    <template>
  <!-- <div class=""> -->

  <div class="wrapper">
    <div class="">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 col-md-10 col-xl-10">
          <div class="formWizard row proccess-wizard " style="margin-bottom:7rem; margin-top:7rem;">
            <div class="wizard-hold">
              <div class="row">
                <div class="col-md-5 mobileorder1 p-3 rounded" v-if="requestJson">
                  <!-- <button class="btn d-flex gap-2 align-items-center px-0 mb-3" @click="backToQuotes()" v-if="currentTab && currentTab=='proposerDetails' && !isShow">
                            <img src="/images/backarrow.svg" width="12px" class="selectrtosvg" />
                          <span class="backtoprevious" style="">Back To Previous</span></button> -->
                  <ProductDetailsHeader :reviewData="reviewDataHeader" :quoteRequest="this.requestJson" />

                </div>
                <div class="col-md-7 mobileorder2">
                  <div class="proposal_form-content">
                    <ul class="nav nav-tabs wizard-step px-2 rounded" id="myTab" role="tablist">
                      <template v-for="(data, ind) in proposalJson.fieldGroups" :key="ind">
                        <template v-if="ind !='traceInfo' && ind != 'distributor'">
                          <li class="nav-item" role="presentation" v-if="!data.visibility ? true : checkVisibility(data.visibility)">
                            <button :class="'nav-link ' + activePage(ind)" :id="'step' + ind + '-tab'" data-bs-toggle="tab" :data-bs-target="'#step' + ind" type="button" role="tab" :aria-controls="'step' + ind" aria-selected="true">
                              <div class="d-flex gap-2 align-items-center">
                                <div class="cir">
                                  <img src="../../assets/images/usericon.svg" class="usersvg" />

                                  <span class="pi pi-check" aria-hidden="true"></span>
                                </div>
                                <span class="txt">{{
                                      checkArray(data) ? data[0].label : data.label
                                    }}</span>
                              </div>

                            </button>
                          </li>
                        </template>
                      </template>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                      <div :class="'tab-pane fade ' + isTabContentActive(ind)" v-for="(data, ind) in proposalJson.fieldGroups" :key="ind" :id="'step' + ind" role="tabpanel" :aria-labelledby="'step' + ind">
                        <div class="tab-body" v-if="ind !='traceInfo' && ind != 'distributor'">
                          <!--Proposer detail form step1-->
                          <div class="floating-form card application-section">
                            <h4 class="title_subtitle text-start">
                              <!-- Let's start with -->
                              {{
                                  checkArray(data)
                                  ? data[0].description
                                  : data.description
                                }}
                            </h4>
                            <!-- <span class="base-reg">{{ data.description }}</span> -->
                            <div class="form-wrapper">
                              <form @submit.prevent="submitForm(ind)" method="post">
                                <!-- <h5 class="mb-3">{{ data.label }}</h5> -->
                                <div v-if="checkArray(data)">
                                  <div class="row" v-for="(value2, ind2) in data" :key="ind2">
                                    <!-- <h5 class="members-wrapper">
                                        {{ value2.label }}
                                        <span v-if="value2.relation">&nbsp;{{ value2?.relation }} Details </span>
                                      </h5> -->
                                    <!-- if fields are available -->
                                    <template v-for="(value3, ind3) in value2.fields" :key="ind3">
                                      <div :class="getColSize(value3.type, ind, ind2)" v-if="!value3.visibility ? true : checkVisibility(value3.visibility)">
                                        <div v-if="value3.type == 'text'">
                                          <!-- Text Field -->
                                          <div class="floating-label">
                                            <input class="floating-input" type="text" :ph="value3.label" :name="value3.name" :placeholder="value3.label" :id="value3.id" :min="value3.min" :max="value3.max" :disabled="(value3.mandatory == 2 || value3.mandatory == 3)" v-model.trim="formInfo.fieldGroups[ind][ind2].fields[ind3].input" @keyup="getValidation($event, value3.name, value3.id, ind, ind2, ind3)" />

                                            <span class="error-msg" :id="'error_' + value3.id"></span>
                                          </div>
                                        </div>
                                        <!-- Number Field -->
                                        <div v-if="value3.type == 'number'" :class="getColSize(value3.type, ind, ind2)">
                                          <label>
                                            {{ value3.label }}
                                            <text v-if="
                                                  value3.mandatory == '1' ||
                                                  value3.mandatory == '2'
                                                " class="mandatory-mark">*</text>
                                          </label>
                                          <div class="floating-label">
                                            <input class="floating-input" type="number" :ph="value3.label" :name="value3.name" :placeholder="value3.label" :id="value3.id" :disabled="value2?.relation =='Self' && (value3.mandatory == 2 || value3.mandatory == 3)" v-model.trim="
                                                formInfo.fieldGroups[ind][ind2].fields[ind3].input" @keyup="getValidation($event, value3.name, value3.id, ind, ind2, ind3)" />

                                            <span class="error-msg" :id="'error_' + value3.id">{{ value3.label }}</span>
                                          </div>
                                        </div>
                                        <!-- Date Field -->
                                        <div v-if="value3.type == 'date'" :class="getColSize(value3.type, ind, ind2)">
                                          <label>
                                            {{ value3.label }}
                                            <text v-if="
                                                  value3.mandatory == '1' ||
                                                  value3.mandatory == '2'
                                                " class="mandatory-mark">*</text>
                                          </label>
                                          <div class="floating-label">
                                            <!-- Original single date input -->
                                            <div v-if="!isDateOfBirth(value3.name)" class="position-relative">
                                              <DateField
                                                :id="value3.id"
                                                :name="value3.name"
                                                :max="value3.max"
                                                :min="value3.min"
                                                :disabled="value2?.relation === 'Self' && (value3.mandatory === 2 || value3.mandatory === 3)"
                                                v-model="formInfo.fieldGroups[ind][ind2].fields[ind3].input"
                                                @onInput="($event) => {
                                                  getValidation($event, value3.name, value3.id, ind, ind2, ind3);
                                                  validateYear(ind, formInfo.fieldGroups[ind][ind2].fields[ind3].input);
                                                }"
                                              />
                                            </div>

                                            <!-- Special handling for Date of Birth with separate DD/MM/YYYY fields -->
                                            <div v-else class="date-input-wrapper">
                                              <!-- Day input -->
                                              <input type="number" class="form-control date-input-field" placeholder="DD" :disabled="value2?.relation =='Self' && (value3.mandatory == 2 || value3.mandatory == 3)" :min="1" :max="31" :value="getDateParts(formInfo.fieldGroups[ind][ind2].fields[ind3].input).day" @input="handleDateDayChange($event, 'fieldGroups.'+ind+'.'+ind2+'.fields.'+ind3+'.input')" @blur="getValidation($event, value3.name, value3.id, ind, ind2, ind3)" />
                                              <span class="date-separator">/</span>

                                              <!-- Month input -->
                                              <input type="number" class="form-control date-input-field" placeholder="MM" :disabled="value2?.relation =='Self' && (value3.mandatory == 2 || value3.mandatory == 3)" :min="1" :max="12" :value="getDateParts(formInfo.fieldGroups[ind][ind2].fields[ind3].input).month" @input="handleDateMonthChange($event, 'fieldGroups.'+ind+'.'+ind2+'.fields.'+ind3+'.input')" @blur="getValidation($event, value3.name, value3.id, ind, ind2, ind3)" />
                                              <span class="date-separator">/</span>

                                              <!-- Year input -->
                                              <input type="number" class="form-control date-input-field year-input" placeholder="YYYY" :disabled="value2?.relation =='Self' && (value3.mandatory == 2 || value3.mandatory == 3)" :min="1900" :max="2100" :value="getDateParts(formInfo.fieldGroups[ind][ind2].fields[ind3].input).year" @input="handleDateYearChange($event, 'fieldGroups.'+ind+'.'+ind2+'.fields.'+ind3+'.input')" @blur="getValidation($event, value3.name, value3.id, ind, ind2, ind3) + validateYear(ind, formInfo.fieldGroups[ind][ind2].fields[ind3].input)" />
                                            </div>

                                            <span class="error-msg" :id="'error_' + value3.id"></span>
                                          </div>
                                        </div>
                                        <!-- Single Select Field -->
                                        <div v-if="value3.type == 'single-select'" :class="getColSize(value3.type, ind, ind2)">
                                          <div class="floating-label">
                                            <label>
                                              {{ value3.label }}
                                              <text v-if="
                                                  value3.mandatory == '1' ||
                                                  value3.mandatory == '2'
                                                " class="mandatory-mark">*</text>
                                            </label>
                                            <div class="position-relative">
                                              <select class="floating-select format" :name="value3.name" :id="value3.id" :disabled="value2?.relation =='Self' && (value3.mandatory == 2 || value3.mandatory == 3)" v-model.trim="
                                                  formInfo.fieldGroups[ind][ind2].fields[ind3].input" @change="getValidation($event, value3.name, value3.id, ind, ind2, ind3)">
                                                <option value="" :disabled="value3.mandatory == 2 || value3.mandatory == 3">SELECT</option>
                                                <option :value="item.Value" v-for="(item, ind3) in sortDropDown(
                                                  value3.value
                                                )" :key="ind3">
                                                  {{ item.Text }}
                                                </option>
                                              </select>
                                              <img src="/images/downarrow.svg" class="downarrowimage">
                                            </div>

                                            <span class="error-msg" :id="'error_' + value3.id"></span>
                                          </div>
                                        </div>
                                        <!-- Multi Select Field -->
                                        <div v-if="value3.type == 'multi-select'" :class="getColSize(value3.type, ind, ind2)">
                                          <label>
                                            {{ value3.label }}
                                            <text v-if="
                                                  value3.mandatory == '1' ||
                                                  value3.mandatory == '2'
                                                " class="mandatory-mark">*</text>
                                          </label>
                                          <div class="floating-label">
                                            <div class="position-relative">
                                              <select class="floating-select format" :name="value3.name" :id="value3.id" :disabled="value2?.relation =='Self' && (value3.mandatory == 2 || value3.mandatory == 3)" v-model.trim="
                                                  formInfo.fieldGroups[ind][ind2].fields[ind3].input" @change="getValidation($event, value3.name, value3.id, ind, ind2, ind3)">
                                                <option value="" :disabled="value3.mandatory == 2 || value3.mandatory == 3">SELECT</option>
                                                <option :value="item.Value" v-for="(item, ind3) in sortDropDown(
                                                  value3.value
                                                )" :key="ind3">
                                                  {{ item.Text }}
                                                </option>
                                              </select>
                                              <img src="/images/downarrow.svg" class="downarrowimage">
                                            </div>
                                            <span class="error-msg" :id="'error_' + value3.id"></span>
                                          </div>
                                        </div>
                                        <!-- Static Field -->
                                        <div v-if="value3.type == 'static'">
                                          <div class="reverse-col mb-3">
                                            <label for="email" class="form-item-label">
                                              {{
                                                    value3.label
                                                }}
                                            </label>
                                          </div>
                                        </div>
                                        <!-- Radio Button Field -->
                                        <div v-if="value3.type == 'boolean'" :class="getColSize(value3.type, ind, ind2)" :id="value3.id">
                                          <div class="d-flex align-items-center mb-3">
                                            <h5 class="label_radio_align">
                                              {{ value3.label }}
                                              <text v-if="
                                                  value3.mandatory == '1' ||
                                                  value3.mandatory == '2'
                                                " class="mandatory-mark">*</text>
                                            </h5>
                                            <div class="radio-btn-grp d-flex gap-4">
                                              <div class="radio-btn-wrap">
                                                <input type="radio" :id="value3.id + '1'" :name="value3.level" v-model.trim="
                                                    formInfo.fieldGroups[ind][ind2].fields[ind3].input" v-bind:value="'1'" :disabled="value2?.relation =='Self' && (value3.mandatory == 2 || value3.mandatory == 3)" @click="getValidation($event, value3.name, value3.id, ind, ind2, ind3)" />
                                                <label :for="value3.id + '1'" class="radio-label">YES</label>
                                              </div>
                                              <div class="radio-btn-wrap">
                                                <input type="radio" :id="value3.id + '2'" name="value3.level" v-model.trim="
                                                    formInfo.fieldGroups[ind][ind2].fields[ind3].input" v-bind:value="'0'" :disabled="value2?.relation =='Self' && (value3.mandatory == 2 || value3.mandatory == 3)" @click="getValidation($event, value3.name, value3.id, ind, ind2, ind3)" />
                                                <label :for="value3.id + '2'" class="radio-label">NO</label>
                                              </div>
                                            </div>
                                          </div>
                                          <span class="error-msg" :id="'error_' + value3.id"></span>
                                        </div>
                                      </div>
                                    </template>
                                    <!-- if fieldGroups are available -->
                                    <template v-for="(value3, ind3) in value2.fieldGroups" :key="ind3">
                                      <!-- <h5 class="mb-3 pt-2">{{ value3.label }}</h5> -->
                                      <h5 class="mb-3">{{ value2?.relation }} Details</h5>
                                      <template v-for="(value4, ind4) in value3.fields" :key="ind4">
                                        <div :class="getColSize(value4.type, ind, ind2, ind3)" v-if="!value4.visibility ? true : checkVisibility(value4.visibility)">
                                          <div v-if="value4.type == 'text'">
                                            <!-- Text Field -->
                                            <div class="floating-label">
                                              <label>{{ value4.label }}
                                                <text v-if="
                                                    value4.mandatory == '1' ||
                                                    value4.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>
                                              <input class="floating-input" type="text" :ph="value4.label" :name="value4.name" :placeholder="value4.label" :id="value4.id + ind2" :min="value4.min" :max="value4.max" :disabled="(value4.mandatory == 2 || value4.mandatory == 3)" v-model.trim="formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input" @keyup="getValidation($event, value4.name, value4.id, ind, ind2, ind3)" />

                                              <span class="error-msg" :id="'error_' + value4.id + ind2"></span>
                                            </div>
                                          </div>
                                          <!-- Number Field -->
                                          <div v-if="value4.type == 'number'">
                                            <div class="floating-label">
                                              <label>
                                                {{ value4.label }}
                                                <text v-if="
                                                    value4.mandatory == '1' ||
                                                    value4.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>
                                              <input class="floating-input" type="number" :ph="value4.label" :name="value4.name" :placeholder="value4.label" :id="value4.id + ind2" :disabled="value2?.relation =='Self' && (value4.mandatory == 2 || value4.mandatory == 3)" v-model.trim="
                                                  formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input" @keyup="getValidation($event, value4.name, value4.id, ind, ind2, ind3)" />

                                              <span class="error-msg" :id="'error_' + value4.id + ind2"></span>
                                            </div>
                                          </div>
                                          <!-- Date Field -->
                                          <div v-if="value4.type == 'date'">
                                            <div class="floating-label">
                                              <label>
                                                {{ value4.label }}
                                                <text v-if="
                                                    value4.mandatory == '1' ||
                                                    value4.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>

                                              <!-- Original single date input -->
                                              <div v-if="!isDateOfBirth(value4.name)" class="position-relative">
                                                  <DateField
                                                    :id="value4.id + ind2"
                                                    :name="value4.name"
                                                    :max="value4.max"
                                                    :min="value4.min"
                                                    :disabled="value2?.relation === 'Self' && (value4.mandatory === 2 || value4.mandatory === 3)"
                                                    v-model="formInfo.fieldGroups[ind][ind2].fieldGroups[ind3].fields[ind4].input"
                                                    @onInput="($event) => {
                                                      getValidation($event, value4.name, value4.id, ind, ind2, ind3);
                                                      validateYear(ind, formInfo.fieldGroups[ind][ind2].fieldGroups[ind3].fields[ind4].input);
                                                    }"
                                                  />
                                              </div>

                                              <!-- Special handling for Date of Birth with separate DD/MM/YYYY fields -->
                                              <div v-else class="date-input-wrapper">
                                                <!-- Day input -->
                                                <input type="number" class="form-control date-input-field" placeholder="DD" :disabled="value2?.relation =='Self' && (value4.mandatory == 2 || value4.mandatory == 3)" :min="1" :max="31" :value="getDateParts(formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input).day" @input="handleDateDayChange($event, 'fieldGroups.'+ind+'.'+ind2+'.fieldGroups.'+ind3+'.fields.'+ind4+'.input')" @blur="getValidation($event, value4.name, value4.id, ind, ind2, ind3)" />
                                                <span class="date-separator">/</span>

                                                <!-- Month input -->
                                                <input type="number" class="form-control date-input-field" placeholder="MM" :disabled="value2?.relation =='Self' && (value4.mandatory == 2 || value4.mandatory == 3)" :min="1" :max="12" :value="getDateParts(formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input).month" @input="handleDateMonthChange($event, 'fieldGroups.'+ind+'.'+ind2+'.fieldGroups.'+ind3+'.fields.'+ind4+'.input')" @blur="getValidation($event, value4.name, value4.id, ind, ind2, ind3)" />
                                                <span class="date-separator">/</span>

                                                <!-- Year input -->
                                                <input type="number" class="form-control date-input-field year-input" placeholder="YYYY" :disabled="value2?.relation =='Self' && (value4.mandatory == 2 || value4.mandatory == 3)" :min="1900" :max="2100" :value="getDateParts(formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input).year" @input="handleDateYearChange($event, 'fieldGroups.'+ind+'.'+ind2+'.fieldGroups.'+ind3+'.fields.'+ind4+'.input')" @blur="getValidation($event, value4.name, value4.id, ind, ind2, ind3) + validateYear(ind, formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input)" />
                                              </div>

                                              <span class="error-msg" :id="'error_' + value4.id + ind2"></span>
                                            </div>
                                          </div>
                                          <!-- Single Select Field -->
                                          <div v-if="value4.type == 'single-select'">
                                            <div class="floating-label">
                                              <label>
                                                {{ value4.label }}
                                                <text v-if="
                                                    value4.mandatory == '1' ||
                                                    value4.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>
                                              <div class="position-relative">
                                                <select class="floating-select format" :name="value4.name" :id="value4.id + ind2" :disabled="value2?.relation =='Self' && (value4.mandatory == 2 || value4.mandatory == 3)" v-model.trim="
                                                  formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input" @change="getValidation($event, value4.name, value4.id, ind, ind2, ind3)">
                                                  <option value="" :disabled="value4.id=='2524' || value4.id=='2533'">SELECT</option>
                                                  <option :value="item.Value" v-for="(item, ind5) in sortDropDown(
                                                    value4.value
                                                  )" :key="ind5" :disabled="value4.id=='2524' || value4.id=='2533'">
                                                    {{ item.Text }}
                                                  </option>
                                                </select>
                                                <img src="/images/downarrow.svg" class="downarrowimage">
                                              </div>

                                              <span class="error-msg" :id="'error_' + value4.id + ind2"></span>
                                            </div>
                                          </div>
                                          <!-- Multi Select Field -->
                                          <div v-if="value4.type == 'multi-select'">
                                            <div class="floating-label">
                                              <label>
                                                {{ value4.label }}
                                                <text v-if="
                                                    value4.mandatory == '1' ||
                                                    value4.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>
                                              <div class="position-relative">
                                                <select class="floating-select format" :name="value4.name" :id="value4.id + ind2" :disabled="value2?.relation =='Self' && (value4.mandatory == 2 || value4.mandatory == 3)" v-model.trim="
                                                  formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input" @change="getValidation($event, value4.name, value4.id, ind, ind2, ind3)">
                                                  <option value="" :disabled="value4.mandatory == 2 || value4.mandatory == 3">SELECT</option>
                                                  <option :value="item.Value" v-for="(item, ind5) in sortDropDown(
                                                    value4.value
                                                  )" :key="ind5">
                                                    {{ item.Text }}
                                                  </option>
                                                </select>
                                                <img src="/images/downarrow.svg" class="downarrowimage">
                                              </div>
                                              <span class="error-msg" :id="'error_' + value4.id + ind2"></span>
                                            </div>
                                          </div>
                                          <!-- Static Field -->
                                          <div v-if="value4.type == 'static'">
                                            <div class="reverse-col mb-3">

                                            </div>
                                          </div>
                                          <!-- Radio Button Field -->
                                          <div v-if="value4.type == 'boolean'" :id="value4.id">
                                            <div class="d-flex align-items-center mb-3">
                                              <h5 class="label_radio_align">
                                                {{ value4.label }}
                                                <text v-if="
                                                    value4.mandatory == '1' ||
                                                    value4.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </h5>
                                              <div class="radio-btn-grp d-flex gap-4">
                                                <div class="radio-btn-wrap">
                                                  <input type="radio" :id="value4.id + '1' + ind2" :name="value4.level" v-model.trim="
                                                      formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input" v-bind:value="'1'" :disabled="value2?.relation =='Self' && (value4.mandatory == 2 || value4.mandatory == 3)" @click="getValidation($event, value4.name, value4.id, ind, ind2, ind3)" />
                                                  <label :for="value4.id + '1' + ind2" class="radio-label">YES</label>
                                                </div>
                                                <div class="radio-btn-wrap">
                                                  <input type="radio" :id="value4.id + '2' + ind2" :name="value4.level" v-model.trim="
                                                      formInfo.fieldGroups[ind][ind2]['fieldGroups'][ind3].fields[ind4].input" v-bind:value="'0'" :disabled="value2?.relation =='Self' && (value4.mandatory == 2 || value4.mandatory == 3)" @click="getValidation($event, value4.name, value4.id, ind, ind2, ind3)" />
                                                  <label :for="value4.id + '2' + ind2" class="radio-label">NO</label>
                                                </div>
                                              </div>
                                            </div>
                                            <span class="error-msg" :id="'error_' + value4.id + ind2"></span>
                                          </div>
                                        </div>
                                      </template>
                                    </template>
                                  </div>
                                </div>
                                <div v-else>
                                  <div class="health-questions" v-if="ind == 'healthQuestions'">

                                    <span class="mid-heading mt-3">
                                      Medical Questions for
                                      <template v-for="(insMember, insInd) in this.formInfo?.fieldGroups?.insuredMembers">
                                        {{getTrim(insMember.fieldGroups?.insuredMemberPersonalDetails?.fields?.firstName?.input)}}
                                        {{getTrim(insMember.fieldGroups?.insuredMemberPersonalDetails?.fields?.middleName?.input)}}
                                        {{getTrim(insMember.fieldGroups?.insuredMemberPersonalDetails?.fields?.lastName?.input)}}{{(this.formInfo?.fieldGroups?.insuredMembers[insInd+1])?', ':''}}
                                      </template>
                                    </span>

                                    <!-- if fields are available -->
                                    <div class="row question-wrapper" v-if="data.fields">
                                      <template v-for="(value2, ind2) in data.fields" :key="ind2">
                                        <h4 :class="(value2.visibility)?' sub-questions':' main-questions'" v-if="
                                            !value2.visibility
                                              ? true
                                              : checkVisibility(
                                                getVisitibilityExpIndexZero(
                                                  value2.visibility
                                                )
                                              )
                                          ">
                                          <div class="sub-question-wrapper">
                                            <label>
                                              <span v-if="!value2.visibility">Q.</span> {{ value2.label }}
                                              <text v-if="
                                                value2.mandatory == '1' ||
                                                value2.mandatory == '2'
                                              " class="mandatory-mark">*</text>
                                            </label>
                                          </div>
                                        </h4>
                                        <template v-if="value2.type != 'static'">

                                          <template v-if="value2.type == 'boolean' && !value2.visibility">
                                            <h5 class="none-option" :class="getNoneOfMembersClass(value2.id, ind, ind2)">
                                              <div class="custom-checkbox">
                                                <input type="checkbox" :id="value2.id" v-on:click="setNoneOfFamilyMember(value2.id, ind, ind2)" :checked="getVisibleClass(value2.id, ind, ind2)">
                                                <label :for="value2.id">None of the family members </label>
                                              </div>
                                            </h5>
                                          </template>

                                          <!--  jjjkkkkkkkkk -->
                                          <!-- + (getVisibleClass(value2.id, ind, ind2)?' d-none ':'') -->
                                          <!-- <template :class="value2.id+'_section '" v-for="(value3, ind3) in selectedMembersList" :key="ind3">  -->
                                          <div :id="value2.id+'_section'" :class="((value2.visibility)?' sub-questions ':' main-questions ')">
                                            <template v-for="(value3, ind3) in this.formInfo?.fieldGroups?.insuredMembers.length" :key="ind3">
                                              <!-- <span v-if="value2.visibility">{{ getVisitibilityExp(value2.visibility, ind3) }}</span> -->
                                              <div :class="getColSize(value2.type, ind, ind2)" v-if="!value2.visibility? true: checkVisibility( getVisitibilityExp(value2.visibility, ind3))">
                                                <div v-if="value2.type == 'text'">
                                                  <div class="floating-label">
                                                    <label>

                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.firstName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.middleName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.lastName?.input }}
                                                      <text v-if="
                                                          value2.mandatory == '1' ||
                                                          value2.mandatory == '2'
                                                        " class="mandatory-mark"></text>
                                                    </label>
                                                    <input class="floating-input" type="text" :ph="value2.label" :placeholder="value2.label" :name="value2.name" :id="value2.id" :min="value2.min" :max="value2.max" :disabled="value2.mandatory == 2 || value2.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input[ind3].answer" @keyup="getValidation($event, value2.name, value2.id, ind, ind2, ind3)" />

                                                    <span class="error-msg" :id="'error_' + value2.id + '_' + ind3"></span>
                                                  </div>
                                                </div>
                                                <!-- Number Field -->
                                                <div v-if="value2.type == 'number'">
                                                  <div class="floating-label">
                                                    <label>

                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.firstName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.middleName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.lastName?.input }}
                                                      <text v-if="
                                                         value2.mandatory == '1' ||
                                                         value2.mandatory == '2'
                                                       " class="mandatory-mark"></text>
                                                    </label>
                                                    <input class="floating-input" type="number" :ph="value2.label" :placeholder="value4.label" :name="value2.name" :id="value2.id" :disabled="value2.mandatory == 2 || value2.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input[ind3].answer" @keyup="getValidation($event, value2.name, value2.id, ind, ind2, ind3)" />

                                                    <span class="error-msg" :id="'error_' + value2.id + '_' + ind3"></span>
                                                  </div>
                                                </div>
                                                <!-- Date Field -->
                                                <div v-if="value2.type == 'date'">
                                                  <div class="floating-label">
                                                    <label>

                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.firstName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.middleName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.lastName?.input }}
                                                      <text v-if="
                                                          value2.mandatory == '1' ||
                                                          value2.mandatory == '2'
                                                        " class="mandatory-mark"></text>
                                                    </label>
                                                    <div class="position-relative">
                                                        <DateField
                                                          :id="value2.id"
                                                          :name="value2.name"
                                                          :max="value2.max"
                                                          :min="value2.min"
                                                          :disabled="value2.mandatory === 2 || value2.mandatory === 3"
                                                          v-model="formInfo.fieldGroups[ind].fields[ind2].input[ind3].answer"
                                                          @onInput="($event) => {
                                                            getValidation($event, value2.name, value2.id, ind, ind2, ind3);
                                                            validateYear(ind, formInfo.fieldGroups[ind].fields[ind2].input[ind3].answer);
                                                          }"
                                                        />
                                                    </div>
                                                    <span class="error-msg" :id="'error_' + value2.id + '_' + ind3"></span>
                                                  </div>
                                                </div>
                                                <!-- Single Select Field -->
                                                <div v-if="value2.type == 'single-select'">
                                                  <div class="floating-label">
                                                    <label>
                                                      <!-- {{ value3.member }} -->
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.firstName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.middleName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.lastName?.input }}
                                                      <text v-if="
                                                          value2.mandatory == '1' ||
                                                          value2.mandatory == '2'
                                                        " class="mandatory-mark"></text>
                                                    </label>
                                                    <div class="position-relative">
                                                      <select class="floating-select format" :name="value2.name" :id="value2.id" :disabled="value2.mandatory == 2 || value2.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input[ind3].answer" @change="getValidation($event, value2.name, value2.id, ind, ind2, ind3)">
                                                        <option value="" :disabled="value2.mandatory == 2 || value2.mandatory == 3">SELECT</option>
                                                        <option :value="item.Value" v-for="(item, ind3) in sortDropDown(value2.value)" :key="ind3">
                                                          {{ item.Text }}
                                                        </option>
                                                      </select>
                                                      <img src="/images/downarrow.svg" class="downarrowimage">
                                                    </div>
                                                    <span class="error-msg" :id="'error_' + value2.id + '_' + ind3"></span>
                                                  </div>
                                                </div>
                                                <!-- Multi Select Field -->
                                                <div v-if="value2.type == 'multi-select'">
                                                  <div class="floating-label">
                                                    <label>
                                                      <!-- {{ value3.member }} -->
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.firstName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.middleName?.input }}
                                                      {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.lastName?.input }}
                                                      <text v-if="
                                                          value2.mandatory == '1' ||
                                                          value2.mandatory == '2'
                                                        " class="mandatory-mark"></text>
                                                    </label>
                                                    <div class="position-relative">
                                                      <select class="floating-select format" :name="value2.name" :id="value2.id" :disabled="value2.mandatory == 2 || value2.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input[ind3].answer" @change="getValidation($event, value2.name, value2.id, ind, ind2, ind3)">
                                                        <option value="" :disabled="value2.mandatory == 2 || value2.mandatory == 3">SELECT</option>
                                                        <option :value="item.Value" v-for="(item, ind3) in sortDropDown(value2.value)" :key="ind3">
                                                          {{ item.Text }}
                                                        </option>
                                                      </select>
                                                      <img src="/images/downarrow.svg" class="downarrowimage">
                                                    </div>
                                                    <span class="error-msg" :id="'error_' + value2.id + '_' + ind3"></span>
                                                  </div>
                                                </div>
                                                <!-- Static Field -->
                                                <div v-if="value2.type == 'static'">
                                                  <div class="reverse-col mb-3">
                                                  </div>
                                                </div>
                                                <!-- Radio Button Field -->
                                                <div v-if="value2.type == 'boolean'" :id="value2.id" class="member mb-1">
                                                  <div class="d-flex align-items-center">

                                                    <h5 class="label_radio_align">
                                                      <label>
                                                        <!-- <input type="Checkbox" :id="value2.id + '1' + ind3" v-on:click="setCheckboxValue(value2.id + '1' + ind3, ind, ind2, ind3)" /> -->
                                                        {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.firstName?.input }}
                                                        {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.middleName?.input }}
                                                        {{ this.formInfo?.fieldGroups?.insuredMembers[ind3].fieldGroups?.insuredMemberPersonalDetails?.fields?.lastName?.input }}
                                                        <!-- {{ value3.member }} -->
                                                        <text v-if="
                                                            value2.mandatory == '1' ||
                                                            value2.mandatory == '2'
                                                          " class="mandatory-mark"></text>
                                                      </label>
                                                    </h5>

                                                    <div class="radio-btn-grp switch-btn d-flex gap-4">
                                                      <div class="radio-btn-wrap">
                                                        <input type="radio" :id="value2.id + '1' + ind3" :name="
                                                            value2.name + '_' + ind3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input[ind3].answer" v-bind:value="'1'" :disabled="value2.mandatory == 2 || value2.mandatory == 3" @click="getValidation($event, value2.name, value2.id, ind, ind2, ind3)" />
                                                        <label :for="value2.id + '1' + ind3" class="radio-label">YES</label>
                                                      </div>
                                                      <div class="radio-btn-wrap">
                                                        <input type="radio" :id="value2.id + '2' + ind3" :name="
                                                            value2.name + '_' + ind3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input[ind3].answer" v-bind:value="'0'" :disabled="value2.mandatory == 2 || value2.mandatory == 3" @click="getValidation($event, value2.name, value2.id, ind, ind2, ind3)" />
                                                        <label :for="value2.id + '2' + ind3" class="radio-label">NO</label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <span class="error-msg" :id="'error_' + value2.id + '_' + ind3"></span>
                                                </div>
                                              </div>
                                            </template>
                                          </div>

                                        </template>
                                      </template>
                                    </div>
                                  </div>
                                  <div v-else class="health-questions-else">
                                    <!-- if fields are available -->
                                    <div class="row" v-if="data.fields">
                                      <template v-for="(value2, ind2) in data.fields" :key="ind2">
                                        <div :class="getColSize(value2.type, ind, ind2)" v-if="!value2.visibility ? true : checkVisibility(value2.visibility)">
                                          <!-- Text Field -->
                                          <div v-if="value2.type == 'text'">
                                            <div class="floating-label">
                                              <label>
                                                {{ value2.label }}
                                                <text v-if="
                                                    value2.mandatory == '1' ||
                                                    value2.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>
                                              <input class="floating-input" type="text" :ph="value2.label" :name="value2.name" :placeholder="value2.label" :id="value2.id" :min="value2.min" :max="value2.max" :disabled="value2.mandatory == 2 || value2.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input" @keyup="getValidation($event, value2.name, value2.id, ind, ind2)" />

                                              <span class="error-msg" :id="'error_' + value2.id"></span>
                                            </div>
                                          </div>
                                          <!-- Number Field -->
                                          <div v-if="value2.type == 'number'">
                                            <div class="floating-label">
                                              <label>
                                                {{ value2.label }}
                                                <text v-if="
                                                    value2.mandatory == '1' ||
                                                    value2.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>
                                              <input class="floating-input" type="number" :ph="value2.label" :name="value2.name" :placeholder="value2.label" :id="value2.id" :disabled="value2.mandatory == 2 || value2.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input" @keyup="getValidation($event, value2.name, value2.id, ind, ind2)" />

                                              <span class="error-msg" :id="'error_' + value2.id"></span>
                                            </div>
                                          </div>
                                          <!-- Date Field -->
                                          <div v-if="value2.type == 'date'">
                                            <div class="floating-label">
                                              <label>
                                                {{ value2.label }}
                                                <text v-if="
                                                    value2.mandatory == '1' ||
                                                    value2.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>
                                              <div class="position-relative">
                                                <DateField
                                                  :id="value2.id"
                                                  :name="value2.name"
                                                  :max="selectMaxDate(data, value2)"
                                                  :min="selectMinDate(data, value2)"
                                                  :disabled="value2.mandatory === 2 || value2.mandatory === 3"
                                                  v-model="formInfo.fieldGroups[ind].fields[ind2].input"
                                                  @onInput="($event) => {
                                                    getValidation($event, value2.name, value2.id, ind, ind2);
                                                    validateYear(ind, formInfo.fieldGroups[ind].fields[ind2].input);
                                                  }"
                                                />
                                                <!-- <img src="/images/date.svg" class="downarrowimage">
                                                <span class="data-placeholder" @click="openDatePicker(value2.id)" v-if="isMobileView() && !formInfo.fieldGroups[ind].fields[ind2].input">dd-mm-yyyy</span> -->
                                              </div>
                                              <span class="error-msg" :id="'error_' + value2.id"></span>
                                            </div>
                                          </div>
                                          <!-- Single Select Field -->
                                          <div v-if="value2.type == 'single-select'">
                                            <div class="floating-label">
                                              <label>
                                                {{ value2.label }}
                                                <text v-if="
                                                    value2.mandatory == '1' ||
                                                    value2.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>
                                              <div class="position-relative">
                                                <select class="floating-select format" :name="value2.name" :id="value2.id" :disabled="value2.mandatory == 2 || value2.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input" @change="getValidation($event, value2.name, value2.id, ind, ind2)">
                                                  <option value="" :disabled="value2.mandatory == 2 || value2.mandatory == 3">SELECT</option>
                                                  <option :value="item.Value" v-for="(item, ind3) in sortDropDown(
                                                    value2.value
                                                  )" :key="ind3">
                                                    {{ value2.name=='nomineeRelationWithProposer' ? (item.Text).toUpperCase() : item.Text }}
                                                  </option>
                                                </select>
                                                <img src="/images/downarrow.svg" class="downarrowimage">
                                              </div>
                                              <span class="error-msg" :id="'error_' + value2.id"></span>
                                            </div>
                                          </div>
                                          <!-- Multi Select Field -->
                                          <div v-if="value2.type == 'multi-select'">
                                            <div class="floating-label">
                                              <label>
                                                {{ value2.label }}
                                                <text v-if="
                                                    value2.mandatory == '1' ||
                                                    value2.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </label>
                                              <div class="position-relative">
                                                <select class="floating-select format" :name="value2.name" :id="value2.id" :disabled="value2.mandatory == 2 || value2.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input" @change="getValidation($event, value2.name, value2.id, ind, ind2)">
                                                  <option value="" :disabled="value2.mandatory == 2 || value2.mandatory == 3">SELECT</option>
                                                  <option :value="item.Value" v-for="(item, ind3) in sortDropDown(
                                                    value2.value
                                                  )" :key="ind3">
                                                    {{ item.Text }}
                                                  </option>
                                                </select>
                                                <img src="/images/downarrow.svg" class="downarrowimage">
                                              </div>
                                              <span class="error-msg" :id="'error_' + value2.id"></span>
                                            </div>
                                          </div>
                                          <!-- Static Field -->
                                          <div v-if="value2.type == 'static'">
                                            <div class="reverse-col mb-3">
                                            </div>
                                          </div>
                                          <!-- Radio Button Field -->
                                          <div v-if="value2.type == 'boolean'" :id="value2.id">
                                            <div class="d-flex align-items-center mb-3">
                                              <h5 class="label_radio_align">
                                                {{ value2.label }}
                                                <text v-if="
                                                    value2.mandatory == '1' ||
                                                    value2.mandatory == '2'
                                                  " class="mandatory-mark">*</text>
                                              </h5>
                                              <div class="radio-btn-grp d-flex gap-4">
                                                <div class="radio-btn-wrap">
                                                  <input type="radio" :id="value2.id + '1'" :name="value2.name" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input" v-bind:value="'1'" :disabled="value2.mandatory == 2 || value2.mandatory == 3" @click="getValidation($event, value2.name, value2.id, ind, ind2)" />
                                                  <label :for="value2.id + '1'" class="radio-label">YES</label>
                                                </div>
                                                <div class="radio-btn-wrap">
                                                  <input type="radio" :id="value2.id + '2'" :name="value2.name" v-model.trim="formInfo.fieldGroups[ind].fields[ind2].input" v-bind:value="'0'" :disabled="value2.mandatory == 2 || value2.mandatory == 3" @click="getValidation($event, value2.name, value2.id, ind, ind2)" />
                                                  <label :for="value2.id + '2'" class="radio-label">NO</label>
                                                </div>
                                              </div>
                                            </div>
                                            <span class="error-msg" :id="'error_' + value2.id"></span>
                                          </div>
                                        </div>
                                      </template>
                                    </div>
                                    <!-- if fieldGroups are available -->
                                    <template v-for="(value2, ind2) in data.fieldGroups" :key="ind2">
                                      <div v-if="!value2.visibility? true: checkVisibility(value2.visibility)">
                                        <h5 class="mb-3" v-if="Object.values(value2.fields).length > 0 && Object.values(value2.fields).some(value3 => !value3.visibility || checkVisibility(value3.visibility))">{{ value2.label }}</h5>
                                        <div class="row">
                                          <template v-for="(value3, ind3) in value2.fields" :key="ind3">
                                            <div :class="getColSize(value3.type, ind, ind2, ind3, value3)" v-if="!value3.visibility ? true : checkVisibility(value3.visibility)">
                                              <!-- Text Field -->
                                              <div v-if="value3.type == 'text'">
                                                <!-- Skip rendering the rtoCode field individually as it's shown with vehicleNumber -->
                                                <template v-if="value3.name === 'rtoCode'">
                                                  <!-- Hide this field as it will be rendered with vehicleNumber -->
                                                  <div class="floating-label" v-if="quoteCategory=='New'">
                                                    <div class="floating-label">
                                                      <div class="d-flex flex-column">
                                                        <label>
                                                          Registration Number
                                                          <text v-if="
                                                              value3.mandatory == '1' ||
                                                              value3.mandatory == '2'
                                                            " class="mandatory-mark">*</text>
                                                        </label>
                                                        <div class="col-lg-12">
                                                          <div class="row px-3">
                                                            <div class="col-6 px-0">
                                                              <div class="registration-code-field">
                                                                <input class="text-center floating-input" type="text" placeholder="MH-01" id="rto-code" :value="Object.values(formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields).find(f => f.name === 'rtoCode')?.input" disabled @keyup="getValidation($event, 'rtoCode', 'rto-code', ind, ind2)" />
                                                              </div>
                                                            </div>
                                                            <div class="col-6 px-0">
                                                              <div class="vehicle-number-field">
                                                                <input type="text" :ph="value3.label" :name="value3.name" :placeholder="value3.label" :id="value3.id" :min="value3.min" :max="value3.max" class="floating-input" style="text-transform: uppercase" :disabled="value3.mandatory == 2 || value3.mandatory == 3" value="New" @keyup="getValidation($event, value3.name, value3.id, ind, ind2)" />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div class="d-flex">
                                                          <div style="flex: 0 0 60px;">
                                                            <span class="error-msg" :id="'error_rto-code'"></span>
                                                          </div>
                                                          <div style="flex: 1;">
                                                            <span class="error-msg" :id="'error_' + value3.id"></span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </template>
                                                <div class="floating-label" v-else-if="value3.name === 'vehicleNumber'">
                                                  <!-- Special handling for Registration Number - combines RTO Code and Vehicle Number -->
                                                  <div class="d-flex flex-column">
                                                    <label>
                                                      Registration Number
                                                      <text v-if="
                                                          value3.mandatory == '1' ||
                                                          value3.mandatory == '2'
                                                        " class="mandatory-mark">*</text>
                                                    </label>


                                                    <div class="d-flex carregistrationdetails" style="border-radius:5px">
                                                      <div class="registration-code-field">
                                                        <input class="floating-input" type="text" placeholder="MH-01" id="rto-code" :value="Object.values(formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields).find(f => f.name === 'rtoCode')?.input" disabled @keyup="getValidation($event, 'rtoCode', 'rto-code', ind, ind2)" style="width: 60px;" />
                                                      </div>


                                                      <div class="vehicle-number-field">
                                                        <input type="text" :ph="value3.label" :name="value3.name" :placeholder="registrationNumberPlaceHolder()" :id="value3.id" :min="value3.min" :max="value3.max" class="floating-input registration_input" :disabled="value3.mandatory == 2 || value3.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input" @keyup="getValidation($event, value3.name, value3.id, ind, ind2)" />
                                                      </div>
                                                    </div>

                                                    <div class="d-flex">
                                                      <div style="flex: 0 0 60px;">
                                                        <span class="error-msg" :id="'error_rto-code'"></span>
                                                      </div>
                                                      <div style="flex: 1;">
                                                        <span class="error-msg" :id="'error_' + value3.id"></span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <!-- Standard text field for all other fields -->
                                                <div v-else class="floating-label" :class="{'relative-fininciarName': value3.name =='financierName', 'digit_counter': value3.label =='Engine Number' || value3.label =='Chassis Number'}">
                                                  <label>
                                                    {{ value3.label }}
                                                    <text v-if="
                                                        value3.mandatory == '1' ||
                                                        value3.mandatory == '2'
                                                      " class="mandatory-mark">*</text>
                                                  </label>
                                                  <input class="floating-input" type="text" :ph="value3.label" :name="value3.name" :placeholder="(value3.label === 'Engine Number' || value3.label === 'Chassis Number') ? `${value3.label} (Min ${value3.min} - Max ${value3.max})` : (value3.name === 'financierName' ? '3+ letters to search · pick from list' : `${value3.label}`)" :id="value3.id" :min="value3.min" :max="value3.max" :minlength="value3.min" :maxlength="value3.max" :disabled="value3.mandatory == 2 || value3.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input" @keyup="getValidation($event, value3.name, value3.id, ind, ind2, ind3)" @input="getValidation($event, value3.name, value3.id, ind, ind2, ind3)" @change="onFinancierFieldChange(value3.id, ind, ind2, ind3)" @focus="openDropdown(value3.name)" @blur="closeDropdown(value3.name)" autocomplete="off" />
                                                  <text class="digit_count" v-if="value3.label=='Engine Number' || value3.label=='Chassis Number'">{{formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input.length}}/{{ value3.max }}</text>

                                                  <span class="error-msg" :id="'error_' + value3.id"></span>
                                                  <div v-if="loadingBankNames && !this.responsebank.length && value3.name=='financierName'" class="loader-bg p-2 d-flex align-items-center justify-content-center" style="position: absolute; left: 0; right: 0; top: 100%; z-index: 10; min-height: 80px;">
                                                    <img :src="require(`@/assets/images/${imageUrl}`)" alt="" style="width: 100px; height: 100px" />
                                                  </div>
                                                  <div
                                                    v-if="value3.name == 'financierName' && isDropdownOpen && !loadingBankNames && !responsebank.length && (!formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input || String(formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input).trim().length < 3) && !financierSearchReturnedEmpty"
                                                    class="loader-bg dropdown financier-dropdown-hint"
                                                    role="note"
                                                  >
                                                    <span class="financier-dropdown-hint__title">Search banks</span>
                                                    <span class="financier-dropdown-hint__sub">Type 3+ letters, then tap a name.</span>
                                                  </div>
                                                  <ul v-if="(this.responsebank.length && value3.name=='financierName' && this.showBankDropdown==true && isDropdownOpen)" class="loader-bg dropdown p-2">
                                                    <li class="p-1 rounded" v-for="(item, ind3) in responsebank" :key="ind3" @mousedown="selectOption(item)">
                                                      {{ item }}
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                              <!-- Number Field -->
                                              <div v-if="value3.type == 'number'">
                                                <div class="floating-label">
                                                  <label>
                                                    {{ value3.label }}
                                                    <text v-if="
                                                        value3.mandatory == '1' ||
                                                        value3.mandatory == '2'
                                                      " class="mandatory-mark">*</text>
                                                  </label>
                                                  <input class="floating-input" type="number" :ph="value3.label" :placeholder="value3.label" :name="value3.name" :id="value3.id" :disabled="value3.mandatory == 2 || value3.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input" @keyup="getValidation($event, value3.name, value3.id, ind, ind2)" />

                                                  <span class="error-msg" :id="'error_' + value3.id"></span>
                                                </div>
                                              </div>
                                              <!-- Date Field -->
                                              <div v-if="value3.type == 'date'">
                                                <div class="floating-label">
                                                  <label>
                                                    {{ value3.label }}
                                                    <text v-if="
                                                        value3.mandatory == '1' ||
                                                        value3.mandatory == '2'
                                                      " class="mandatory-mark">*</text>
                                                  </label>
                                                  <div class="position-relative">
                                                    <DateField
                                                      :id="value3.id"
                                                      :name="value3.name"
                                                      :min="setMinDateAssociation(value3)"
                                                      :max="dobMaxRange(value2, value3)"
                                                      :disabled="value3.mandatory === 2 || value3.mandatory === 3"
                                                      v-model="formInfo.fieldGroups[ind].fieldGroups[ind2].fields[ind3].input"
                                                      @onInput="($event) => {
                                                        getValidation($event, value3.name, value3.id, ind, ind2);
                                                        validateYear(ind, formInfo.fieldGroups[ind].fieldGroups[ind2].fields[ind3].input);
                                                      }"
                                                    />
                                                  </div>
                                                  <span class="error-msg" :id="'error_' + value3.id"></span>
                                                </div>
                                              </div>
                                              <!-- Single Select Field -->

                                              <div v-if="value3.type == 'single-select'">
                                                <div class="floating-label">
                                                  <label class="selectlabel">
                                                    {{ value3.label }}
                                                    <text v-if="
                                                        value3.mandatory == '1' ||
                                                        value3.mandatory == '2'
                                                      " class="mandatory-mark">*</text>
                                                  </label>
                                                  <div class="position-relative">
                                                    <select class="floating-select format" :name="value3.name" :id="value3.id" :disabled="value3.mandatory == 2 || value3.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input" @change="getValidation($event, value3.name, value3.id, ind, ind2)">
                                                      <option value="" :disabled="value3.id=='2495'">SELECT</option>
                                                      <option :value="item.Value" v-for="(item, ind4) in sortDropDown(value3.value)" :key="ind3" :disabled="value3.id=='2495'" style="padding-right: 20px;">
                                                        {{ item.Text.toUpperCase() }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                      </option>
                                                    </select>
                                                    <img src="/images/downarrow.svg" class="downarrowimage">
                                                  </div>
                                                  <span class="error-msg" :id="'error_' + value3.id"></span>
                                                </div>
                                              </div>
                                              <!-- Multi Select Field -->
                                              <div v-if="value3.type == 'multi-select'">
                                                <div class="floating-label">
                                                  <label>
                                                    {{ value3.label }}
                                                    <text v-if="
                                                        value3.mandatory == '1' ||
                                                        value3.mandatory == '2'
                                                      " class="mandatory-mark">*</text>
                                                  </label>
                                                  <div class="position-relative">
                                                    <select class="floating-select format" :name="value3.name" :id="value3.id" :disabled="value3.mandatory == 2 || value3.mandatory == 3" v-model.trim="formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input" @change="getValidation($event, value3.name, value3.id, ind, ind2)">
                                                      <option value="" :disabled="value3.mandatory == 2 || value3.mandatory == 3">SELECT</option>
                                                      <option :value="item.Value" v-for="(item, ind4) in sortDropDown(value3.value)" :key="ind3">
                                                        {{ item.Text }}
                                                      </option>
                                                    </select>
                                                    <img src="/images/downarrow.svg" class="downarrowimage">
                                                  </div>
                                                  <span class="error-msg" :id="'error_' + value3.id"></span>
                                                </div>
                                              </div>
                                              <!-- Static Field -->
                                              <div v-if="value3.type == 'static'">
                                                <div class="reverse-col mb-3">
                                                  <label for="email" class="form-item-label">
                                                    {{
                                                          value3.label
                                                      }}
                                                  </label>
                                                </div>
                                              </div>
                                              <!-- Radio Button Field -->
                                              <div v-if="value3.type == 'boolean'" :id="value3.id">
                                                <div class=" mb-3">
                                                  <h5 class="label_radio_align">
                                                    {{ value3.label }}
                                                    <text v-if="
                                                        value3.mandatory == '1' ||
                                                        value3.mandatory == '2'
                                                      " class="mandatory-mark">*</text>
                                                  </h5>
                                                  <div class="radio-btn-grp d-flex gap-4">
                                                    <div class="radio-btn-wrap">
                                                      <input type="radio" :id="value3.id + '1'" :name="value3.level" v-model.trim="formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input" v-bind:value="'1'" :disabled="value3.mandatory == 2 || value3.mandatory == 3" @click="getValidation($event, value3.name, value3.id, ind, ind2)" @change="removeFinanciarError(value3.name)" />
                                                      <label :for="value3.id + '1'" class="radio-label">YES</label>
                                                    </div>
                                                    <div class="radio-btn-wrap">
                                                      <input type="radio" :id="value3.id + '2'" :name="value3.level" v-model.trim="formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].input" v-bind:value="'0'" :disabled="value3.mandatory == 2 || value3.mandatory == 3" @keyup="getValidation($event, value3.name, value3.id, ind, ind2)" @change="removeFinanciarError(value3.name)" />
                                                      <label :for="value3.id + '2'" class="radio-label">NO</label>
                                                    </div>
                                                  </div>
                                                </div>
                                                <span class="error-msg" :id="'error_' + value3.id"></span>
                                              </div>
                                              <div class="mb-0 ncb_Discount-Message p-2" v-if="data.name=='previousPolicyDetails' && value2.name=='previousPolicyQuestions' && formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions!=undefined && formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.prevZeroDep.name=='prevZeroDep' && formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].name=='prevZeroDep' && formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.prevZeroDep.input!='' && formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.prevZeroDep.input!=null && formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.prevZeroDep.input==0 && motorProductType=='4W-Pvt'">
                                                <p class="mb-0">Inspection will be required.</p>
                                              </div>
                                              <div class="mb-0 ncb_Discount-Message p-2" v-if="data.name=='previousPolicyDetails' && value2.name=='previousPolicyQuestions' && formInfo.fieldGroups[ind]['fieldGroups'][ind2].fields[ind3].name=='ownershipTransfer' && formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.ownershipTransfer.input==1">
                                                <p class="mb-0"> NCB will be set to 0% </p>
                                              </div>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                </div>

                                <!-- Submit Form Button -->
                                <span v-if="currentTab == 'vehicleDetails' && this.financiererror!='' && this.showBankDropdown==false && !this.responsebank.length" style="font-size: 12px;color: red;">{{this.financiererror}}</span><br />
                                <span v-if="currentTab == 'vehicleDetails'" class="notes fw-bold" style="font-size: 12px">Note : Entering wrong Chassis Number & Engine Number will result in claim rejection in future.</span>
                                <div class="d-flex gap-4 mt-3">
                                  <button type="button" class="btn  backbutton" @click="goBack()" v-if="currentTab != 'proposerDetails'">
                                    <i class="pi pi-chevron-left me-2" aria-hidden="true"></i>
                                    <span>Previous</span>
                                  </button>
                                  <button type="submit" class="btn commonButton" :disabled="isPinCodePending || (ind === 'vehicleDetails' && (this.isDropdownOpen || this.isTextAllowed))">
                                    <span>Proceed</span>
                                    <i class="pi pi-chevron-right ms-2" aria-hidden="true"></i>
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                          <!--Proposer detail form step1-->
                          <div v-if="displayApiErrosOnUI.length">
                            <p class="mt-3 errorMessage" v-html="displayApiErrosOnUI.join('<br/>')"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <!-- Delete Modal Start-->
              <div class="modal fade" id="savechangesModal" tabindex="-1" aria-labelledby="savechangesModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-sm modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header border-0">
                      <h5 class="modal-title" id="savechangesModalLabel"></h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body py-0">
                      <div class="text-center">
                        <h4 class="text-primary">
                          Do you really want to delete Nominee1
                        </h4>
                      </div>
                    </div>
                    <div class="modal-footer justify-content-center border-0">
                      <div class="btn-hold mb-4">
                        <button class="btn btn-sm btn-outline-secondary rounded-pill" type="button">
                          No
                        </button>
                        <button class="btn btn-sm btn-warning text-white rounded-pill" type="button" data-bs-dismiss="modal">
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Delete Modal end-->
            </div>
          </div>
        </div>
      </div>
      <!--row-->
    </div>
  </div>
  <Disclaimer :page="'PROPOSAL'" />

  <PageLoader :msg="loadingMsg" v-if="loadingState" :isButton="isButton" />
  <Verifypremium v-if="verifyPremiumFlag" @emitVerifyClose="verifyModalClose" @continueNewPremium="continueNewPremium" :updatedPlanData="updatedPlanData" :selectedPlan="selectedPlan" />

  <!-- </div> -->
</template>
<script>
import { ref } from "vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { getIsAutoComplete } from "@/mixins/common";
import OwnerDetails from "../selectCard/ownerDetails.vue";
import policyDetails from "../selectCard/policyDetails.vue";
import ConfirmPay from "../selectCard/confirmPay.vue";
import EditDetailsModal from "@/modals/editDetailsModal.vue";
import VehicleDetail from "../selectCard/vehicleDetail.vue";
import $ from "jquery";
import PageLoader from "../pageLoaders/pageLoader.vue";
import { getDistributer} from '@/mixins/common';
import ProductDetailsHeader from "../productDetailsHeader/ProductDetailsHeader.vue";
import Verifypremium from "@/modals/verifypremium.vue";
import Disclaimer from "@/components/uiResuable/Disclaimer.vue"
import { stripHtml } from '@/utils/inputSanitizer';
import { shouldSkipGodigitKycOvd } from '@/utils/godigitKycOvdSkip';
import moment from 'moment';

export default {
  name: "formWizard",
  mixins: [getDistributer],
  components: {
    OwnerDetails,
    VehicleDetail,
    policyDetails,
    ConfirmPay,
    EditDetailsModal,
    PageLoader,
    ProductDetailsHeader,
    Verifypremium,
    Disclaimer
  },
  mounted() {
    this.distributorID = getDistributer()["distributerID"];
    if (sessionStorage.getItem("userData")) {
      this.userData = JSON.parse(sessionStorage.getItem("userData"));
      console.log(this.userData, "userData");
    }
    this.selectedPlan = JSON.parse(
      sessionStorage.getItem("selected_plan_data")
    );
    this.reviewDataHeader = JSON.parse(sessionStorage.getItem("quote_request"))

    this.requestJson = JSON.parse(sessionStorage.getItem("quote_request"));
    //for expression check
    this.quoteInfo = {
      'quoteResponse': this.selectedPlan,
      'quoteRequest': this.requestJson
    };
    if (sessionStorage.getItem("sp_details_data")) {
      this.spDetails = JSON.parse(sessionStorage.getItem("sp_details_data"));
    }
    this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
    if (this.rmData) {
      this.agentCode = this.rmData["UserId"];
    }
    // this.distributorID = distributorID;
    this.channel_type = this.requestJson.distributor.channelType;
    this.getProposal();
    // this.fetchKYCDetails();
    this.productCode = this.selectedPlan.insuranceAndProducts.productCode;

    const currentTab = JSON.parse(sessionStorage.getItem('currentTab'));
    if(currentTab && Object.values(this.formInfo).length > 0){
      // this.activeNextTab(currentTab);
      this.activeTab(currentTab);
    }
    this.motorProductType = this.$store.state.motorProductType;
    this.quoteCategory = this.$store.state.quoteCategory;
    if(sessionStorage.getItem("isOvdFlow")){
      this.isOvdAndFromDashboard = JSON.parse(sessionStorage.getItem("isOvdFlow"));
    }
  },
  data() {
    return {
        showBankDropdown:false,
        isDropdownOpen: false,
        financierFieldFocused: false,
        financierFieldPath: null,
        isTextAllowed:false,
        financiererror:"",
        selectedFinancier: "",
        responsebank:[],
        /** True after a successful bank search returned zero matches (Proceed blocked until user fixes). */
        financierSearchReturnedEmpty: false,
        /** Incremented to ignore stale getBankName responses when the user shortens input. */
        financierSearchSeq: 0,
        financierSearchDebounceTimer: null,
        financierApiInFlight: 0,
        loadingBankNames: false,
        productCode: "",
        loadingState: false,
        loadingMsg:"",
        configData: "",
        currentTab: "proposerDetails",
        noOfAdult: 0,
        noOfChild: 0,
        requestJson: "",
        selectedPlan: "",
        membersInputJson: [],
        selectedPolicyIndex: 0,
        proposalJson: "",
        proposalJson1: "",
        channel_type:"",
        ckycDetails: {},
        formInfo: {},
        quoteInfo: {},
        errorCounter: 0,
        submittedTab: "",
        tabsArr: [],
        userData: "",
        selectedMembersList: [],
        proposalUiId: 0,
        rmData: "",
        applicationNo: "",
        distributorID: "",
        pollRequestId: "",
        quoteResponseID: "",
        responseData: "",
        customModal: false,
        currentSectionIndex: "",
        currentQuoteResponseData: "",
        resume_proposal_flag: "",
        kycData: "",
        imageUrl: "pageloader.gif",
        displayApiErrosOnUI: [],
        apiReqData: {},
        reviewDataHeader: {},
        pollapiflag: true,
        uniqueQuoteId: "",
        verifyPremiumFlag: false,
        updatedPlanData: {},
        motorProductType: "",
        quoteCategory: "",
        isButton: false,
        isPinCodePending: false,
        isOvdAndFromDashboard: false
    };
  },
  methods: {
    fetchKYCDetails(){
      this.ckycDetails = JSON.parse(sessionStorage.getItem("kyc_response"));
      this.requestJson = JSON.parse(sessionStorage.getItem("quote_request"));
    },
    // backToQuotes() {
    //   this.$router.push('/ckyc-form');
    // },
    registrationNumberPlaceHolder(){
      // setTimeout(() => {
        return "Registration Number"
      // }, 0);
    },
    submitForm(sectionIndex) {
        console.log("form submitted: ", sectionIndex);
        let subArray = this.formInfo["fieldGroups"][sectionIndex];
        console.log("subArray: ", subArray);
  
        // ############# Validation Section #############
        this.errorCounter = 0;
        $(".error-msg").text("");
        if (sectionIndex === "vehicleDetails") {
          this.adoptRestoredFinancierSelection();
        }
        // If Fields
        var scrollTop = "";
  
        // If Array
        if (this.checkArray(subArray)) {
          for (var key in subArray) {
            // If Fields
            if(subArray[key].fields) {
              let fieldsArr = subArray[key].fields;
              console.log("fieldsArr: ", fieldsArr);
              for (var key2 in fieldsArr) {
                console.log("inside fieldsArr");
                let data = fieldsArr[key2];
                // Evaluating default field
                if(data.default) {
                  // eval(this.getFinalObject(data.default));
                }
                if (
                  this.checkVisibility(data.visibility) &&
                  this.checkVisibility(subArray[key].visibility)
                ) {
                  let errorTxt = this.getDescriptionTextArray(data.description);
                  if (
                    data.mandatory == "1" &&
                    data.type == "checkbox" &&
                    data.input == false
                  ) {
                    this.errorCounter++;
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id).text("This field is required");
                    console.log("invalid 1  mandatory:", data);
                  } else if (
                    data.type == "multi-select" &&
                    data.mandatory == "1" &&
                    data.input.length == 0
                  ) {
                    this.errorCounter++;
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id).text("This field is required");
                  } else if (
                    data.mandatory == "1" &&
                    !data.input &&
                    data.input != "0"
                  ) {
                    this.errorCounter++;
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id).text("This field is required");
                    //console.log('invalid 1 0000 mandatory:', data);
                  } else if (
                    data.type !== "boolean" &&
                    data.input &&
                    data.pattern &&
                    this.checkPattern(data.input, data.pattern) == false
                  ) {
                    this.errorCounter++;
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id).text(errorTxt[0]);
                    console.log("data.id: ", data.id);
                    console.log("rules 1: ", data.pattern);
                  } else if (
                    data.input &&
                    data.max &&
                    data.type == "number" &&
                    (data.input < data.min || data.input > data.max)
                  ) {
                    console.log("inside number: ", data);
                    this.errorCounter++;
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id).text(
                      "Value should be between " + data.min + " and " + data.max
                    );
                    console.log(
                      "rules number 1 Incorrect: ",
                      data.validation,
                      data
                    );
                  }else if (
                    data.input &&
                    data.min && data.max &&
                    data.type == "text" &&
                    (data.input.length < data.min || data.input.length > data.max)
                  ) {
                    console.log("inside number: ", data);
                    this.errorCounter++;
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id).text(
                      "Value should be between " + data.min + " and " + data.max + " Characters"
                    );
                    console.log(
                      "rules number 1 Incorrect: ",
                      data.validation,
                      data
                    );
                  }else if (
                    data.validation != null &&
                    data.input &&
                    this.checkValidation(data.validation, data.description) == false
                  ) {
                    this.errorCounter++;
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id).text(errorTxt[1]);
                    console.log("rules 1 invalid: ", data.validation);
                  }
                } else {
  
                  // setting blank, previously filled data
  
                  if(sectionIndex == 'healthQuestions') {
                    //this.formInfo["fieldGroups"][sectionIndex][key]["fields"][key2]["input"]  = this.membersInputJson
                  } else {
                    this.formInfo["fieldGroups"][sectionIndex][key]["fields"][key2]["input"] = "";
                  }
                }
              }
            }
  
            // If FieldGroups
            if(subArray[key].fieldGroups) {
              console.log('inside array fieldgroup');
              for(var key3 in subArray[key].fieldGroups) {
                let fieldsArr = subArray[key].fieldGroups[key3].fields;
                console.log("fieldsArr: ", fieldsArr);
                for (var key2 in fieldsArr) {
                  console.log("inside fieldsArr");
                  let data = fieldsArr[key2];
                  // Evaluating default field
                  if(data.default) {
                    // eval(this.getFinalObject(data.default));
                  }
                  if (
                    this.checkVisibility(data.visibility) &&
                    this.checkVisibility(subArray[key].visibility)
                  ) {
                    let errorTxt = this.getDescriptionTextArray(data.description);
  
                    console.log('error text id: ', data.id + key);
  
                    if (
                      data.mandatory == "1" &&
                      data.type == "checkbox" &&
                      data.input == false
                    ) {
                      this.errorCounter++;
                      if (scrollTop == "") {
                        scrollTop = data.id + key;
                      }
                      $("#error_" + data.id + key).text("This field is required");
                      console.log("invalid 1  mandatory:", data);
                    } else if (
                      data.type == "multi-select" &&
                      data.mandatory == "1" &&
                      data.input.length == 0
                    ) {
                      this.errorCounter++;
                      if (scrollTop == "") {
                        scrollTop = data.id + key;
                      }
                      $("#error_" + data.id + key).text("This field is required");
                    } else if (
                      (data.mandatory == "1" || data.mandatory == "2") &&
                      !data.input &&
                      data.input != "0"
                    ) {
                      this.errorCounter++;
                      if (scrollTop == "") {
                        scrollTop = data.id + key;
                      }
                      $("#error_" + data.id + key).text("This field is required");
                      //console.log('invalid 1 0000 mandatory:', data);
                    } else if (
                      data.type !== "boolean" &&
                      data.input &&
                      data.pattern &&
                      this.checkPattern(data.input, data.pattern) == false
                    ) {
                      this.errorCounter++;
                      if (scrollTop == "") {
                        scrollTop = data.id + key;
                      }
                      $("#error_" + data.id + key).text(errorTxt[0]);
                      console.log("data.id: ", data.id);
                      console.log("rules 1: ", data.pattern);
                    } else if (
                      data.input &&
                      data.max &&
                      data.type == "number" &&
                      (data.input < data.min || data.input > data.max)
                    ) {
                      console.log("inside number: ", data);
                      this.errorCounter++;
                      if (scrollTop == "") {
                        scrollTop = data.id + key;
                      }
                      $("#error_" + data.id + key).text(
                        "Value should be between " + data.min + " and " + data.max
                      );
                      console.log(
                        "rules number 1 Incorrect: ",
                        data.validation,
                        data
                      );
                    }else if (
                      data.input &&
                      data.min && data.max &&
                      data.type == "text" &&
                      (data.input.length < data.min || data.input.length > data.max)
                    ) {
                      console.log("inside number: ", data);
                      this.errorCounter++;
                      if (scrollTop == "") {
                        scrollTop = data.id + key;
                      }
                      $("#error_" + data.id + key).text(
                        "Value should be between " + data.min + " and " + data.max
                      );
                      console.log(
                        "rules number 1 Incorrect: ",
                        data.validation,
                        data
                      );
                    }else if (
                      data.validation != null &&
                      data.input &&
                      this.checkValidation2(this.getExpWithIndex(data.validation, key), data.description) == false
                    ) {
                      this.errorCounter++;
                      if (scrollTop == "") {
                        scrollTop = data.id + key;
                      }
                      $("#error_" + data.id + key).text(errorTxt[1]);
                      console.log("rules 1 invalid: ", data.validation);
                    }
                  } else {
                    // setting blank, previously filled data
                    if(sectionIndex == 'healthQuestions') {
                      //this.formInfo["fieldGroups"][sectionIndex][key]["fields"][key2]["input"] = this.membersInputJson;
                    } else {
                      this.formInfo["fieldGroups"][sectionIndex][key]["fields"][key2]["input"] = "";
                    }
                    
                  }
                }
              }
  
                
            }
            
          }
        }
  
        // If Fields
        for (var key in subArray.fields) {
          let data = subArray.fields[key];
          // Evaluating default field
          if(data.default) {
            // eval(this.getFinalObject(data.default));
          }
          if (this.checkVisibility2(data.visibility, sectionIndex)) {
            let errorTxt = this.getDescriptionTextArray(data.description);
            if(sectionIndex == 'healthQuestions' && this.checkArray(data.input)) {
              
              data.input.forEach((element, index) => {
                if(this.checkVisibility(this.getExpWithIndex(data.visibility, index))) {
                  if(data.mandatory == "1" && !data?.input[index]["answer"]) {
                    this.errorCounter++;
                    console.log('Health error 1: mandatory: ', data);
                    $("#error_" + data.id + '_' + index).text("This field is required");
                  } else if(data.type == "number" && (data?.input[index]["answer"] < data.min ||  data?.input[index]["answer"] > data.max)) {
                    console.log("Health error 2: number min max", data);
                    this.errorCounter++;
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id + '_' + index).text(
                      "Value should be between " + data.min + " and " + data.max
                    );
                  }else if(data.type == "text" && (data?.input[index]["answer"].length < data.min ||  data?.input[index]["answer"].length > data.max)) {
                    console.log("Health error 2: number min max", data);
                    this.errorCounter++;
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id + '_' + index).text(
                      "Value should be between " + data.min + " and " + data.max + " Characters"
                    );
                  }else if(this.checkValidation2(this.getExpWithIndex(data.validation, index), data.description) == false) {
                    this.errorCounter++;
                    console.log('');
                    if (scrollTop == "") {
                      scrollTop = data.id;
                    }
                    $("#error_" + data.id + '_' + index).text(errorTxt[1]);
                    console.log("Health error 3: validation: ", data);
                    if ($("#"+data.id+'_section').hasClass("d-none")) {
                      $("#"+data.id+'_section').removeClass("d-none")
                    }
                  } 
                  
                  // Add error class to dropdowns
                  this.getErrorClassForDropdown('dropdownMenuButton1' + data.id);
                }
              });
              
              
              
            } else {
              if (
                data.mandatory == "1" &&
                data.type == "checkbox" &&
                data.input == false
              ) {
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text("This field is required");
                console.log("invalid 1  mandatory:", data);
              } else if (
                data.mandatory == "1" &&
                !data.input &&
                data.input != "0"
              ) {
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                // console.log(scrollTop);
                console.log("invalid fields: mandatory: dt", data);
                $("#error_" + data.id).text("This field is required");
              } else if (
                data.type !== "boolean" &&
                data.input &&
                data.pattern &&
                this.checkPattern(data.input, data.pattern) == false
              ) {
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text(errorTxt[0]);
                console.log("data.id: ", data.id);
                console.log("rules 1 Incorrect: ", data.pattern);
              } else if (
                data.input &&
                data.max &&
                data.type == "number" &&
                (data.input < data.min || data.input > data.max)
              ) {
                console.log("inside number: f ", data);
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text(
                  "Value should be between " + data.min + " and " + data.max
                );
                console.log("rules number Incorrect: ", data.validation);
              }else if (
                data.input &&
                data.max && data.min &&
                data.type == "text" &&
                (data.input.length < data.min || data.input.length > data.max)
              ) {
                console.log("inside number: f ", data);
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text(
                  "Value should be between " + data.min + " and " + data.max + " Characters"
                );
                console.log("rules number Incorrect: ", data.validation);
              }else if (
                data.validation &&
                data.input && this.checkValidation(data.validation, data.description) == false
              ) {
                  this.errorCounter++;
                  console.log('inside checkvalidation pppppppppppp')
                  if (scrollTop == "") {
                    scrollTop = data.id;
                  }
                  $("#error_" + data.id).text(errorTxt[1]);
                  console.log("rules 1 invalid: ", data.validation);
              }
            }
            
          } else {
            // setting blank, previously filled data
            if(sectionIndex == 'healthQuestions') {
              //this.formInfo["fieldGroups"][sectionIndex]["fields"][key]["input"] = this.membersInputJson;
            } else {
              this.formInfo["fieldGroups"][sectionIndex]["fields"][key]["input"] ="";
            }
          }
        }
  
        // if (scrollTop != '') {
        //     var ele = document.getElementById(scrollTop);
        //     ele.scrollIntoView();
        //     ele.focus();
        //     ele.placeholder = ele.getAttribute("ph");
        // }
  
        // If FieldGroups
        for (var key in subArray.fieldGroups) {
          console.log('field groups key: ', key);
          let fieldsArr = subArray.fieldGroups[key].fields;
          for (var key2 in fieldsArr) {
            let data = fieldsArr[key2];
            // Evaluating default field
            if(data.default) {
              // eval(this.getFinalObject(data.default));
            }
            if (
              this.checkVisibility(data.visibility) &&
              this.checkVisibility(subArray.fieldGroups[key].visibility)
            ) {
              let errorTxt = this.getDescriptionTextArray(data.description);
              if (
                data.mandatory == "1" &&
                data.type == "checkbox" &&
                data.input == false
              ) {
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text("This field is required");
                console.log("invalid 1  mandatory:", data);
              } else if (
                data.type == "multi-select" &&
                data.mandatory == "1" &&
                data.input.length == 0
              ) {
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text("This field is required");
              } else if (
                data.mandatory == "1" &&
                !data.input &&
                data.input != "0"
              ) {
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text("This field is required");
                //console.log('invalid 1 0000 mandatory:', data);
              } else if (
                data.type !== "boolean" &&
                data.input &&
                data.pattern &&
                this.checkPattern(data.input, data.pattern) == false
              ) {
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text(errorTxt[0]);
                console.log("data.id: ", data.id);
                console.log("rules 1: ", data.pattern);
              } else if (
                data.input &&
                data.max &&
                data.type == "number" &&
                (data.input < data.min || data.input > data.max)
              ) {
                console.log("inside number: ", data);
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text(
                  "Value should be between " + data.min + " and " + data.max
                );
                console.log("rules number 1 Incorrect: ", data.validation, data);
              }else if (
                data.input &&
                data.max && data.min &&
                data.type == "text" &&
                (data.input.length < data.min || data.input.length > data.max)
              ) {
                console.log("inside number: ", data);
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text(
                  "Value should be between " + data.min + " and " + data.max + " Characters"
                );
                console.log("rules number 1 Incorrect: ", data.validation, data);
              }else if (
                data.validation != null &&
                data.input &&
                this.checkValidation(data.validation, data.description) == false
              ) {
                this.errorCounter++;
                if (scrollTop == "") {
                  scrollTop = data.id;
                }
                $("#error_" + data.id).text(errorTxt[1]);
                console.log("rules 1 invalid: ", data.validation);
              } else if (
                sectionIndex === "vehicleDetails" &&
                data.name === "financierName" &&
                this.isFinancierStrictContext()
              ) {
                const inputVal = String(data.input || "").trim();
                const selVal = String(this.selectedFinancier || "").trim();
                let financierInvalid = false;
                if (inputVal && selVal !== inputVal) {
                  financierInvalid = true;
                }
                if (data.mandatory === "2" && !inputVal && data.input != "0") {
                  financierInvalid = true;
                }
                if (financierInvalid) {
                  if (scrollTop == "") {
                    scrollTop = data.id;
                  }
                  $("#error_" + data.id).text(
                    inputVal && selVal !== inputVal
                      ? "Please select a bank from the list."
                      : "This field is required"
                  );
                }
              }
            
            } else {
              // setting blank, previously filled data
              if(sectionIndex == 'healthQuestions') {
                //this.formInfo["fieldGroups"][sectionIndex]["fieldGroups"][key]["fields"][key2]["input"] =  this.membersInputJson;
              } else {
                this.formInfo["fieldGroups"][sectionIndex]["fieldGroups"][key]["fields"][key2]["input"] = "";
              }
            }
          }
        }
  
        if (scrollTop != "" && ele) {
          var ele = document.getElementById(scrollTop);
          console.log('kkkkkkkkk: ', scrollTop);
          ele.scrollIntoView();
          ele.focus();
          //ele.placeholder = ele.getAttribute("ph");
        }
  
        console.log("this.errorCounter: ", this.errorCounter);
        //console.log("formInfo['fieldGroups']['insuredMembers']['0']['fieldGroups']['insuredMemberPersonalDetails']['fields']['gender']['input']: ", this.formInfo['fieldGroups']['insuredMembers']['0']['fieldGroups']['insuredMemberPersonalDetails']['fields']['gender']['input']);
        //console.log("formInfo['fieldGroups']['insuredMembers']['1']['fieldGroups']['insuredMemberPersonalDetails']['fields']['gender']['input']: ", this.formInfo['fieldGroups']['insuredMembers']['1']['fieldGroups']['insuredMemberPersonalDetails']['fields']['gender']['input']);
        if (this.errorCounter == "0") {
          this.submittedTab = sectionIndex;
  
          // If submitted index is proposer details
          
  
          // If submitted index is insured members
          if(this.submittedTab == 'insuredMembers') {
            subArray.forEach((element, index) => {
              let dob = element["fieldGroups"]["insuredMemberPersonalDetails"]["fields"]["dateOfBirth"]["input"];
              this.requestJson.personalInformation.individualDetails[index]["dateOfBirth"] = dob;
              this.requestJson.personalInformation.individualDetails[index]["age"] = this.calculateAge(dob);
            })
  
            console.log('Updated request json = ', this.requestJson);
            this.getQuotationApi(this.requestJson, sectionIndex);
          } else {
            this.saveProposal(sectionIndex);
          }
  
          console.log("submitted data modified: ", this.formInfo);
  
          // Calling Save Proposal
          //this.saveProposal(sectionIndex);  
          //this.activeNextTab(sectionIndex);
        } else {
          //this.activeNextTab(sectionIndex);
        }
      },
      getDescriptionTextArray(str) {
        let tempArr = [];
        if (str) {
          var check = str.includes("#");
          if (check) {
            tempArr = str.split("#");
          } else {
            tempArr[0] = str;
            tempArr[1] = str;
          }
        } else {
          tempArr[0] = "";
          tempArr[1] = "";
        }
  
        return tempArr;
      },
    sortDropDown(list) {
        //return list;
        if (list) {
          list = list.sort(sortbyname);
          function sortbyname(a, b) {
            if (a.Text < b.Text) return -1;
            if (a.Text > b.Text) return 1;
            return 0;
          }
          return list;
        }
      },
      validateYear(field, value){
        if(field == "proposerDetails"){
          const dateParts = value.split("-")
          if (dateParts[0] && dateParts[0].length > 4) {
            dateParts[0] = dateParts[0].slice(0, 4);
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input = dateParts.join("-");
          }
        }else if(field =="nomineeInfo"){
          const dateParts1 = value.split("-")
          if (dateParts1[0] && dateParts1[0].length > 4) {
            dateParts1[0] = dateParts1[0].slice(0, 4);
            this.formInfo.fieldGroups.nomineeInfo.fields.dateOfBirth.input = dateParts1.join("-");
          }
        }else if(field =="previousPolicyDetails"){
          const dateParts2 = value.split("-")
          if (dateParts2[0] && dateParts2[0].length > 4) {
            dateParts2[0] = dateParts2[0].slice(0, 4);
            this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input = dateParts2.join("-");
          }
        }
      },
      updateFinancierName($event,item) {
        this.formInfo.fieldGroups.vehicleDetails.fieldGroups.financierDetails.fields.financierName.input = 
        $event.target.value;
        this.selectedFinancier=$event.target.value;
      },
      removeFinanciarError(name){
        if(name =="vehicleHypothecation"){
          this.financiererror="";
          const hyp = this.formInfo?.fieldGroups?.vehicleDetails?.fieldGroups?.financierDetails?.fields?.vehicleHypothecation?.input;
          if (String(hyp) === '0') {
            this.clearFinancierSearchDebounce();
            this.financierSearchSeq += 1;
            this.responsebank = [];
            this.selectedFinancier = "";
            this.financierSearchReturnedEmpty = false;
            this.showBankDropdown = false;
            this.isDropdownOpen = false;
            if (this.formInfo?.fieldGroups?.vehicleDetails?.fieldGroups?.financierDetails?.fields?.financierName) {
              this.formInfo.fieldGroups.vehicleDetails.fieldGroups.financierDetails.fields.financierName.input = "";
            }
            const fn = this.formInfo?.fieldGroups?.vehicleDetails?.fieldGroups?.financierDetails?.fields?.financierName;
            if (fn?.id) {
              $("#error_" + fn.id).text("");
            }
            this.syncFinancierProceedGate();
          } else if (String(hyp) === '1') {
            this.syncFinancierProceedGate();
          }
        }
        if(name=='ownershipTransfer'){
          this.requestJson.personalInformation.individualDetails[0].isOwnerTransfer = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.ownershipTransfer.input==1 ? true : false;
          sessionStorage.setItem("quote_request",JSON.stringify(this.requestJson));
        }
        if(name=='prevZeroDep'){     
          let zeroDepNo = {
            optionValueSelected: "prevPolicyHasZeroDep",
            optionValueInput: this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.prevZeroDep.input==0 ? "false" : "true"
          }
          this.requestJson.product.motorCovers = this.requestJson.product.motorCovers.map(cover => {
            if (cover.optionSelected === "zeroDep") {
                let updatedOptionValue = cover.optionValue
                    .filter(opt => opt.optionValueSelected !== "prevPolicyHasZeroDep")
                    .filter(opt => opt.optionValueSelected !== "noOfClaims");
                
                updatedOptionValue.push(zeroDepNo);
                return {
                    ...cover,
                    optionValue: updatedOptionValue
                };
            }
            return cover;
        });
          sessionStorage.setItem("filledData", JSON.stringify(this.formInfo));
          sessionStorage.setItem("quote_request",JSON.stringify(this.requestJson));
        }
      },
      getFinancierDetailsContext() {
        try {
          const vehicleDetails = this.formInfo?.fieldGroups?.vehicleDetails;
          const financierGroup = vehicleDetails?.fieldGroups?.financierDetails;
          if (!financierGroup?.fields?.financierName || !financierGroup?.fields?.vehicleHypothecation) {
            return null;
          }
          return {
            vehicleDetails,
            financierGroup,
            hypothecation: financierGroup.fields.vehicleHypothecation,
            financierName: financierGroup.fields.financierName,
          };
        } catch (e) {
          return null;
        }
      },
      isFinancierStrictContext() {
        const ctx = this.getFinancierDetailsContext();
        if (!ctx) return false;
        if (String(ctx.hypothecation?.input) !== "1") return false;
        if (ctx.vehicleDetails?.visibility && !this.checkVisibility(ctx.vehicleDetails.visibility)) {
          return false;
        }
        if (ctx.financierGroup?.visibility && !this.checkVisibility(ctx.financierGroup.visibility)) {
          return false;
        }
        if (ctx.financierName?.visibility && !this.checkVisibility(ctx.financierName.visibility)) {
          return false;
        }
        return true;
      },
      /**
       * When true, the Proceed button stays disabled (template: :disabled="... || this.isTextAllowed").
       * Financier: strict list selection only while hypothecation is Yes.
       */
      syncFinancierProceedGate() {
        if (!this.isFinancierStrictContext()) {
          this.isTextAllowed = false;
          return;
        }
        const ctx = this.getFinancierDetailsContext();
        const input = String(ctx.financierName.input || "").trim();
        const sel = String(this.selectedFinancier || "").trim();
        const required = ctx.financierName.mandatory === "1" || ctx.financierName.mandatory === "2";

        let block = false;
        if (this.financiererror && input.length >= 3) {
          block = true;
        }
        if (!this.loadingBankNames && this.financierSearchReturnedEmpty && input.length >= 3) {
          block = true;
        }
        if (required && !input) {
          block = true;
        }
        if (input && sel !== input) {
          block = true;
        }
        this.isTextAllowed = block;
      },
      /**
       * After reload / proposal hydrate, `financierName.input` is restored from session or API
       * but `selectedFinancier` stays empty — strict validation then fails. Align selection from saved input.
       */
      adoptRestoredFinancierSelection() {
        try {
          const ctx = this.getFinancierDetailsContext();
          if (!ctx?.financierName) return;
          const trimmed = String(ctx.financierName.input || "").trim();
          if (!trimmed) return;
          this.selectedFinancier = trimmed;
          this.financierSearchReturnedEmpty = false;
          this.financiererror = "";
          if (ctx.financierName.id) {
            $("#error_" + ctx.financierName.id).text("");
          }
          this.syncFinancierProceedGate();
        } catch (e) {
          console.log("adoptRestoredFinancierSelection", e);
        }
      },
      onFinancierFieldChange(id, ind, ind2, ind3) {
        this.financierFieldPath = { ind, ind2, ind3 };
        this.syncFinancierProceedGate();
      },
      clearFinancierSearchDebounce() {
        if (this.financierSearchDebounceTimer) {
          clearTimeout(this.financierSearchDebounceTimer);
          this.financierSearchDebounceTimer = null;
        }
      },
      /**
       * Runs getBankName for current financier input (length >= 3). Uses financierSearchSeq for stale guards
       * and financierApiInFlight + finally so loading never sticks when responses are stale.
       */
      runFinancierBankSearch(id) {
        const p = this.financierFieldPath;
        if (!p || !this.formInfo?.fieldGroups?.[p.ind]?.fieldGroups?.[p.ind2]?.fields?.[p.ind3]) return;
        const field = this.formInfo.fieldGroups[p.ind].fieldGroups[p.ind2].fields[p.ind3];
        const q = String(field.input || "").trim();
        if (q.length < 3) return;

        const seq = ++this.financierSearchSeq;
        this.responsebank = [];
        this.financiererror = "";
        this.financierSearchReturnedEmpty = false;

        const headers = {};
        const reqData = {
          lookUpCategory: "search",
          manufacturerId: this.selectedPlan.insuranceAndProducts.insuranceCompanyCode,
          entityId: "BANKNM",
          key: q.toUpperCase(),
        };
        this.loadingMsg = "Fetching bank names...";
        this.financierApiInFlight += 1;
        this.loadingBankNames = true;
        this.syncFinancierProceedGate();

        this.backendApi("getBankName", reqData, headers, "post")
          .then((response) => {
            if (seq !== this.financierSearchSeq) {
              return;
            }
            const errors = response.data?.errors;
            if (errors && errors.length) {
              this.financiererror =
                errors[0].errorDisplayMessage || errors[0].message || "Error fetching bank names";
              this.showBankDropdown = false;
              this.responsebank = [];
              this.financierSearchReturnedEmpty = true;
              $("#error_" + id).text("Please select a bank from the list.");
              this.syncFinancierProceedGate();
            } else if (response && response.data) {
              const data = response.data.data || {};
              const rawData = data.BANKNM ?? data.result ?? data.lookupResult ?? [];
              const list = Array.isArray(rawData)
                ? rawData
                    .map((item) =>
                      typeof item === "string"
                        ? item
                        : (item?.Value ?? item?.Text ?? item?.value ?? item?.text ?? "")
                    )
                    .map((s) => String(s).trim())
                    .filter(Boolean)
                : [];
              this.responsebank = [...new Set(list)].sort();
              if (this.responsebank.length === 0) {
                this.financierSearchReturnedEmpty = true;
                this.showBankDropdown = false;
                $("#error_" + id).text(
                  "No matching banks. Please adjust your search and select from the list."
                );
              } else {
                this.financierSearchReturnedEmpty = false;
                this.showBankDropdown = true;
                $("#error_" + id).text("");
              }
              this.financiererror = "";
              this.$nextTick(() => {
                this.isDropdownOpen = true;
              });
              this.syncFinancierProceedGate();
            }
          })
          .catch((error) => {
            console.error("[getBankName] API Error:", error);
            if (seq !== this.financierSearchSeq) {
              return;
            }
            this.responsebank = [];
            this.showBankDropdown = false;
            this.financierSearchReturnedEmpty = true;
            this.financiererror = "Error fetching bank names";
            $("#error_" + id).text("Please select a bank from the list.");
            this.syncFinancierProceedGate();
          })
          .finally(() => {
            this.financierApiInFlight = Math.max(0, this.financierApiInFlight - 1);
            if (this.financierApiInFlight === 0) {
              this.loadingBankNames = false;
            }
            this.syncFinancierProceedGate();
          });
      },
      setNCBDetails(){
        let quoteRequestUpdated = JSON.parse(sessionStorage.getItem("quote_request"));
        this.apiReqData.product.ncbDetails.ncbPercentageLastYear = 
          (this.requestJson.personalInformation.individualDetails[0].isOwnerTransfer || 
          this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousCoverageType.input == 'StandaloneTP(1)') || quoteRequestUpdated.product.ncbDetails.claimLastYearFlag
            ? 0 : this.requestJson.product.ncbDetails.ncbPercentageLastYear;

        this.apiReqData.product.ncbDetails.claimLastYearFlag = 
            (this.requestJson.personalInformation.individualDetails[0].isOwnerTransfer || 
            this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousCoverageType.input == 'StandaloneTP(1)') || quoteRequestUpdated.product.ncbDetails.claimLastYearFlag
              ? true 
              : false;

        this.apiReqData.product.ncbDetails.numberOfClaims = 
            (this.requestJson.personalInformation.individualDetails[0].isOwnerTransfer || 
            this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousCoverageType.input == 'StandaloneTP(1)') || quoteRequestUpdated.product.ncbDetails.claimLastYearFlag
              ? 1 
              : 0;
      },
      setMotorProducts() {
        if (this.requestJson.product.motorCovers.length == 0) return;

        // Handle Automobile Association
        let associationAvailable = this.requestJson.product.motorCovers.find(
          cover => cover.optionSelected === 'autoasso'
        );
        
        if (associationAvailable) {
          let automobileAssociation = {
            optionValueSelected: "membershipnumber",
            optionValueInput: this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.MembershipId.input
          };

          this.apiReqData.product.motorCovers = this.requestJson.product.motorCovers.map(cover => {
            if (cover.optionSelected === "autoasso") {
              cover.optionValue.length = 0;
              cover.optionValue.push(automobileAssociation);
            }
            return cover;
          });
          sessionStorage.setItem("quote_request", JSON.stringify(this.requestJson));
        }

        // Handle Zero Dep
        let allMotorCoversInMQ = JSON.parse(sessionStorage.getItem("motor_covers"));
        let zeroDepAvailable = allMotorCoversInMQ?.find(
          cover => cover.optionSelected === 'zeroDep'
        );

        if (zeroDepAvailable) {
          const prevZeroDepInput = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.prevZeroDep.input;

          if (prevZeroDepInput === 0) {
            // User selected NO → Remove zeroDep from API request
            if(this.apiReqData.product.insuranceAndProducts[0].insuranceCompanyCode.startsWith("GO")){
              this.apiReqData.product.motorCovers = this.apiReqData.product.motorCovers.filter(
                cover => cover.optionSelected !== 'zeroDep'
              );
            }
          } 
          else if (prevZeroDepInput == 1) {
            // User selected YES → Push zeroDep if not already present
            const alreadyZeroDep = this.apiReqData.product.motorCovers.find(
              cover => cover.optionSelected === 'zeroDep'
            );
            if (!alreadyZeroDep) {
              const zeroDepObj = {
                optionSelected: "zeroDep",
                optionValue: [
                  {
                    optionValueSelected: "prevPolicyHasZeroDep",
                    optionValueInput: "true"
                  }
                ],
                varFields: [
                  {
                    fieldName: "",
                    fieldValue: ""
                  }
                ]
              };
              this.apiReqData.product.motorCovers.push(zeroDepObj);
              console.log("Zero Dep Available + Pushed: ", this.apiReqData.product.motorCovers);
            }
          }
        }
      },
      setFullNameField(){
        let kycData = sessionStorage.getItem("kyc_response") ? JSON.parse(sessionStorage.getItem("kyc_response")) : "";
        let userType = JSON.parse(sessionStorage.getItem("user-type"));
        try {
          const firstName = kycData['personalInformation']['firstName'] || '';
          const middleName = kycData['personalInformation']['middleName'] || '';
          const lastName = kycData['personalInformation']['lastName'] || '';

          if(userType != 'corporate'){
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fullName']['input'] = [firstName, middleName, lastName].filter(name => name).join(' ');
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fullName']['mandatory'] = this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fullName']['input'] ? 2 : 1;
          }else{
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails']['fields']['nameOfCaompany']['input'] = [firstName, middleName, lastName].filter(name => name).join(' ');
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails']['fields']['nameOfCaompany']['mandatory'] = this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails']['fields']['nameOfCaompany']['input'] ? 2 : 1;
          }
          
          if(this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fullName']['default']) {
            eval(this.getFinalObject(this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fullName']['default']));
          }
          console.log("Full Name: ", "Pradip Kaity", this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fullName'])
        } catch (err) {
          console.log('kyc data fullName mapping error:', err);
        }
      },
    getValidation(event, name, id, ind1 = "", ind2 = "", ind3 = "") {
      const char = String.fromCharCode(event.keyCode || event.which);
      const regex = /[A-Za-z0-9]/;
      if (event.target.type === "number") {
        const value = event.target.value;
        event.target.value = value.replace(/[^0-9.]/g, "");
      }
      self = this;
      $("#error_" + id).text("");
      let val = event.target.value;
      if(name =="aadharNo"){
        const regex= /^\d{12}$/;
        if (!regex.test(char)) {
          event.preventDefault();
        }
        this.formInfo.fieldGroups[ind1].fieldGroups[ind2].fields[name].input =
          this.formInfo.fieldGroups[ind1].fieldGroups[ind2].fields[name]["input"].toUpperCase().replace(/\D/g, '');
      }
      if (name == "PAN") {
        if (!regex.test(char)) {
          event.preventDefault();
        }
        this.formInfo.fieldGroups[ind1].fieldGroups[ind2].fields[name].input =
          this.formInfo.fieldGroups[ind1].fieldGroups[ind2].fields[name]["input"].toUpperCase().replace(/[^A-Z0-9]/g, '');
      }
      if (name == "nameOfCaompany"){
        this.formInfo.fieldGroups['proposerDetails'].fieldGroups['corporateDetails'].fields['nameOfCaompany'].input = this.formInfo.fieldGroups['proposerDetails'].fieldGroups['corporateDetails'].fields['nameOfCaompany'].input.replace(/[^a-zA-Z0-9 ,.'&-]/g, '');
      }
      if (name == "mobileNumber"){
        this.formInfo.fieldGroups['proposerDetails'].fieldGroups['personalDetails'].fields['mobileNumber'].input = this.formInfo.fieldGroups['proposerDetails'].fieldGroups['personalDetails'].fields['mobileNumber'].input.replace(/[^0-9]/g, '');
      }
      // if((name == "panNumber" || name == "dateOfEstablishment") && ind2=='corporateDetails'){
      //   let today = new Date();
      //   let futureYear = today.getFullYear() + 99;
      //   let mm = String(today.getMonth() + 1).padStart(2, '0');
      //   let dd = String(today.getDate()).padStart(2, '0');
      //   let allowMaxDate = `${futureYear}-${mm}-${dd}`;

      //   let corporatePAN = this.formInfo.fieldGroups['proposerDetails'].fieldGroups['corporateDetails'].fields['panNumber'].input;
      //   if(corporatePAN && (corporatePAN[3] != 'p' || corporatePAN[3] != 'P')){
      //     console.log("date of establishment: ", this.formInfo.fieldGroups['proposerDetails'].fieldGroups['corporateDetails'].fields['dateOfEstablishment'])
      //     this.formInfo.fieldGroups['proposerDetails'].fieldGroups['corporateDetails'].fields['dateOfEstablishment'].min = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
      //     this.formInfo.fieldGroups['proposerDetails'].fieldGroups['corporateDetails'].fields['dateOfEstablishment'].max = allowMaxDate
      //   }else{
      //     this.formInfo.fieldGroups['proposerDetails'].fieldGroups['corporateDetails'].fields['dateOfEstablishment'].max = "9999-12-31"
      //   }
      // }
      if (name == "vehicleNumber" || name == "rtoCode" || name == "vehicleEngineNumber" || name == "gstNumber" || name == "panNumber" || name == "vehicleChassisNumber") {
        this.formInfo.fieldGroups[ind1].fieldGroups[ind2].fields[name].input = this.formInfo.fieldGroups[ind1].fieldGroups[ind2].fields[name]["input"].toUpperCase().replace(/[^A-Z0-9]/g, '');
        
      }
      // if((name=='firstName' || name=='lastName') && ind1=='nomineeInfo'){
        this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName.input = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName.input.replace(/[^a-zA-Z\s']/g, '');
        this.formInfo.fieldGroups.nomineeInfo.fields.firstName.input = this.formInfo.fieldGroups.nomineeInfo.fields.firstName.input.replace(/[^a-zA-Z\s']/g, '');
        this.formInfo.fieldGroups.nomineeInfo.fields.lastName.input = this.formInfo.fieldGroups.nomineeInfo.fields.lastName.input.replace(/[^a-zA-Z\s']/g, '');
      // }
      if(name =="financierName"){
        this.financierFieldPath = { ind: ind1, ind2, ind3 };
        const valTrim = String(val || "").trim();
        const selTrim = String(this.selectedFinancier || "").trim();
        if (selTrim && valTrim !== selTrim) {
          this.selectedFinancier = "";
        }
        if(val==''){
          this.clearFinancierSearchDebounce();
          this.financierSearchSeq += 1;
          this.selectedFinancier = "";
          this.responsebank = [];
          this.financierSearchReturnedEmpty = false;
          this.financiererror = "";
          $("#error_" + id).text("");
          this.syncFinancierProceedGate();
        } else if (val.length < 3) {
          this.clearFinancierSearchDebounce();
          this.financierSearchSeq += 1;
          this.responsebank = [];
          this.showBankDropdown = false;
          this.financierSearchReturnedEmpty = false;
          this.financiererror = "";
          $("#error_" + id).text("");
          this.syncFinancierProceedGate();
        }
        if (val.length >= 3) {
          this.clearFinancierSearchDebounce();
          const debounceMs = 350;
          this.financierSearchDebounceTimer = setTimeout(() => {
            this.financierSearchDebounceTimer = null;
            this.runFinancierBankSearch(id);
          }, debounceMs);
        }
      }
      

      if (
        this.selectedPlan.insuranceAndProducts.insuranceCompanyCode === "TAGIC"
      ) {
        if (ind1 === "healthQuestions" && val === "0") {
          const miniIndex = ind2?.substring(3, 0);
          const allIndexs = Object.keys(this.formInfo.fieldGroups[ind1].fields)
            .filter((ele) => {
              return ele?.startsWith(miniIndex);
            })
            .slice(1);
          allIndexs.forEach((indexName) => {
            this.formInfo.fieldGroups[ind1].fields[indexName].input.forEach(
              (ele) => {
                this.formInfo.fieldGroups[ind1].fields[indexName].input[
                  ind3
                ].answer = "";
              }
            );
          });
        }
      }

      if (name == "weight" || name == "height") {
        // let testString = this.formInfo["fieldGroups"][ind1][ind2]["fieldGroups"][ind3]["fields"]["insuredBMI"]["default"];
        // eval(this.getFinalObject(testString));
      }
      if (name == "zipCode" && val.length == 6) {
        console.log("zipcode completed");
        this.getPincodeDetails2(val, ind1, ind2, ind3);
      }

      // if(name === 'cityDistrict')
      // {
      //   console.log("get Area completed",val,name)
      //   this.getAreaCode(val,ind1, ind2, ind3)
      // }

      if (name === "town") {
        this.getAreaCode(val, ind1, ind2, ind3);
      }

      // if (name == "maritalStatus") {
      //   this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
      //     "title"
      //   ]["input"] = this.getTitleStr(
      //     val,
      //     this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
      //       "gender"
      //     ]["input"]
      //   );
      //   console.log(">>>>>>>>>>>>>>>>>!!!!!!!!!!!!!",          this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
      //       "gender"
      //     ])
      // }

      //console.log('path: ', path);
      if(name == 'middleName'){
        this.validateMiddleName()
      }
      if(name=='dateOfBirth'){
        let userType = JSON.parse(sessionStorage.getItem("user-type"));
        let age = this.calculateAge(this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input);
        if(userType=='individual' && age<18){
          $("#error_" + this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.id).text("The Date of Birth should be above 18 years.");
          this.dateOfBirth = "";
        }else{
          $("#error_" + this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.id).text("");
        }
      }
    },
    openDropdown(name) {
      if(name =="financierName"){
        this.financierFieldFocused = true;
        this.isDropdownOpen = true;
        this.$nextTick(() => {
          const t = String(this.getFinancierDetailsContext()?.financierName?.input || "").trim();
          if (t && !String(this.selectedFinancier || "").trim()) {
            this.adoptRestoredFinancierSelection();
          }
          this.syncFinancierProceedGate();
        });
      }
    },
    closeDropdown(name) {
      if(name =="financierName"){
        this.financierFieldFocused = false;
        setTimeout(() => {
          this.isDropdownOpen = false;
          const p = this.financierFieldPath;
          const fnField = p && this.formInfo?.fieldGroups?.[p.ind]?.fieldGroups?.[p.ind2]?.fields?.[p.ind3];
          const inputVal = fnField ? String(fnField.input || "").trim() : "";
          const selVal = String(this.selectedFinancier || "").trim();
          if (this.isFinancierStrictContext() && inputVal && selVal !== inputVal) {
            this.selectedFinancier = "";
            this.setFinancierInput("");
            this.responsebank = [];
            this.showBankDropdown = false;
            if (fnField?.id) {
              $("#error_" + fnField.id).text("Please select a bank from the list.");
            }
          }
          this.syncFinancierProceedGate();
        }, 200);
      }
    },
    setFinancierInput(value) {
      const p = this.financierFieldPath;
      if (!p || !this.formInfo?.fieldGroups?.[p.ind]?.fieldGroups?.[p.ind2]?.fields?.[p.ind3]) return;
      this.formInfo.fieldGroups[p.ind].fieldGroups[p.ind2].fields[p.ind3].input = value;
    },
    selectOption(option) {
      this.selectedFinancier = option;
      this.setFinancierInput(option);
      this.isDropdownOpen = false;
      this.financierSearchReturnedEmpty = false;
      this.financiererror = "";
      const p = this.financierFieldPath;
      if (p && this.formInfo?.fieldGroups?.[p.ind]?.fieldGroups?.[p.ind2]?.fields?.[p.ind3]?.id) {
        $("#error_" + this.formInfo.fieldGroups[p.ind].fieldGroups[p.ind2].fields[p.ind3].id).text("");
      }
      this.syncFinancierProceedGate();
    },
    validateMiddleName(){
      const MAX_CHARACTERS = 50;
      const middleNameValue = this.proposalJson['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['middleName']['input']
      if(middleNameValue.length > MAX_CHARACTERS){
        this.proposalJson['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['middleName']['input'] = middleNameValue.slice(0, MAX_CHARACTERS);
      }
    },
    getPincodeDetails2(pincode, ind1, ind2) {
      const Insurence = JSON.parse(
        sessionStorage.getItem("selected_plan_data")
      );

      var headers = {
        Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
        "Content-Type": "application/json",
      };
      let reqData = [pincode];
      //this.loadingState=true;
      this.isPinCodePending = true;
      this.loadingMsg="Getting Pin Code details"
      //this.loading = true;
      this.backendApi("getPincodeInfo", reqData, headers, "get")
        .then((response) => {
          this.isPinCodePending = false;
          this.loadingState=false;
          if (response == "error") {
            //this.apiError = true;
            console.log("pincode api error: block");
          } else if (response.data.errors.length > 0) {
            this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
              "zipCode"
            ]["input"] = "";
            this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
              "cityDistrict"
            ]["input"] = "";
            if (
              Insurence.insuranceAndProducts.insuranceCompanyCode === "STAR"
            ) {
              this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
                "area"
              ]["input"] = "";
            }
            this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
              "state"
            ]["input"] = "";
            this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
              "nationality"
            ]["input"] = "";
          } else if (response && response.data) {
            this.zipCodeInside = pincode;

            if (
              Insurence.insuranceAndProducts.insuranceCompanyCode === "STAR"
            ) {
              this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
                "area"
              ]["input"] = "";
              let v = response.data.data[0];
              sessionStorage.setItem("pincode_data", JSON.stringify(v));
              this.getCityCode(pincode, ind1, ind2);
              this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
                "cityDistrict"
              ]["input"] = v?.city;
              this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
                "state"
              ]["input"] = v.state;
              this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
                "nationality"
              ]["input"] = v.country.toUpperCase();
            } else {
              let v = response.data.data[0];
              sessionStorage.setItem("pincode_data", JSON.stringify(v));
              // Setting Pincode Data
              this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
                "cityDistrict"
              ]["input"] = v.city;
              this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
                "state"
              ]["input"] = v.state;
              this.formInfo["fieldGroups"][ind1]["fieldGroups"][ind2]["fields"][
                "nationality"
              ]["input"] = v.country.toUpperCase();
            }
          }
        })
        .catch((error) => {
          this.loadingState=false;
          console.log("error msg block getting pincode info", error);
          //this.loading = false;
          //this.apiError = true;
        });
    },
    getDescriptionText(str) {
      let descText = "";
      if (str) {
        var check = str.includes("#");
        if (check) {
          let tempArr = str.split("#");
          descText = tempArr[0];
        } else {
          descText = str;
        }
      } else {
        descText = "";
      }
      return descText;
    },
    completed(index) {
      this.activeTab = index;
    },
    isCompleted(index) {
      return index < this.activeTab;
    },
    getFinalObject(tempResponse) {
      //console.log('tempResponse: ', tempResponse)
      var tempString = JSON.stringify(tempResponse);
      var updatedString = tempString.replace(
        /'input' in formInfo\[/g,
        "formInfo["
      );
      var updatedString2 = updatedString.replace(
        /formInfo\[/g,
        "this.formInfo["
      );
      var updatedString3 = updatedString2.replace(
        /quoteInfo\[/g,
        "this.quoteInfo["
      );
      //console.log('final String: ', updatedString3);
      return JSON.parse(updatedString3);
    },
    getDescriptionText(str) {
      let descText = "";
      if (str) {
        var check = str.includes("#");
        if (check) {
          let tempArr = str.split("#");
          descText = tempArr[0];
        } else {
          descText = str;
        }
      } else {
        descText = "";
      }
      return descText;
    },
    defaultData(fieldGroups,formInfo,quoteInfo){
      for(let fieldGroupKey in fieldGroups ){
        let fieldGroup = fieldGroups[fieldGroupKey];
        if ('fields' in fieldGroup){
          for(let fieldKey in fieldGroup['fields']){
            let field = fieldGroup['fields'][fieldKey];
            let exp = field['default'];
            if(exp){
              try {
                eval(exp);
              }
              catch (err) {
                console.log('error default exp: ', exp);
                console.log('error-->'+err);
              }
            }

          }
        } 
        if ('fieldGroups' in fieldGroup){
          this.defaultData(fieldGroup['fieldGroups'],formInfo,quoteInfo);
        }
      }
    },
    normalizeSingleSelectValues(fieldGroups, processedFields = new Set(), path = '') {
      // Normalize case for single-select field values to match option values
      if (!fieldGroups) return;
      
      // Handle array-based fieldGroups
      const groupsToProcess = Array.isArray(fieldGroups) ? fieldGroups : Object.values(fieldGroups);
      
      for(let fieldGroup of groupsToProcess) {
        if (!fieldGroup) continue;
        
        // Build current path for unique identification
        const currentPath = path ? `${path}.${fieldGroup.name || 'group'}` : (fieldGroup.name || 'root');
        
        // Process fields in current fieldGroup
        if ('fields' in fieldGroup && fieldGroup.fields) {
          const fieldsToProcess = Array.isArray(fieldGroup.fields) 
            ? fieldGroup.fields 
            : Object.values(fieldGroup.fields);
          
          for(let field of fieldsToProcess) {
            if (!field) continue;
            
            // Create a unique identifier using field.id (most reliable) or path + name combination
            // Use field.id as primary identifier since it should be unique
            const fieldId = field.id ? String(field.id) : `${currentPath}.${field.name || field.label || 'field'}`;
            
            // Skip if already processed
            if (processedFields.has(fieldId)) {
              continue;
            }
            
            // Mark as processed
            processedFields.add(fieldId);

            // Get the actual input value - handle Vue reactive objects
            // Vue reactive objects (Proxy) can show differently in console.log
            // Use direct property access and handle all edge cases
            let actualInput = '';
            try {
              // Direct access - Vue reactive objects should work with direct property access
              const inputProp = field.input;
              
              // Check if it's a valid non-empty value
              if (inputProp !== undefined && inputProp !== null && inputProp !== '') {
                actualInput = inputProp;
              }
            } catch (e) {
              // If access fails, treat as empty
              actualInput = '';
            }
            
            // Convert to string and trim - handle all falsy values
            // Only process if we have a non-empty string value
            const inputValue = actualInput ? String(actualInput).trim() : '';
            const hasInput = inputValue !== '' && inputValue !== 'undefined' && inputValue !== 'null';
            
            // Special logging for previousCoverageType field - log even if no input
            if (field.name === 'previousCoverageType' || field.label === 'Previous Policy Type') {
             
              if (Array.isArray(field.value) && field.value.length > 0) {
                console.log('Available Options:', field.value.map(item => ({ Text: item?.Text, Value: item?.Value })));
              }
            }
            
            // Check if it's a single-select field with an input value and options
            if (
              field.type === 'single-select' &&
              hasInput &&
              Array.isArray(field.value) &&
              field.value.length > 0
            ) {
              // Find matching option value (case-insensitive)
              const matchedOption = field.value.find(item => 
                item && item.Value && String(item.Value).trim().toLowerCase() === inputValue.toLowerCase()
              );
              
              if (matchedOption) {
                // Replace input value with exact case from option value
                if (field.name === 'previousCoverageType' || field.label === 'Previous Policy Type') {
                  console.log('✓ Match found! Original:', inputValue, 'Normalized to:', matchedOption.Value);
                }
                field.input = matchedOption.Value;
              } else {
                // Log if no match found for debugging
                if (field.name === 'previousCoverageType' || field.label === 'Previous Policy Type') {
                 
                  const partialMatches = field.value.filter(item => 
                    item && item.Value && String(item.Value).trim().toLowerCase().includes(inputValue.toLowerCase())
                  );
                  if (partialMatches.length > 0) {
                    console.warn('Partial matches found:', partialMatches.map(item => item.Value));
                  }
                }
              }
            } else if (field.name === 'previousCoverageType' || field.label === 'Previous Policy Type') {
              // Log why the field wasn't processed
              if (field.type !== 'single-select') {
                console.warn('Field is not single-select type');
              }
              if (!hasInput) {
                console.warn('Field has no input value');
              }
              if (!Array.isArray(field.value) || field.value.length === 0) {
                console.warn('Field value array is empty or not an array');
              }
            }
          }
        }
        
        // Recursively process nested fieldGroups (pass the same Set to track processed fields)
        if ('fieldGroups' in fieldGroup && fieldGroup.fieldGroups) {
          this.normalizeSingleSelectValues(fieldGroup.fieldGroups, processedFields, currentPath);
        }
      }
    },
    // Direct method to check and normalize previousCoverageType field
    checkPreviousCoverageType() {
      try {
        const field = this.formInfo?.fieldGroups?.previousPolicyDetails?.fieldGroups?.ownDamagePolicyDetails?.fields?.previousCoverageType;
        
        if (!field) {
          console.error('previousCoverageType field not found');
          return null;
        }
      
        
        if (!Array.isArray(field.value) || field.value.length === 0) {
          console.warn('Field value array is empty or not an array');
          return null;
        }
        
        const inputValue = field.input ? String(field.input).trim() : '';
        if (!inputValue || inputValue === '') {
          console.warn('Field input is empty');
          return { input: '', matched: null, isMatch: false };
        }
        
        // Find matching option value (case-insensitive)
        const matchedOption = field.value.find(item => 
          item && item.Value && String(item.Value).trim().toLowerCase() === inputValue.toLowerCase()
        );
        
        if (matchedOption) {
          console.log('✓ Match found! Original:', inputValue, 'Normalized to:', matchedOption.Value);
          field.input = matchedOption.Value;
          return {
            input: inputValue,
            matched: matchedOption.Value,
            options: field.value.map(item => ({ Text: item?.Text, Value: item?.Value })),
            isMatch: true
          };
        } else {
          // Try to find partial matches
          const partialMatches = field.value.filter(item => 
            item && item.Value && String(item.Value).trim().toLowerCase().includes(inputValue.toLowerCase())
          );
          if (partialMatches.length > 0) {
            console.warn('Partial matches found:', partialMatches.map(item => item.Value));
          }
          return {
            input: inputValue,
            matched: null,
            options: field.value.map(item => ({ Text: item?.Text, Value: item?.Value })),
            isMatch: false
          };
        }
      } catch (error) {
        console.error('Error checking previousCoverageType:', error);
        return null;
      }
    },
    // Helper method to check if a field's input matches any value in its value array
    checkFieldInputMatch(fieldPath) {
      try {
        // Navigate to the field using the path
        const pathParts = fieldPath.split('.');
        let field = this.formInfo;
        
        for (const part of pathParts) {
          if (field && field[part] !== undefined) {
            field = field[part];
          } else {
            console.error('Field path not found:', fieldPath);
            return null;
          }
        }
        
        // Check if it's a single-select field
        if (field.type !== 'single-select') {
          console.warn('Field is not a single-select field:', fieldPath);
          return null;
        }
        
        // Get input value
        const inputValue = field.input ? String(field.input).trim() : '';
        
        // Check if value array exists
        if (!Array.isArray(field.value) || field.value.length === 0) {
          console.warn('Field value array is empty or not an array:', fieldPath);
          return null;
        }
        
        // Find matching option
        const matchedOption = field.value.find(item => 
          item && item.Value && String(item.Value).trim().toLowerCase() === inputValue.toLowerCase()
        );
        
        console.log('=== Field Input Match Check ===');
        console.log('Field Path:', fieldPath);
        console.log('Field Input:', inputValue);
        console.log('Available Options:', field.value.map(item => ({ Text: item?.Text, Value: item?.Value })));
        console.log('Match Found:', matchedOption ? matchedOption.Value : 'No match');
        
        return {
          input: inputValue,
          matched: matchedOption ? matchedOption.Value : null,
          options: field.value.map(item => ({ Text: item?.Text, Value: item?.Value })),
          isMatch: !!matchedOption
        };
      } catch (error) {
        console.error('Error checking field input match:', error);
        return null;
      }
    },
    getProposal() {

      console.log('||||||||||||||||||||')
      // this.loadingMessage = 'Please wait a moment while we verify details!';
      const isUploadDocRequired = sessionStorage.getItem('isUploadDocRequired') ? JSON.parse(sessionStorage.getItem('isUploadDocRequired')) : false;
      this.loadingState = true;
      this.loadingMsg="Fetching Proposal Details"
      var self = this;
      this.errMsg = "";
      let reqData = {
        productId: this.selectedPlan.insuranceAndProducts.productCode,
        manufacturerId:this.selectedPlan.insuranceAndProducts.insuranceCompanyCode,
        version: 1,
      };
      let headers = { Authorization: `Bearer ${this.$store.state.token}` };
      this.backendApi("getProposal", reqData, headers, "get")
        .then((response) => {
          this.loadingState = false;
          console.log("proposal response: ", response);

          if (response.status == "error") {
            let msg = [response.data.errors[0].errorDisplayMsg];
            this.errMsg = msg;
            // this.$router.push({ path: '/error-page', query: { backUrl, msg: msg } });
          } else if (response.data.errors.length > 0) {
            let msg = [];
            for (let i = 0; i < response.data.errors.length; i++) {
              msg.push(stripHtml(response.data.errors[i]["errorDisplayMessage"]));
            }
            // this.$router.push({ path: '/error-page', query: { backUrl, msgError: "We are facing some issue while fetching proposal data", reqId: response.data.reqId, msg: msg } });
            this.errMsg = msg;
          } else {
            if(this.isOvdAndFromDashboard && isUploadDocRequired){
              this.proposalFormGenerate(JSON.parse(sessionStorage.getItem("filledData")))
            }else{
              this.proposalFormGenerate(response.data.data);
            }
          }
        })
        .catch((error) => {
          this.loadingState=false;
          console.log("error msg block : get proposal", error);
          self.loading = false;
          // self.apiError = true;
          let msg = [
            "We are facing some issue from while fetching Proposal API",
          ];
          this.errMsg = msg;

          // this.$router.push({ path: '/error-page', query: {backUrl:'policy-quote', msg: msg }});
        });
    },
    checkArray(data) {
      return Array.isArray(data);
    },
    getSalutation2(gen) {
      if (gen == "Male") {
        return "mr";
      } else {
        let itemIndex = this.userData.memberList.findIndex(
          (item) => item.member == "Spouse"
        );
        if (itemIndex > -1) {
          return "mrs";
        } else {
          return "ms";
        }
      }
    },
    proposalFormGenerate(proposalForm) {

      console.log(788899998)
      const fromDashboard = JSON.parse(sessionStorage.getItem('fromDashboard'));
      const resumeFromDashboard = sessionStorage.getItem('resumeFromDashboard') ? JSON.parse(sessionStorage.getItem('resumeFromDashboard')) : false;
      let filledData = JSON.parse(sessionStorage.getItem("filledData"));
      this.proposalJson = proposalForm;
      this.formInfo = fromDashboard && this.selectedPlan.insuranceAndProducts.insuranceCompanyCode.startsWith("GO") ? filledData : this.proposalJson;
      // Removing traceInfo and distributer attriutes from proposal json visibility
      //delete this.proposalJson.fieldGroups.traceInfo;
      //delete this.proposalJson.fieldGroups.distributor;
      this.proposalJson.fieldGroups.traceInfo.visibility = "false";
      this.proposalJson.fieldGroups.distributor.visibility = "false";
      //console.log('after deleted traceinfo and distributer: ', this.formInfo);

      // Temprary update for test purpose
      let arr1 = [{ Text: "Maharastra", Value: "maharastra" }];
      let arr2 = [{ Text: "Indian", Value: "in" }];
      let arr3 = [{ Text: "Father", Value: "father" }];
      //this.proposalJson.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.state.value = arr1;
      //this.proposalJson.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.nationality.value = arr2;
      //this.proposalJson.fieldGroups.nomineeInfo.fields.nomineeRelationWithProposer.value = arr3;
      // End temprary update for test purpose
      if (!resumeFromDashboard && this.formInfo?.fieldGroups) {
        this.defaultData(this.formInfo.fieldGroups, this.formInfo, this.quoteInfo);
      }
      // Normalize single-select values to match option value cases
      this.normalizeSingleSelectValues(this.formInfo['fieldGroups']);
      for (var key in this.proposalJson.fieldGroups) {
        if (key != "traceInfo" && key != "distributor") {
          if (this.checkArray(this.proposalJson.fieldGroups[key])) {
            this.tabsArr.push(this.proposalJson.fieldGroups[key][0]["name"]);
          } else {
            this.tabsArr.push(this.proposalJson.fieldGroups[key]["name"]);
          }
        }
      }
      //console.log("this.tabsArr: ", this.tabsArr);
      //setting ckyc details
      let kycData = sessionStorage.getItem("kyc_response") ? JSON.parse(sessionStorage.getItem("kyc_response")) : "";
      let userType = JSON.parse(sessionStorage.getItem("user-type"));
      let vahanData = sessionStorage.getItem("vahanData") ? JSON.parse(sessionStorage.getItem("vahanData")) : "";

      if (kycData) {
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input'] = String(kycData['personalInformation']['gender']).charAt(0).toUpperCase() + String(kycData['personalInformation']['gender']).slice(1).toLowerCase();
        } catch (err) {
          console.log('kyc data title mapping error:', err);
        }
        this.setFullNameField();
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['firstName']['input'] = kycData['personalInformation']['firstName'];
        } catch (err) {
          console.log('kyc data firstName mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['middleName']['input'] = kycData['personalInformation']['middleName'];
        } catch (err) {
          console.log('kyc data middleName mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['lastName']['input'] = kycData['personalInformation']['lastName'];
        } catch (err) {
          console.log('kyc data lastName mapping error:', err);
        }
        // try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['mobileNumber']['input'] =  String(this.userData["mobileNumber"]);
        // } catch (err) {
        //   console.log('kyc data mobileNumber mapping error:', err);
        // }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['PAN']['input'] = kycData['personalInformation']['pan'];
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['PAN']['mandatory'] = this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['PAN']['input'] ? this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['PAN']['mandatory']: 1;
        } catch (err) {
          console.log('kyc data PAN mapping error:', err);
        }

        try {
          if(this.selectedPlan.insuranceAndProducts.insuranceCompanyCode.startsWith("GO")){
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['PAN']['mandatory'] = 1;
          }
        } catch (error) {
          console.log('kyc data PANNumber mandatory error:', err);
        }
        // try {
        //   this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input'] = this.userData.gender.toLowerCase();
        // } catch (err) {
        //   console.log('kyc data gender mapping error:', err);
        // }
        // this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] = this.getMaritalStatusForProposer(); PFM-8629

        // Mapping Corporate Details
        let hasCorporateDetails = this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails'];
        if(hasCorporateDetails != undefined){
          try {
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails']['fields']['panNumber']['input'] = this.userData["PANNumber"];
          } catch (err) {
            console.log('kyc data PANNumber mapping error:', err);
          }

          try {
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails']['fields']['dateOfEstablishment']['input'] = this.userData["dateOfBirth"];
          } catch (err) {
            console.log('kyc data dateOfBirth mapping error:', err);
          }
          try {
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails']['fields']['panNumber']['input'] = this.userData["PANNumber"];
          } catch (err) {
            console.log('kyc data dateOfBirth mapping error:', err);
          }
        }

        try {
          if(userType != 'corporate'){
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'] = this.getDateFormat(kycData?.personalInformation?.dateOfBirth);
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['mandatory']=this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'] ? this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['mandatory']:1
          }
        } catch (err) {
          console.log('kyc data dateOfBirth mapping error:', err);
          }
        try {
          if(userType != 'corporate' && kycData && kycData['personalInformation']['dateOfBirth']){
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['mandatory'] = 2;
          }
        } catch (error) {
          console.log('kyc data dateOfBirth mapping error:', err);
        }
        // Communication Address
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['address1']['input'] = kycData['communicationAddressDetails']['address1'];
        } catch (err) {
          console.log('kyc data address1 mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['address2']['input'] = kycData['communicationAddressDetails']['address2'];
        } catch (err) {
          console.log('kyc data address2 mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['address3']['input'] = kycData['communicationAddressDetails']['address3'];
        } catch (err) {
          console.log('kyc data address3 mapping error:', err);
        }
        try {
        if(kycData['communicationAddressDetails']['zipcode'] !=""){
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['zipCode']['input'] = kycData['communicationAddressDetails']['zipcode'];
        }
        else{
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['zipCode']['input'] = filledData != undefined && filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input!='' ? filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input : kycData['permanentAddressDetails']['zipcode'];
        }
        } catch (err) {
          console.log('kyc data zipCode mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['identificationDetails']['fields']['cKYCId']['input'] = kycData['kycInfo']['Manufacturer_KYC_Id'];
        } catch (err) {
          console.log('kyc data cKYCId mapping error:', err);
        }
        // Permanent Address
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address1']['input'] = kycData['permanentAddressDetails']['address1'];
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address1']['mandatory'] = this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address1']['input'] ? this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address1']['mandatory']:1
        } catch (err) {
          console.log('kyc data permanentAddressDetails address1 mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address2']['input'] = kycData['permanentAddressDetails']['address2'];
        } catch (err) {
          console.log('kyc data permanentAddressDetails address2 mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address3']['input'] = kycData['permanentAddressDetails']['address3'];
        } catch (err) {
          console.log('kyc data permanentAddressDetails address3 mapping error:', err);
        }
        try {
          if(kycData['permanentAddressDetails']['zipcode'] !=""){
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['zipCode']['input'] = kycData['permanentAddressDetails']['zipcode'];
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['zipCode']['input'] = kycData['permanentAddressDetails']['zipcode'];

          }
          else{
            // this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['zipCode']['input'] = this.userData["pinCode"];
            // if(this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['zipCode']['default']) {
            //       eval(this.getFinalObject(this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['zipCode']['default']));
            //     }
          }
        } catch (err) {
          console.log('kyc data permanentAddressDetails zipCode mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['cityDistrict']['input'] = kycData['permanentAddressDetails']['citydistrict'];
        } catch (err) {
          console.log('kyc data permanentAddressDetails cityDistrict mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['state']['input'] = kycData['permanentAddressDetails']['state'];
        } catch (err) {
          console.log('kyc data permanentAddressDetails state mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['sameAddress']['input'] = filledData.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.sameAddress.input ? filledData.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.sameAddress.input : '0';
        } catch (err) {
          console.log('kyc data permanentAddressDetails sameAddress mapping error:', err);
        }
        try {
          if (kycData.permanentAddressDetails.zipcode) {
            this.getPermanetAddressInfo(kycData.permanentAddressDetails.zipcode); 
          }
        } catch (err) {
          console.log('kyc data permanentAddressDetails sameAddress mapping error:', err);
        }
        if ((kycData['communicationAddressDetails']['zipcode'] || kycData['permanentAddressDetails']['zipcode']) && this.selectedPlan?.insuranceAndProducts?.insuranceCompanyCode == "RSGI") {
          this.getCommunicationState(kycData['permanentAddressDetails']['zipcode'])

            // this.getPincodeDetails(filledData!=undefined && filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input ? filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input : kycData['communicationAddressDetails']['zipcode']);
            // this.getPincodeDetails3(filledData!=undefined && filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input ? filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input : kycData['permanentAddressDetails']['zipcode']);
          }
          else{
            // this.getPincodeDetails(filledData!=undefined && filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input ? filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input : kycData['permanentAddressDetails']['zipcode']);
            // this.getPincodeDetails3(filledData.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input ? filledData.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input : kycData['permanentAddressDetails']['zipcode']);
            // this.getPincodeDetails3(filledData!=undefined && filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input ? filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input : kycData['permanentAddressDetails']['zipcode']);
        }

        // Setting Pin code section 
        // if (JSON.parse(sessionStorage.getItem("proposal_review_flag")) != '1') {
          // if (kycData['communicationAddressDetails']['zipcode']) {
          //   this.getPincodeDetails(kycData['communicationAddressDetails']['zipcode']);
          //   this.getPincodeDetails3(kycData['permanentAddressDetails']['zipcode']);
          // }
        // }
        
      }
      if (!resumeFromDashboard) {
        this.mapPreviousPolicyFields();
      }
      if(vahanData){
        let kycData = sessionStorage.getItem("kyc_response") ? JSON.parse(sessionStorage.getItem("kyc_response")) : "";
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fullName']['input'] = vahanData['personalInformation']['individualDetails'][0].fullName;
          if(kycData && (kycData?.personalInformation?.firstName || kycData?.personalInformation?.lastName || kycData?.personalInformation?.middleName)){
            this.setFullNameField();
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fullName']['mandatory'] = 2;
          }
        } catch (err) {
          console.log('Vahan Data fullName mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input'] = vahanData['personalInformation']['individualDetails'][0].gender;
        } catch (err) {
          console.log('Vahan Data gender mapping error:', err);
        }
        // try {
        //   this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address1']['input'] = vahanData['personalInformation']['individualDetails'][0].address1;
        // } catch (err) {
        //   console.log('Vahan Data address1 mapping error:', err);
        // }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] = vahanData['personalInformation']['individualDetails'][0].maritalStatus;
        } catch (err) {
          console.log('Vahan Data maritalStatus mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['zipCode']['input'] = vahanData['personalInformation']['individualDetails'][0].zipCode;
          this.getVahanAddress(vahanData['personalInformation']['individualDetails'][0].zipCode);
        } catch (err) {
          console.log('Vahan Data zipCode mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address1']['input'] = vahanData['personalInformation']['individualDetails'][0].address1;
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address2']['input'] = vahanData['personalInformation']['individualDetails'][0].address2;
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address3']['input'] = vahanData['personalInformation']['individualDetails'][0].address3;

          if(kycData && (kycData?.permanentAddressDetails?.address1 || kycData?.permanentAddressDetails?.address2 || kycData?.permanentAddressDetails?.address3)){
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address1']['input'] = kycData?.permanentAddressDetails?.address1;
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address2']['input'] = kycData?.permanentAddressDetails?.address2;
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['address3']['input'] = kycData?.permanentAddressDetails?.address3;
          }
        } catch (err) {
          console.log('Vahan Data address1 mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['address1']['input'] = vahanData['personalInformation']['individualDetails'][0].address1;
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['address2']['input'] = vahanData['personalInformation']['individualDetails'][0].address2;
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['address3']['input'] = vahanData['personalInformation']['individualDetails'][0].address3;
          if(kycData && (kycData?.communicationAddressDetails?.address1 || kycData?.communicationAddressDetails?.address2 || kycData?.communicationAddressDetails?.address3)){
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['address1']['input'] = kycData?.communicationAddressDetails?.address1;
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['address2']['input'] = kycData?.communicationAddressDetails?.address2;
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['address3']['input'] = kycData?.communicationAddressDetails?.address3;
          }
        } catch (err) {
          console.log('Vahan Data address1 mapping error:', err);
        }
        setTimeout(() => {
          this.mapVehicleData()
        }, 1000);
        setTimeout(() => {
          this.mapPreviousPlicyData()
        }, 1000);
      }
      try {
        this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['email']['input'] = this.userData?.email;
      } catch (err) {
        console.log('Email mapping error:', err);
      }

      const isUploadDocRequired = sessionStorage.getItem('isUploadDocRequired') ? JSON.parse(sessionStorage.getItem('isUploadDocRequired')) : false;
      const configData = this.$store.state.configData;
      const isOvd = configData["OVD_KYC"][this.selectedPlan.insuranceAndProducts.insuranceCompanyCode];
      // if( isUploadDocRequired && isOvd && isOvd==="PRE_PROPOSAL"){
      if( isUploadDocRequired){
        try {
          const panField = this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['PAN'];
          if (!panField['input']?.trim()) {
            panField['input'] = this.userData["PANNumber"];
          }
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['PAN']['mandatory'] = 1;
        } catch (err) {
          console.log('kyc data PANNumber mapping error:', err);
        }
      }

      try {
        if(this.selectedPlan.insuranceAndProducts.insuranceCompanyCode.startsWith("GO")){
          this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['PAN']['mandatory'] = 1;
        }
      } catch (error) {
        console.log('kyc data PANNumber mandatory error:', err);
      }

      let hasCorporateDetails = this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails'];
      let kycdataSession = JSON.parse(sessionStorage.getItem("kycdata"))
        if(hasCorporateDetails != undefined){
          try {
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails']['fields']['panNumber']['input'] = this.userData["PANNumber"];
          } catch (err) {
            console.log('kyc data PANNumber mapping error:', err);
          }

          try {
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['corporateDetails']['fields']['dateOfEstablishment']['input'] = kycdataSession["dateOfBirth"];
          } catch (err) {
            console.log('kyc data dateOfBirth mapping error:', err);
          }
        }
     
      


      // Setting up previously filled data
      // const userData =
      //   this.requestJson.personalInformation.individualDetails[0];

      // const addressData =
      //   this.proposalJson.fieldGroups.proposerDetails.fieldGroups
      //     .permanentAddressDetails.fields;
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "personalDetails"
      //   ]["fields"]["title"]["input"] = this.getSalutation2(
      //     this.userData.gender
      //   );
      // } catch (err) {
      //   console.log("landing page data mapping error for title:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "personalDetails"
      //   ]["fields"]["firstName"]["input"] = userData["firstName"]
      //     ? userData["firstName"]
      //     : this.userData["contactDetails"]["firstName"];
      // } catch (err) {
      //   console.log("landing page data mapping error for firstName:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "personalDetails"
      //   ]["fields"]["middleName"]["input"] = userData["middleName"]
      //     ? userData["middleName"]
      //     : this.userData["contactDetails"]["middleName"];
      // } catch (err) {
      //   console.log("landing page mapping error for middleName:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "personalDetails"
      //   ]["fields"]["lastName"]["input"] = userData["lastName"]
      //     ? userData["lastName"]
      //     : this.userData["contactDetails"]["lastName"];
      // } catch (err) {
      //   console.log("landing page mapping error for lastName:", err);
      // }

      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "personalDetails"
      //   ]["fields"]["dateOfBirth"]["input"] = userData["dateOfBirth"]
      //     ? userData["dateOfBirth"]
      //     : this.userData["contactDetails"]["dateOfBirth"];
      // } catch (err) {
      //   console.log("landing page mapping error for dob:", err);
      // }

      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "personalDetails"
      //   ]["fields"]["maritalStatus"]["input"] = userData["maritalStatus"]
      //     ? userData["maritalStatus"].toLowerCase()
      //     : this.userData["contactDetails"]["maritalStatus"];
      // } catch (err) {
      //   console.log("landing page mapping error for marital status:", err);
      // }

      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "personalDetails"
      //   ]["fields"]["mobileNumber"]["input"] = userData["mobileNumber"]
      //     ? userData["mobileNumber"].toString()
      //     : this.userData["contactDetails"]["mobileNumber"];
      // } catch (err) {
      //   console.log("landing page mapping error for mobileNumber:", err);
      // }
      // // Pan not avaiable
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "personalDetails"
      //   ]["fields"]["email"]["input"] = userData["email"]
      //     ? userData["email"]
      //     : this.userData["contactDetails"]["emailId"];
      // } catch (err) {
      //   console.log("landing page emailis mapping error for email:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "personalDetails"
      //   ]["fields"]["gender"]["input"] = userData.gender
      //     ? userData.gender.toLowerCase()
      //     : this.userData.gender.toLowerCase();
      // } catch (err) {
      //   console.log("landing page gender mapping error for gender:", err);
      // }

      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "communicationAddressDetails"
      //   ]["fields"]["address1"]["input"] = userData["address1"]
      //     ? userData["address1"]
      //     : addressData["address1"].input;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "communicationAddressDetails"
      //   ]["fields"]["address2"]["input"] = userData["address2"]
      //     ? userData["address2"]
      //     : addressData["address2"].input;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "communicationAddressDetails"
      //   ]["fields"]["address3"]["input"] = userData["address3"]
      //     ? userData["address3"]
      //     : addressData["address3"].input;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "communicationAddressDetails"
      //   ]["fields"]["zipCode"]["input"] = userData["zipCode"]
      //     ? userData["zipCode"]
      //     : addressData["zipCode"].input
      //     ? addressData["zipCode"]?.input
      //     : this.userData.pinCode;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "identificationDetails"
      //   ]["fields"]["cKYCId"]["input"] = userData["Manufacturer_KYC_Id"];
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // // Permanent Address
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "permanentAddressDetails"
      //   ]["fields"]["address1"]["input"] = userData["address1"]
      //     ? userData["address1"]
      //     : addressData["address1"].input;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "permanentAddressDetails"
      //   ]["fields"]["address2"]["input"] = userData["address2"]
      //     ? userData["address2"]
      //     : addressData["address2"].input;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "permanentAddressDetails"
      //   ]["fields"]["address3"]["input"] = userData["address3"]
      //     ? userData["address3"]
      //     : addressData["address3"].input;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "permanentAddressDetails"
      //   ]["fields"]["zipCode"]["input"] = userData["zipCode"]
      //     ? userData["zipCode"]
      //     : addressData["zipCode"].input;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "permanentAddressDetails"
      //   ]["fields"]["cityDistrict"]["input"] = userData["citydistrict"]
      //     ? userData["citydistrict"]
      //     : addressData["citydistrict"].input;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "permanentAddressDetails"
      //   ]["fields"]["state"]["input"] = userData["state"]
      //     ? userData["state"]
      //     : addressData["state"].input;
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }
      // try {
      //   this.formInfo["fieldGroups"]["proposerDetails"]["fieldGroups"][
      //     "permanentAddressDetails"
      //   ]["fields"]["sameAddress"]["input"] = "0";
      // } catch (err) {
      //   console.log("kyc data mapping error:", err);
      // }

      // if (this.userData.pinCode) {
      //   if (this.userData.pinCode) {
      //     this.getPincodeDetails(this.userData.pinCode);
      //     this.getPincodeDetails3(this.userData.pinCode);
      //     this.zipCodeInside = this.userData.pinCode;
        //   }
      // }

      let spdetail_flag = process.env.VUE_APP_SPDETAIL_ONESB;
      if (this.spDetails != null) {
        if (spdetail_flag == 1) {
          for (var attr in this.spDetails.attributes) {
            try {
              this.formInfo.fieldGroups.distributor.fields[attr].input = this.spDetails.attributes[attr];
            } catch (err) {
              console.log("SpDetails assignment failed", err);
            }
          }
          if (this.formInfo.fieldGroups.distributor.fields.agentCode) {
            this.formInfo.fieldGroups.distributor.fields.agentCode.input = this.spDetails.spCode;
          }
        }
      }
      const isPreFilled = getDistributer()['isPreFilled'];
      if(isPreFilled && this.$store.state.customerData){
        const customerData = this.$store.state.customerData;
        try {
          if(this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email){
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input = customerData.personalInformation.email;
          }
        } catch (error) { }

        try {
          if(this.formInfo.fieldGroups.nomineeInfo.fields.fullName){
            this.formInfo.fieldGroups.nomineeInfo.fields.fullName.input = `${customerData.nomineeDetails.firstName} ${customerData.nomineeDetails.middleName || ''} ${customerData.nomineeDetails.lastName}`.replace(/\s+/g, ' ').trim();

          }
        } catch (error) { }

        try {
          if(this.formInfo.fieldGroups.nomineeInfo.fields.dateOfBirth){
            this.formInfo.fieldGroups.nomineeInfo.fields.dateOfBirth.input = customerData.nomineeDetails.dateOfBirth;
          }
        } catch (error) { }

        try {
          if(this.formInfo.fieldGroups.nomineeInfo.fields.nomineeRelationWithProposer){
            this.formInfo.fieldGroups.nomineeInfo.fields.nomineeRelationWithProposer.input = customerData.nomineeDetails.relationship;
          }
        } catch (error) { }
      }
      let self = this;
      if (filledData) {
        if (this.productCode == filledData.productId) {
          let filledDataTab = JSON.parse(
            sessionStorage.getItem("filledDataTab")
          );

          for (var key in filledData.fieldGroups) {
            let data = filledData["fieldGroups"][key];

            // If Array
            if (this.checkArray(data)) {
              let subArray = filledData["fieldGroups"][key];
              for (var key_1 in subArray) {
                // If Fields
                if (subArray[key_1].fields) {
                  let fieldsArr = subArray[key_1].fields;
                  console.log("fieldsArr: ", fieldsArr);
                  for (var key_2 in fieldsArr) {
                    let data2 =
                      filledData["fieldGroups"][key][key_1]["fields"][key_2];
                  }
                }

                // If FieldGroups
                if (subArray[key_1].fieldGroups) {
                  //console.log('inside array fieldgroup');
                  for (var key_2 in subArray[key_1].fieldGroups) {
                    let fieldsArr = subArray[key_1].fieldGroups[key_2].fields;
                    //console.log("fieldsArr: ", fieldsArr);
                    for (var key_3 in fieldsArr) {
                      //console.log("inside fieldsArr");
                      let data3 =
                        filledData["fieldGroups"][key][key_1]["fieldGroups"][
                          key_2
                        ]["fields"][key_3];

                      if (data3.type == "multi-select") {
                        try {
                          this.formInfo["fieldGroups"][key][key_1][
                            "fieldGroups"
                          ][key_2]["fields"][key_3]["input"] =
                            filledData["fieldGroups"][key][key_1][
                              "fieldGroups"
                            ][key_2]["fields"][key_3]["input"];
                        } catch (err) {
                          console.log("error during assignment:", err);
                          //console.log("this.formInfo['fieldGroups'][" + key + "]['fieldGroups'][" + key2 + "]['fields'][" + key3 + "][input]: " + filledData['fieldGroups'][key]['fieldGroups'][key2]['fields'][key3]['input']);
                        }
                      } else if (data3.type == "single-select") {
                        try {
                          const formField = this.formInfo["fieldGroups"][key][key_1]["fieldGroups"][key_2]["fields"][key_3];
                          const filledInput = filledData["fieldGroups"][key][key_1]["fieldGroups"][key_2]["fields"][key_3]["input"];
                          const filteredData = (formField.value || []).filter((ele) => ele.Value === filledInput);
                          formField["input"] = filteredData && filteredData[0] && filteredData[0].Value ? filteredData[0].Value : "";
                        } catch (err) {
                          console.log("error during assignment:", err);
                        }
                      } else if (data3.type == "boolean") {
                        try {
                          this.formInfo["fieldGroups"][key][key_1][
                            "fieldGroups"
                          ][key_2]["fields"][key_3]["input"] =
                            filledData["fieldGroups"][key][key_1][
                              "fieldGroups"
                            ][key_2]["fields"][key_3]["input"];
                        } catch (err) {
                          console.log("error during assignment:", err);
                          //console.log("this.formInfo['fieldGroups'][" + key + "]['fieldGroups'][" + key2 + "]['fields'][" + key3 + "][input]: " + filledData['fieldGroups'][key]['fieldGroups'][key2]['fields'][key3]['input']);
                        }
                      } else if (data3.type == "number") {
                        try {
                          this.formInfo["fieldGroups"][key][key_1][
                            "fieldGroups"
                          ][key_2]["fields"][key_3]["input"] = parseInt(
                            filledData["fieldGroups"][key][key_1][
                              "fieldGroups"
                            ][key_2]["fields"][key_3]["input"]
                          );
                        } catch (err) {
                          console.log("error during assignment:", err);
                          //console.log("this.formInfo['fieldGroups'][" + key + "]['fieldGroups'][" + key2 + "]['fields'][" + key3 + "][input]: " + filledData['fieldGroups'][key]['fieldGroups'][key2]['fields'][key3]['input']);
                        }
                      } else if (data3.type == "currency") {
                        try {
                          console.log(
                            "currency in filled data",
                            filledData["fieldGroups"][key][key_1][
                              "fieldGroups"
                            ][key_2]["fields"][key_3]["input"]
                          );
                          this.formInfo["fieldGroups"][key][key_1][
                            "fieldGroups"
                          ][key_2]["fields"][key_3]["input"] =
                            new Intl.NumberFormat("en-IN").format(
                              parseInt(
                                filledData["fieldGroups"][key][key_1][
                                  "fieldGroups"
                                ][key_2]["fields"][key_3]["input"]
                              )
                            );
                        } catch (err) {
                          console.log("error during assignment:", err);
                          //console.log("this.formInfo['fieldGroups'][" + key + "]['fieldGroups'][" + key2 + "]['fields'][" + key3 + "][input]: " + filledData['fieldGroups'][key]['fieldGroups'][key2]['fields'][key3]['input']);
                        }
                      } else {
                        try {
                          this.formInfo["fieldGroups"][key][key_1][
                            "fieldGroups"
                          ][key_2]["fields"][key_3]["input"] =
                            filledData["fieldGroups"][key][key_1][
                              "fieldGroups"
                            ][key_2]["fields"][key_3]["input"];
                        } catch (err) {
                          console.log("error during assignment:", err);
                          //console.log("this.formInfo['fieldGroups'][" + key + "]['fieldGroups'][" + key2 + "]['fields'][" + key3 + "][input]: " + filledData['fieldGroups'][key]['fieldGroups'][key2]['fields'][key3]['input']);
                        }
                      }
                    }
                  }
                }
              }
            }
            // End : If Array

            if (data.fields) {
              for (var key2 in data.fields) {
                let data2 = filledData["fieldGroups"][key]["fields"][key2];
                if (data2.type == "multi-select") {
                  this.formInfo["fieldGroups"][key]["fields"][key2]["input"] =
                    filledData["fieldGroups"][key]["fields"][key2]["input"];
                } else if (data2.type == "single-select") {
                  try {
                    const formField = this.formInfo["fieldGroups"][key]["fields"][key2];
                    const filledInput = filledData["fieldGroups"][key]["fields"][key2]["input"];
                    const filteredData = (formField.value || []).filter((ele) => ele.Value === filledInput);
                    formField["input"] = filteredData && filteredData[0] && filteredData[0].Value ? filteredData[0].Value : "";
                  } catch (err) {
                    console.log("error during assignment:", err);
                  }
                } else if (data2.type == "boolean") {
                  this.formInfo["fieldGroups"][key]["fields"][key2]["input"] =
                    filledData["fieldGroups"][key]["fields"][key2]["input"];
                } else if (data2.type == "number" && key == "healthQuestions") {
                  this.formInfo["fieldGroups"][key]["fields"][key2]["input"] =
                    filledData["fieldGroups"][key]["fields"][key2]["input"];
                } else if (data2.type == "number") {
                  this.formInfo["fieldGroups"][key]["fields"][key2]["input"] =
                    parseInt(
                      filledData["fieldGroups"][key]["fields"][key2]["input"]
                    );
                } else if (data2.type == "currency") {
                  console.log(
                    "currency in filled data",
                    filledData["fieldGroups"][key]["fields"][key2]["input"]
                  );
                  this.formInfo["fieldGroups"][key]["fields"][key2]["input"] =
                    new Intl.NumberFormat("en-IN").format(
                      parseInt(
                        filledData["fieldGroups"][key]["fields"][key2]["input"]
                      )
                    );
                } else {
                  this.formInfo["fieldGroups"][key]["fields"][key2]["input"] =
                    filledData["fieldGroups"][key]["fields"][key2]["input"];
                }
              }
            }

            // fieldGroups
            if (data.fieldGroups) {
              for (var key2 in data.fieldGroups) {
                let data2 = filledData["fieldGroups"][key]["fieldGroups"][key2];
                for (var key3 in data2.fields) {
                  let data3 =
                    filledData["fieldGroups"][key]["fieldGroups"][key2][
                      "fields"
                    ][key3];
                  if (data3.type == "multi-select") {
                    try {
                      this.formInfo["fieldGroups"][key]["fieldGroups"][key2][
                        "fields"
                      ][key3]["input"] =
                        filledData["fieldGroups"][key]["fieldGroups"][key2][
                          "fields"
                        ][key3]["input"];
                    } catch (err) {
                      console.log("error during assignment:", err);
                      console.log(
                        "this.formInfo['fieldGroups'][" +
                          key +
                          "]['fieldGroups'][" +
                          key2 +
                          "]['fields'][" +
                          key3 +
                          "][input]: " +
                          filledData["fieldGroups"][key]["fieldGroups"][key2][
                            "fields"
                          ][key3]["input"]
                      );
                    }
                  } else if (data3.type == "single-select") {
                    try {
                      const formField = this.formInfo["fieldGroups"][key]["fieldGroups"][key2]["fields"][key3];
                      const filledInput = filledData["fieldGroups"][key]["fieldGroups"][key2]["fields"][key3]["input"];
                      const filteredData = (formField.value || []).filter((ele) => ele.Value === filledInput);
                      formField["input"] = filteredData && filteredData[0] && filteredData[0].Value ? filteredData[0].Value : "";
                    } catch (err) {
                      console.log("error during assignment:", err);
                    }
                  } else if (data3.type == "boolean") {
                    try {
                      this.formInfo["fieldGroups"][key]["fieldGroups"][key2][
                        "fields"
                      ][key3]["input"] =
                        filledData["fieldGroups"][key]["fieldGroups"][key2][
                          "fields"
                        ][key3]["input"];
                    } catch (err) {
                      console.log("error during assignment:", err);
                      console.log(
                        "this.formInfo['fieldGroups'][" +
                          key +
                          "]['fieldGroups'][" +
                          key2 +
                          "]['fields'][" +
                          key3 +
                          "][input]: " +
                          filledData["fieldGroups"][key]["fieldGroups"][key2][
                            "fields"
                          ][key3]["input"]
                      );
                    }
                  } else if (data3.type == "number") {
                    try {
                      this.formInfo["fieldGroups"][key]["fieldGroups"][key2][
                        "fields"
                      ][key3]["input"] = parseInt(
                        filledData["fieldGroups"][key]["fieldGroups"][key2][
                          "fields"
                        ][key3]["input"]
                      );
                    } catch (err) {
                      console.log("error during assignment:", err);
                      console.log(
                        "this.formInfo['fieldGroups'][" +
                          key +
                          "]['fieldGroups'][" +
                          key2 +
                          "]['fields'][" +
                          key3 +
                          "][input]: " +
                          filledData["fieldGroups"][key]["fieldGroups"][key2][
                            "fields"
                          ][key3]["input"]
                      );
                    }
                  } else if (data3.type == "currency") {
                    try {
                      console.log(
                        "currency in filled data",
                        filledData["fieldGroups"][key]["fieldGroups"][key2][
                          "fields"
                        ][key3]["input"]
                      );
                      this.formInfo["fieldGroups"][key]["fieldGroups"][key2][
                        "fields"
                      ][key3]["input"] = new Intl.NumberFormat("en-IN").format(
                        parseInt(
                          filledData["fieldGroups"][key]["fieldGroups"][key2][
                            "fields"
                          ][key3]["input"]
                        )
                      );
                    } catch (err) {
                      console.log("error during assignment:", err);
                      console.log(
                        "this.formInfo['fieldGroups'][" +
                          key +
                          "]['fieldGroups'][" +
                          key2 +
                          "]['fields'][" +
                          key3 +
                          "][input]: " +
                          filledData["fieldGroups"][key]["fieldGroups"][key2][
                            "fields"
                          ][key3]["input"]
                      );
                    }
                  } else {
                    try {
                      this.formInfo["fieldGroups"][key]["fieldGroups"][key2][
                        "fields"
                      ][key3]["input"] =
                        filledData["fieldGroups"][key]["fieldGroups"][key2][
                          "fields"
                        ][key3]["input"];
                    } catch (err) {
                      console.log("error during assignment:", err);
                      console.log(
                        "this.formInfo['fieldGroups'][" +
                          key +
                          "]['fieldGroups'][" +
                          key2 +
                          "]['fields'][" +
                          key3 +
                          "][input]: " +
                          filledData["fieldGroups"][key]["fieldGroups"][key2][
                            "fields"
                          ][key3]["input"]
                      );
                    }
                  }
                }

                // 333333
                // fieldGroups.fieldGroups
                if (data2.fieldGroups) {
                  for (var key3 in data2.fieldGroups) {
                    let data3 =
                      filledData["fieldGroups"][key]["fieldGroups"][key2][
                        "fieldGroups"
                      ][key3];
                    for (var key4 in data3.fields) {
                      let data4 =
                        filledData["fieldGroups"][key]["fieldGroups"][key2][
                          "fieldGroups"
                        ][key3]["fields"][key4];
                      if (data4.type == "multi-select") {
                        try {
                          this.formInfo["fieldGroups"][key]["fieldGroups"][
                            key2
                          ]["fieldGroups"][key3]["fields"][key4]["input"] =
                            filledData["fieldGroups"][key]["fieldGroups"][key2][
                              "fieldGroups"
                            ][key3]["fields"][key4]["input"];
                        } catch (err) {
                          console.log("error during assignment:", err);
                          console.log(
                            "this.formInfo['fieldGroups'][" +
                              key +
                              "]['fieldGroups'][" +
                              key2 +
                              "]['fields'][" +
                              key3 +
                              "]['fields'][" +
                              key4 +
                              "][input]" +
                              filledData["fieldGroups"][key]["fieldGroups"][
                                key2
                              ]["fieldGroups"][key3]["fields"][key4]["input"]
                          );
                        }
                      } else if (data4.type == "single-select") {
                        try {
                          const formField = this.formInfo["fieldGroups"][key]["fieldGroups"][key2]["fieldGroups"][key3]["fields"][key4];
                          const filledInput = filledData["fieldGroups"][key]["fieldGroups"][key2]["fieldGroups"][key3]["fields"][key4]["input"];
                          const filteredData = (formField.value || []).filter((ele) => ele.Value === filledInput);
                          formField["input"] = filteredData && filteredData[0] && filteredData[0].Value ? filteredData[0].Value : "";
                        } catch (err) {
                          console.log("error during assignment:", err);
                        }
                      } else if (data4.type == "boolean") {
                        try {
                          this.formInfo["fieldGroups"][key]["fieldGroups"][
                            key2
                          ]["fieldGroups"][key3]["fields"][key4]["input"] =
                            filledData["fieldGroups"][key]["fieldGroups"][key2][
                              "fieldGroups"
                            ][key3]["fields"][key4]["input"];
                        } catch (err) {
                          console.log("error during assignment:", err);
                          console.log(
                            "this.formInfo['fieldGroups'][" +
                              key +
                              "]['fieldGroups'][" +
                              key2 +
                              "]['fields'][" +
                              key3 +
                              "]['fields'][" +
                              key4 +
                              "][input]" +
                              filledData["fieldGroups"][key]["fieldGroups"][
                                key2
                              ]["fieldGroups"][key3]["fields"][key4]["input"]
                          );
                        }
                      } else if (data4.type == "number") {
                        try {
                          this.formInfo["fieldGroups"][key]["fieldGroups"][
                            key2
                          ]["fieldGroups"][key3]["fields"][key4]["input"] =
                            parseInt(
                              filledData["fieldGroups"][key]["fieldGroups"][
                                key2
                              ]["fieldGroups"][key3]["fields"][key4]["input"]
                            );
                        } catch (err) {
                          console.log("error during assignment:", err);
                          console.log(
                            "this.formInfo['fieldGroups'][" +
                              key +
                              "]['fieldGroups'][" +
                              key2 +
                              "]['fields'][" +
                              key3 +
                              "]['fields'][" +
                              key4 +
                              "][input]" +
                              filledData["fieldGroups"][key]["fieldGroups"][
                                key2
                              ]["fieldGroups"][key3]["fields"][key4]["input"]
                          );
                        }
                      } else if (data4.type == "currency") {
                        try {
                          console.log(
                            "inside currency filled data",
                            filledData["fieldGroups"][key]["fieldGroups"][key2][
                              "fieldGroups"
                            ][key3]["fields"][key4]["input"]
                          );
                          this.formInfo["fieldGroups"][key]["fieldGroups"][
                            key2
                          ]["fieldGroups"][key3]["fields"][key4]["input"] =
                            new Intl.NumberFormat("en-IN").format(
                              parseInt(
                                filledData["fieldGroups"][key]["fieldGroups"][
                                  key2
                                ]["fieldGroups"][key3]["fields"][key4]["input"]
                              )
                            );
                        } catch (err) {
                          console.log("error during assignment:", err);
                          console.log(
                            "this.formInfo['fieldGroups'][" +
                              key +
                              "]['fieldGroups'][" +
                              key2 +
                              "]['fields'][" +
                              key3 +
                              "]['fields'][" +
                              key4 +
                              "][input]" +
                              filledData["fieldGroups"][key]["fieldGroups"][
                                key2
                              ]["fieldGroups"][key3]["fields"][key4]["input"]
                          );
                        }
                      } else {
                        try {
                          this.formInfo["fieldGroups"][key]["fieldGroups"][
                            key2
                          ]["fieldGroups"][key3]["fields"][key4]["input"] =
                            filledData["fieldGroups"][key]["fieldGroups"][key2][
                              "fieldGroups"
                            ][key3]["fields"][key4]["input"];
                        } catch (err) {
                          console.log("error during assignment:", err);
                          console.log(
                            "this.formInfo['fieldGroups'][" +
                              key +
                              "]['fieldGroups'][" +
                              key2 +
                              "]['fields'][" +
                              key3 +
                              "]['fields'][" +
                              key4 +
                              "][input]" +
                              filledData["fieldGroups"][key]["fieldGroups"][
                                key2
                              ]["fieldGroups"][key3]["fields"][key4]["input"]
                          );
                        }

                        //this.formInfo['fieldGroups'][key]['fieldGroups'][key2]['fieldGroups'][key3]['fields'][key4]['input'] = filledData['fieldGroups'][key]['fieldGroups'][key2]['fieldGroups'][key3]['fields'][key4]['input'];
                      }
                    }
                  }
                }
                // 333333
              }
            }

            //}
          }

          if (filledDataTab) {
            //console.log('inside filled data tab', filledDataTab);
            setTimeout(function () {
              //self.activeTabAfterReload(filledDataTab);
              self.activeTab(filledDataTab);
              if(self.$route.query.process){
                self.activeTab(self.$route.query.process);
              }else{
                return;
              }
            }, 1000);
          }
        } else {
          // Removing previous data
          localStorage.removeItem("filledData");
          localStorage.removeItem("filledDataTab");
          sessionStorage.removeItem("filledData");
          sessionStorage.removeItem("filledDataTab");
        }
      }
      // End setting previously filled data

      // Setting traceinfo and distributor details section

      if (this.formInfo.fieldGroups.distributor.fields.distributorID) {
        this.formInfo.fieldGroups.distributor.fields.distributorID.input =
          this.distributorID;
      }
      try {
        if( this.formInfo.fieldGroups.vehicleDetails.fieldGroups.financierDetails.fields.vehicleHypothecation != undefined) {          
          this.formInfo.fieldGroups.vehicleDetails.fieldGroups.financierDetails.fields.vehicleHypothecation.input = filledData.fieldGroups.vehicleDetails.fieldGroups.financierDetails.fields.vehicleHypothecation.input;
          
          /* this.formInfo.fieldGroups.vehicleDetails.fieldGroups.financierDetails.fields.vehicleHypothecation.default = `formInfo['fieldGroups']['vehicleDetails']['fieldGroups']['financierDetails']['fields']['vehicleHypothecation']['input'] = '${filledData.fieldGroups.vehicleDetails.fieldGroups.financierDetails.fields.vehicleHypothecation.input}'` */
        }
      }catch (error) { }

      try {
        if( this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.ownershipTransfer != undefined) {          
          this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.ownershipTransfer.input= filledData.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.ownershipTransfer.input;
        }
      }catch (error) { }
      
      try {
        if( this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.prevZeroDep != undefined) {          
          this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.prevZeroDep.input = filledData.fieldGroups.previousPolicyDetails.fieldGroups.previousPolicyQuestions.fields.prevZeroDep.input;
          // this.requestProposalQuote = JSON.parse(sessionStorage.getItem("quote_request"));
          // this.requestProposalQuote.product.motorCovers = this.requestProposalQuote.product.motorCovers.filter(cover => cover.optionSelected != 'zeroDep');   
          // sessionStorage.setItem("quote_request_proposal",JSON.stringify(this.requestProposalQuote));
        }
      }catch (error) { }
      //console.log(" this.formInfo.fieldGroups.distributor.fields.agentCode.input", this.formInfo.fieldGroups.distributor.fields.agentCode.input)
      /* if (this.formInfo.fieldGroups.distributor.fields.agentCode) {
        this.formInfo.fieldGroups.distributor.fields.agentCode.input =
          this.agentCode;
      } */
      // End mofification
      if(!kycData){
        try {
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.mandatory = 1;
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.mandatory = 1;
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.address1.mandatory = 1;
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.mandatory = 1;
          try {
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['sameAddress']['input'] = filledData.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.sameAddress.input ? filledData.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.sameAddress.input : '0';
          } catch (err) {
            console.log('kyc data permanentAddressDetails sameAddress mapping error:', err);
          }
          let kycdata = "";
          let kycResponse = "";
          if(sessionStorage.getItem("kycdata")){
            kycdata = JSON.parse(sessionStorage.getItem("kycdata"));
          }
          if(sessionStorage.getItem("kyc_response")){
            kycResponse = JSON.parse(sessionStorage.getItem("kyc_response"));
          }
          if(kycdata){
            if(userType != 'corporate'){
              this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input = kycdata.dateOfBirth;
            }
          }
          if(userType != 'corporate' && kycResponse && kycResponse?.personalInformation.dateOfBirth){
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.mandatory = 2;
          }
        } catch (error) {
          
        }
      }
      try {
        if(!kycData?.permanentAddressDetails.address1 && !vahanData){
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.address1.mandatory = 1;
        }
      } catch (error) {}
      if(!kycdata  && !vahanData && !filledData.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.sameAddress.input){
        try {
            this.formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['sameAddress']['input'] = '1';
          } catch (err) {
            console.log('kyc data permanentAddressDetails sameAddress mapping error:', err);
          }
      }
      try {
        this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.mobileNumber.max = 10;
      } catch (error) {
        console.log('Max Length set up error for mobile number', err);
      }
      try {
        this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.max = 6;
        this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.max = 6;
      } catch (error) {
        console.log('Max Length set up error for Zip Code', err);
      }
      if(!kycData?.permanentAddressDetails.address1){
        this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.address1.mandatory = 1;
      }
      let userData = JSON.parse(sessionStorage.getItem("userData"));
      if(userData.regNumber){
        this.formInfo.fieldGroups.vehicleDetails.fieldGroups.makeModelVariantDetails.fields.vehicleNumber.input = userData.regNumber;
      }
      let apiReqData = JSON.parse(sessionStorage.getItem("quote_request"));
      let kycdata = JSON.parse(sessionStorage.getItem("kycdata"));
      
      if(kycdata && apiReqData.personalInformation.individualDetails[0].ownerBelongsToOrganizationFlag == true){
        if(filledData && filledData.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input != ''){
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input = filledData.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input
        }else{
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input = ""
        }
        // this.formInfo.fieldGroup.saveProposalDetails
        this.formInfo.fieldGroups.proposerDetails.fieldGroups.corporateDetails.fields.dateOfEstablishment.input = kycdata.dateOfBirth;
        this.formInfo.fieldGroups.proposerDetails.fieldGroups.corporateDetails.fields.panNumber.input = kycdata.panNumber;
      }
      try {
        if(filledData && filledData.fieldGroups.previousPolicyDetails.fieldGroups?.ownDamagePolicyDetails?.fields?.isTPDetailsSameAsODDetails){
          this.formInfo['fieldGroups']['previousPolicyDetails']['fieldGroups']['ownDamagePolicyDetails']['fields']['isTPDetailsSameAsODDetails']['input'] = filledData.fieldGroups.previousPolicyDetails.fieldGroups?.ownDamagePolicyDetails?.fields?.isTPDetailsSameAsODDetails.input;
        }
      } catch (err) {
        console.log('Is Third Party Policy Details is same as Own Damage Policy Details error:', err);
      }
      // if(this.isOvdAndFromDashboard){
      //   this.formInfo = JSON.parse(sessionStorage.getItem("filledData"));
      // }
      this.$nextTick(() => {
        this.adoptRestoredFinancierSelection();
      });
      setTimeout(() => {
        this.adoptRestoredFinancierSelection();
      }, 1150);
    },
    mapVehicleData(){
      let vahanData = sessionStorage.getItem("vahanData") ? JSON.parse(sessionStorage.getItem("vahanData")) : "";
      try {
          this.formInfo.fieldGroups.vehicleDetails.fieldGroups.makeModelVariantDetails.fields.vehicleEngineNumber.input = vahanData.vehicleDetails.vehicleEngineNumber;
        } catch (err) {
          console.log('Vahan Data vehicleEngineNumber mapping error:', err);
        }
        try {
          this.formInfo['fieldGroups']['vehicleDetails']['fieldGroups']['makeModelVariantDetails']['fields']['vehicleChassisNumber']['input'] = vahanData['vehicleDetails'].vehicleChassisNumber;
        } catch (err) {
          console.log('Vahan Data vehicleChassisNumber mapping error:', err);
        }
        try {
          const fd = vahanData && typeof vahanData === "object" ? vahanData.financierDetails : null;
          if (fd) {
            const vName = fd.financierName != null ? String(fd.financierName).trim() : "";
            this.formInfo["fieldGroups"]["vehicleDetails"]["fieldGroups"]["financierDetails"]["fields"]["vehicleHypothecation"]["input"] = vName ? "1" : "0";
            if (vName) {
              this.formInfo["fieldGroups"]["vehicleDetails"]["fieldGroups"]["financierDetails"]["fields"]["financierType"]["input"] =
                fd.financierType != null ? String(fd.financierType) : "";
              this.selectedFinancier = vName;
              this.formInfo["fieldGroups"]["vehicleDetails"]["fieldGroups"]["financierDetails"]["fields"]["financierName"]["input"] = vName;
              if (!this.responsebank.includes(vName)) {
                this.responsebank.push(vName);
              }
            }
          }
        } catch (err) {
          console.log("Vahan Data financierDetails mapping error:", err);
        }
        this.financierSearchReturnedEmpty = false;
    },
    mapPreviousPolicyFields(){
      let prevPolicyType = this.userData?.prevPolicyType;
      let prevInsurerName = this.userData?.prevInsurerName;
      try {
        this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousCoverageType.input = prevPolicyType;

        this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input = prevInsurerName;
        
        // Normalize single-select values after mapping
        this.$nextTick(() => {
          this.normalizeSingleSelectValues(this.formInfo['fieldGroups']);
          // Also check the specific field directly
          this.checkPreviousCoverageType();
        });
      } catch (error) {
        console.error('Error in mapPreviousPolicyFields:', error);
      }
    },
    mapPreviousPlicyData(){
      let vahanData = sessionStorage.getItem("vahanData") ? JSON.parse(sessionStorage.getItem("vahanData")) : "";
      const ownDamageFields = this.formInfo?.fieldGroups?.previousPolicyDetails?.fieldGroups?.ownDamagePolicyDetails?.fields;
      if (!ownDamageFields) return;

      const applyMandatoryFromInput = (fieldKey) => {
        const field = ownDamageFields[fieldKey];
        if (!field) return;
        if (field.input && field.mandatory == '1') {
          field.mandatory = 2;
        } else if (field.input) {
          field.mandatory = 3;
        } else {
          // No input: keep field enabled and required
          field.mandatory = 1;
        }
      };

      try {
        const resolveCoverageTypeInput = (raw) => {
          if (raw == null || String(raw).trim() === '') return '';
          const opts = ownDamageFields.previousCoverageType?.value;
          if (!Array.isArray(opts) || opts.length === 0) return String(raw).trim();
          const normalized = String(raw).trim().toLowerCase();
          const byValue = opts.find(o => o?.Value && String(o.Value).trim().toLowerCase() === normalized);
          if (byValue) return byValue.Value;
          const byText = opts.find(o => o?.Text && String(o.Text).trim().toLowerCase() === normalized);
          if (byText) return byText.Value;
          return String(raw).trim();
        };
        const vahanCovType = vahanData?.previousPolicyDetails?.previousCoverageType;
        const hasVahanCovType = vahanCovType != null && String(vahanCovType).trim() !== '';
        const existingCovType =
          ownDamageFields.previousCoverageType?.input || this.userData?.prevPolicyType || '';
        const rawCovType = hasVahanCovType ? vahanCovType : existingCovType;
        if (rawCovType != null && String(rawCovType).trim() !== '') {
          ownDamageFields.previousCoverageType.input = resolveCoverageTypeInput(rawCovType);
        }
        applyMandatoryFromInput('previousCoverageType');
      } catch (err) {
        console.log('Vahan Data previousCoverageType mapping error:', err);
      }
      try {
        ownDamageFields.previousPolicyNumber.input = vahanData.previousPolicyDetails?.previousPolicyNumber ?? '';
        applyMandatoryFromInput('previousPolicyNumber');
      } catch (err) {
        console.log('Vahan Data previousPolicyNumber mapping error:', err);
      }
      try {
        const value = ownDamageFields.previousPolicyInsurer.value.filter((ele) => {
          return ele.Value.toLowerCase() == vahanData?.previousPolicyDetails?.previousPolicyInsurer?.toLowerCase();
        });
        ownDamageFields.previousPolicyInsurer.input = value && value.length > 0 ? value[0]['Value'] : '';
        applyMandatoryFromInput('previousPolicyInsurer');
      } catch (err) {
        console.log('Vahan Data previousPolicyInsurer mapping error:', err);
      }
      
      // Normalize single-select values after mapping data
      this.$nextTick(() => {
        this.normalizeSingleSelectValues(this.formInfo['fieldGroups']);
        this.checkPreviousCoverageType();
      });
    },
    getDateFormat(dt) {
      if(dt) {
        let arr = dt.split("-");
        if(arr[2].length > 2) {
          return arr['2']+'-'+arr['1']+'-'+arr['0'];
        } else {
          return dt;
        }
      } else {
        return "";
      }
    },
    getVahanAddress(pinCode){
      this.loadingMsg="Fetching Pincode Details"
      var headers = {
        Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
        "Content-Type": "application/json",
      };
      this.isPinCodePending = true;
      let reqData = [pinCode];
      this.backendApi("getPincodeInfo", reqData, headers, "get")
        .then((response) => {
          this.loadingState = false;
          if (response == "error") {
            this.isPinCodePending = false;
          } else if (response && response.data) {
            this.isPinCodePending = false;
            let v = response?.data?.data[0];
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.cityDistrict.input = v?.city;
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.state.input = v?.state;
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.nationality.input = v?.country.toUpperCase();
          }
        })
    },
    getPincodeDetails(pincode) {
      if(this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.sameAddress.input) return;
      // this.loadingState = true;
      this.loadingMsg="Fetching Pincode Details"
      //console.log('getPincodeDetails called: ', pincode);
      var headers = {
        Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
        "Content-Type": "application/json",
      };
      let reqData = [pincode];
      this.isPinCodePending = true;
      //this.loading = true;
      this.backendApi("getPincodeInfo", reqData, headers, "get")
        .then((response) => {
          this.loadingState = false;
          if (response == "error") {
            //this.apiError = true;
            this.isPinCodePending = false;
            console.log("pincode api error: block");
          } else if (response && response.data) {
            this.isPinCodePending = false;
            //console.log('pincode response: ', response.data.data);
            let v = response?.data?.data[0];
            sessionStorage.setItem("pincode_data", JSON.stringify(v));
            // Setting Pincode Data
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input =
              pincode;
            // this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.cityDistrict.input =
            //   v?.city;
            // this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.state.input =
            //   v?.state;
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.nationality.input =
            v?.country.toUpperCase();
            // this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.nationality.input =
            //   v?.country.toUpperCase();
          }
        })
        .catch((error) => {
          this.loadingState=false;
          console.log("error msg block getting pincode info", error);
          //this.loading = false;
          //this.apiError = true;
        });
    },
    getPermanetAddressInfo(pinCode){
      // this.loadingState = true;
      this.loadingMsg="Fetching Pincode Details"
      var headers = {
        Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
        "Content-Type": "application/json",
      };
      this.isPinCodePending = true;
      let reqData = [pinCode];
      this.backendApi("getPincodeInfo", reqData, headers, "get")
      .then((response) => {
        this.loadingState = false;
        if (response == "error") {
          this.isPinCodePending = false;
          console.log("pincode api error: block");
        } else if (response && response.data) {
          this.isPinCodePending = false;
          let v = response?.data?.data[0];
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.nationality.input = v?.country.toUpperCase();
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.state.input = v?.state;
          this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.cityDistrict.input = v?.city;

          // this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.nationality.input = v?.country.toUpperCase();
          // this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.state.input = v?.state;
          // this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.cityDistrict.input = v?.city;
        }
      })
      .catch((error) => {
        this.loadingState=false;
        console.log("error msg block getting pincode info", error);
      });
    },
    getPincodeDetails3(pincode) {
      if(this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.sameAddress.input) return;

      // this.loadingState = true;
      this.loadingMsg="Fetching Pincode Details"
      let pinCodeInPermanentAddress = JSON.parse(sessionStorage.getItem("kyc_response"));
      let filledData = JSON.parse(sessionStorage.getItem("filledData"));
      //console.log('getPincodeDetails called: ', pincode);
      var headers = {
        Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
        "Content-Type": "application/json",
      };
      let reqData = [pincode];
      this.isPinCodePending = true;
      //this.loading = true;
      this.backendApi("getPincodeInfo", reqData, headers, "get")
        .then((response) => {
          this.loadingState = false;
          //this.loading = false;
          if (response == "error") {
            //this.apiError = true;
            this.isPinCodePending = false;
            console.log("pincode api error: block");
          } else if (response && response.data) {
            //console.log('pincode response: ', response.data.data);
            this.isPinCodePending = false;
            let v = response?.data?.data[0];
            sessionStorage.setItem("pincode_data", JSON.stringify(v));
            // Setting Pincode Data
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input = filledData != undefined && filledData.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input!='' ? filledData.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input : pinCodeInPermanentAddress.permanentAddressDetails.zipcode;
            
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input = filledData != undefined && filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input!='' ? filledData.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input : pinCodeInPermanentAddress.permanentAddressDetails.zipcode;
            
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.cityDistrict.input = pinCodeInPermanentAddress.communicationAddressDetails.citydistrict ? pinCodeInPermanentAddress.communicationAddressDetails.citydistrict : v?.city;

            if(pinCodeInPermanentAddress.permanentAddressDetails.zipcode){
              this.getCommunicationState(pinCodeInPermanentAddress.permanentAddressDetails.zipcode);
            }
            // this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.cityDistrict.input =
            //   v?.city;
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.state.input =
              v?.state;
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.nationality.input =
              v?.country.toUpperCase();
          }
        })
        .catch((error) => {
          this.loadingState=false;
          console.log("error msg block getting pincode info", error);
          //this.loading = false;
          //this.apiError = true;
        });
    },
    getCommunicationState(zipcode){
      var headers = {
        Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
        "Content-Type": "application/json",
      };
      let reqData = [zipcode];
      let v;
      this.isPinCodePending = true;
      this.backendApi("getPincodeInfo", reqData, headers, "get")
        .then((response) => {
          if (response == "error") {
            this.isPinCodePending = false;
          } else if (response && response.data) {
            v = response?.data?.data[0];
            this.isPinCodePending = false;
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.nationality.input = v.country.toUpperCase();
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.state.input = v.state;
            this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.cityDistrict.input = v.district;
          }
        })
    },
    checkVisibility(value) {
      //console.log("check Visibility called: ", value);
      // default expression evalutiona added along with visibility
      if (value) {
        let obj = this.getFinalObject(value);
        try {
          console.log('eval: ', eval(obj));
          return eval(obj);
        } catch (err) {
          console.log("error visibility exp: ", value);
        }
      } else {
        return true;
      }
    },
    activePage(val) {
      if (val == "proposerDetails") {
        return "active";
      } else {
        return "disabled";
        //return "";
      }
    },
    async activeNextTab(currentTab) {
        console.log("active next tab called", this.tabsArr);
        let ckk = this.checkVisibility(this.formInfo['fieldGroups'][currentTab]['visibility']);
        if(ckk == true) {
          // Setting Up Filled Tab on localstorage
          let filledDataTab=""
          if(sessionStorage.getItem("filledDataTab"))
          {
            filledDataTab = sessionStorage.getItem("filledDataTab")
          }
          if(this.tabsArr.indexOf(currentTab) ==0 && !filledDataTab)
          {
            localStorage.setItem("filledDataTab", JSON.stringify(currentTab));
            sessionStorage.setItem("filledDataTab", JSON.stringify(currentTab));
          }
          else if(this.tabsArr.indexOf(currentTab)>=this.tabsArr.indexOf(filledDataTab))
          {
            localStorage.setItem("filledDataTab", JSON.stringify(currentTab));
            sessionStorage.setItem("filledDataTab", JSON.stringify(currentTab));
          }
       
          localStorage.setItem("filledData", JSON.stringify(this.formInfo));
          sessionStorage.setItem("filledData", JSON.stringify(this.formInfo)); 
        }
  
        var tabIndex = this.tabsArr.indexOf(currentTab);
        let nextTab;
        //console.log('tab index: ', tabIndex)
        if (tabIndex < this.tabsArr.length - 1) {
          nextTab = this.tabsArr[tabIndex + 1];
          console.log('next tab: ', nextTab);
        } else {
          // If conntrol is on last tab
          console.log("inside: conntrol is on last tab");
          const configData = this.$store.state.configData;
          const isReQuote = configData['RE_QUOTE'];
          console.log('this.selectedPlan.insuranceAndProducts.insuranceCompanyCode', this.selectedPlan.insuranceAndProducts.insuranceCompanyCode);
          if(isReQuote && isReQuote[this.selectedPlan.insuranceAndProducts.insuranceCompanyCode] && isReQuote[this.selectedPlan.insuranceAndProducts.insuranceCompanyCode].toLowerCase() == "yes"){
            await this.getSingleQuote();
          }
          const isUploadDocRequired = sessionStorage.getItem('isUploadDocRequired') ? JSON.parse(sessionStorage.getItem('isUploadDocRequired')) : false;
          const isOvd = configData["OVD_KYC"][this.selectedPlan.insuranceAndProducts.insuranceCompanyCode];
          if (shouldSkipGodigitKycOvd(this.selectedPlan)) {
            sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
            if (this.channel_type == "B2C") {
              this.$router.push('/confirm-payment-diy')
            } else {
              this.$router.push('/confirm-payment')
            }
          } else if (isUploadDocRequired && isOvd && isOvd === "PRE_PROPOSAL") {
            this.$router.push('/upload-ovds');
          }else if(this.channel_type == "B2C") {
            this.$router.push('/confirm-payment-diy')
          }else{
            this.$router.push('/confirm-payment')
          }
        }
        if (nextTab) {
          this.activeTab(nextTab);
        }
      },
    async getSingleQuote() {
      try {
        let kycData = sessionStorage.getItem("kyc_response") ? JSON.parse(sessionStorage.getItem("kyc_response")) : "";
        this.loadingState = true;
        this.loadingMsg = "Reinitilizing the Quote..."
        this.apiReqData = JSON.parse(sessionStorage.getItem("quote_request"));
          if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input || this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input) {
            this.apiReqData.personalInformation.individualDetails[0].zipCode = this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input ? this.formInfo.fieldGroups.proposerDetails.fieldGroups.communicationAddressDetails.fields.zipCode.input:this.formInfo.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input
          }
        if(this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName!=undefined && !this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName.input){
          if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input) {
            this.apiReqData.personalInformation.individualDetails[0].firstName = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input
          }
          if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input) {
            this.apiReqData.personalInformation.individualDetails[0].middleName = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName.input
          }
          if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input) {
            this.apiReqData.personalInformation.individualDetails[0].lastName = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input
          }
        }else{
          if(kycData && kycData.personalInformation){
            this.apiReqData.personalInformation.individualDetails[0].firstName = kycData.personalInformation.firstName
            this.apiReqData.personalInformation.individualDetails[0].middleName = kycData.personalInformation.middleName
            this.apiReqData.personalInformation.individualDetails[0].lastName = kycData.personalInformation.lastName
          }
        }
        if (!kycData || !kycData.personalInformation) {
          const fullName = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName.input;
          const nameParts = fullName.trim().split(/\s+/); // split on one or more spaces

          const firstName = nameParts[0] || '';
          const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : '';
          const middleName = nameParts.length > 2 ? nameParts.slice(1, -1).join(' ') : '';

          this.apiReqData.personalInformation.individualDetails[0].firstName = firstName;
          this.apiReqData.personalInformation.individualDetails[0].middleName = middleName;
          this.apiReqData.personalInformation.individualDetails[0].lastName = lastName;
        }
        
        if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.gender.input) {
          this.apiReqData.personalInformation.individualDetails[0].gender = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.gender.input
        }
        if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input) {
          this.apiReqData.personalInformation.individualDetails[0].dateOfBirth = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input
        }
        if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input) {
          this.apiReqData.personalInformation.individualDetails[0].email = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input
        }
        // 
        if (this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyEndDate = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
        }
        if (this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyInsurer = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
        }
        if (this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyNumber = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
        }
        if (this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyOdExpiryDate = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
        }

        if (this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyInsurer = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
        }

        if (this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyOdNumber = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
        }
        // if (this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input) {
        //   this.apiReqData.product.previousPolicyDetails.previousPolicyTpExpiryDate = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
        // }
        if (this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyTpInsurer = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
        }
        if (this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input) {
          this.apiReqData.product.previousPolicyDetails.previousPolicyTpNumber = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
        }
        this.apiReqData.product.previousPolicyDetails.previousCoverageType = this.formInfo.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousCoverageType.input;
        this.apiReqData.product.registrationDetails.registrationNumber = this.$store.state.quoteCategory !== 'New' ? this.formInfo.fieldGroups.vehicleDetails.fieldGroups.makeModelVariantDetails.fields.rtoCode.input + this.formInfo.fieldGroups.vehicleDetails.fieldGroups.makeModelVariantDetails.fields.vehicleNumber.input : 'New';
        
        // this.apiReqData.personalInformation.individualDetails[0].fullName = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName.input;
        this.setNCBDetails();
        this.setMotorProducts();

        if(this.quoteCategory == "New"){
          delete this.apiReqData.product.ncbDetails.claimLastYearFlag;
          this.apiReqData.product.ncbDetails.numberOfClaims = 0;
        }
        let userType = JSON.parse(sessionStorage.getItem("user-type"));
        if(userType=='corporate'){
          this.apiReqData.product.motorCovers = this.apiReqData.product.motorCovers.filter(cover => cover.optionSelected != 'paCvr');
        }

        const response = await this.backendApi("quotationApi", this.apiReqData, { "Authorization": `Bearer ${this.$store.state.token}` }, "post");
        sessionStorage.setItem("quote_request", JSON.stringify(this.apiReqData));
        if (response.data.errors.length > 0) {
          this.displayApiErrosOnUI = []
          this.loadingState = false;

          const msg = [];
          for (let i = 0; i < response.data.errors.length; i++) {
            msg.push(stripHtml(response.data.errors[i]["errorDisplayMessage"]))
          }
          console.log("Errors in Response", msg);
          this.displayApiErrosOnUI.push(msg);
        } else if (response && response.data) {

          this.requestId = response.data.reqId;
          if (response?.data?.data?.quote?.length > 0) {
            console.log("inside loop for")
            this.responseData.push(response.data.data.quote);
          }
          if (response.data.errors.length == 0) {
            await this.getMotorProduct();
          }
          else {
            console.log("inside else case")
            this.loadingState = false;
            if (this.responseData.length == 0) {
              this.erMsg = 'No products found as per your selected filter. Please change the filters.';
            }
          }
        }
      } catch (error) {
        console.log('error msg block dp', error);
        const msg = "Service is Unavailable, Please try again later.";
        this.displayApiErrosOnUI.push(msg);
      }
    },
    async getMotorProduct() {
      this.loadingState = true;
      const startTime = Date.now();
      const maxPollingTime = 3 * 60 * 1000;
      let headers = { "Authorization": `Bearer ${this.$store.state.token}` };
      let reqData = [this.requestId];

      while (this.pollapiflag && (Date.now() - startTime) < maxPollingTime) {
        try {
          const response = await this.backendApi("quotationPoll", reqData, headers, "get");
          if (response.data.errors.length > 0) {
            this.loading = false;
            this.loadingState = false;
            const msg = [];
            for (let i = 0; i < response.data.errors.length; i++) {
              msg.push(stripHtml(response.data.errors[i]["errorDisplayMessage"]))
            }
            this.displayApiErrosOnUI.push(msg);
            return;
          }
          if (response?.data?.data?.quote?.length > 0) {
            this.suggestedIDV = response?.data?.data?.quote[0].supportingData.insuredDeclaredValue.suggestedIDV;
            this.responseData = response.data.data.quote;
            sessionStorage.setItem("quoteSingleData", JSON.stringify(this.responseData))
          }
          if (response.data.data.isPollComplete == true) {
            this.uniqueQuoteId = response.data.data.quote[0].trackInfo.manufacturerQuoteID;
            this.updatedPlanData = response.data.data.quote[0];
            sessionStorage.setItem("selected_plan_data", JSON.stringify(this.updatedPlanData));
            const isUploadDocRequired = sessionStorage.getItem('isUploadDocRequired') ? JSON.parse(sessionStorage.getItem('isUploadDocRequired')) : false;
            const configData = this.$store.state.configData;
            const isOvd = configData["OVD_KYC"][this.selectedPlan.insuranceAndProducts.insuranceCompanyCode];
            const planForSkip = this.updatedPlanData || this.selectedPlan;
            if (shouldSkipGodigitKycOvd(planForSkip)) {
              sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
              if ((this.updatedPlanData.productDetails.totalPremiumDetails[0].totalPremiumWithTax !== this.selectedPlan.productDetails.totalPremiumDetails[0].totalPremiumWithTax) || (this.updatedPlanData.productDetails.inspectionDetails.isInspectionRequired !== this.selectedPlan.productDetails.inspectionDetails.isInspectionRequired)) {
                this.verifyPremiumFlag = true;
                this.loadingState = false;
                this.pollapiflag = false;
                return;
              }
              if (this.channel_type == "B2C") {
                this.$router.push('/confirm-payment-diy')
              } else {
                this.$router.push('/confirm-payment')
              }
            } else if (isUploadDocRequired && isOvd && isOvd === "PRE_PROPOSAL") {
              if ((this.updatedPlanData.productDetails.totalPremiumDetails[0].totalPremiumWithTax !== this.selectedPlan.productDetails.totalPremiumDetails[0].totalPremiumWithTax) || (this.updatedPlanData.productDetails.inspectionDetails.isInspectionRequired !== this.selectedPlan.productDetails.inspectionDetails.isInspectionRequired)) {
                this.verifyPremiumFlag = true;
                this.loadingState = false;
                this.pollapiflag = false;
                return;
              }else{
                this.$router.push('/upload-ovds');
              }
            } else if(isUploadDocRequired && isOvd && isOvd === "REDIRECT"){
              await this.getCkycDetails();
            } else {
              if ((this.updatedPlanData.productDetails.totalPremiumDetails[0].totalPremiumWithTax !== this.selectedPlan.productDetails.totalPremiumDetails[0].totalPremiumWithTax) || (this.updatedPlanData.productDetails.inspectionDetails.isInspectionRequired !== this.selectedPlan.productDetails.inspectionDetails.isInspectionRequired)) {
                this.verifyPremiumFlag = true;
                this.loadingState = false;
                this.pollapiflag = false;
                return;
              }
              // await this.getCkycDetails();
              if (this.channel_type == "B2C") {
                this.$router.push('/confirm-payment-diy')
              }
              else {
                this.$router.push('/confirm-payment')
              }
            }
            this.loading2 = false;
            break;
          }
          if (response.data.errors.length > 0) {
            if (response.data.errors[0].errorIdentifier == "INVALID_REQUEST_ID") {
              this.pollapiflag = true;
            }
          }
          await this.sleep(1000);
        } catch (err) {
          console.log('error msg block', err);
          this.loading = false;
        }
      };
      if ((Date.now() - startTime) >= maxPollingTime) {
        this.pollapiflag = false;
        this.loading2 = false;
        this.loading = false;
      }
    },
    async getCkycDetails() {
      try {
        this.loadingMsg = "Fetching CKYC Details";
        this.kycRedirectUrl = "";
        this.msg = [];
        this.isUploadDocRequired = false;
        let panNumber = "";
        let kycdataSession = JSON.parse(sessionStorage.getItem("kycdata"))
        // Get PAN number from sessionStorage
        const userData = sessionStorage.getItem("userData");
        if (userData) {
          const parsedData = JSON.parse(userData);
          panNumber = parsedData?.PANNumber || this.formInfo?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields?.PAN?.input || "";
        }

        // Construct request data
        let reqData = {
          personalInformation: {
            dateOfBirth: this.formInfo?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields?.dateOfBirth?.input || kycdataSession?.dateOfBirth,
            email: "",
            mobileNumber: this.formInfo?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields?.mobileNumber?.input || "",
            zipCode: this.formInfo?.fieldGroups?.proposerDetails?.fieldGroups?.permanentAddressDetails?.fields?.zipCode?.input || "",
            pan: panNumber,
            gender: "male",
          },
          product: {
            insuranceCompanyCode: this.selectedPlan?.insuranceAndProducts?.insuranceCompanyCode || "",
            productId: this.selectedPlan?.insuranceAndProducts?.productCode || "",
          },
          trackInfo: {
            manufacturerQuoteID: this.uniqueQuoteId?.toString() || "",
            manuApplicationNo: "",
            KYCRequestID: "",
          },
          distributor: {
            distributorID: this.distributorID || "",
            agentID: this.getAgentIdFromRmData(this.rmData),
            agentType: this.rmData.RoleId =="4" ? "POSP" : "",
            salesChannel: "online",
            channelType: this.rmData.RoleId !== "1" ? "B2B" : "B2C",
          },
          kycInfo: {
            ReturnURL: "https://www.1silvebullet.tech",
          },
          journey_id: JSON.parse(sessionStorage.getItem("journey_id")) || "",
        };

        let headers = { Authorization: `Bearer ${this.$store.state.token}` };

        console.log("Calling KYC...");
        const response = await this.backendApi("getCkyc", reqData, headers);

        if (!response || !response.data) {
          throw new Error("Invalid response received from KYC API.");
        }

        this.kycResponse = response.data.data || {};
        this.kycStatus = this.kycResponse?.kycInfo?.Status || null;

        // Handle errors in API response
        if (response.data.errors?.length > 0) {
          this.msg.push(
            "Verify that your PAN-Date of Birth combination is correct and try again. If the issue continues, please contact the support staff."
          );
          this.loadingState = false;
          return;
        }

        // Handle different KYC statuses
        if (this.kycStatus === "approved") {
          sessionStorage.setItem("kyc_response", JSON.stringify(this.kycResponse));
        } else if (response.data.data.kycInfo.RedirectURL) {
          await this.getCkycRedirect(response.data.data.kycInfo.RedirectURL);
        } else if (["Pending", "POAIncomplete", "Incomplete"].includes(this.kycStatus)) {
          this.isUploadDocRequired = true;
        } else {
          sessionStorage.removeItem("kyc_response");
          this.kycRedirectUrl = this.kycResponse.kycInfo?.RedirectURL || "";

          if (this.kycRedirectUrl) {
            setTimeout(() => {
              window.open(this.kycRedirectUrl, "_blank").focus();
            }, 2000);
          }
        }
      } catch (error) {
        console.error("Error fetching CKYC details:", error);
        this.loadingState = false;
        this.$router.push({ path: "/error-page", query: { msg: error.message || "An unexpected error occurred." } });
      }
    },
    async getCkycRedirect(redirectUrl) {
      try {
        const reqData = [JSON.parse(sessionStorage.getItem("journey_id")) || ""];
        const headers = {};
        this.loadingState = true;
        this.loadingMsg = "Fetching CKYC Details";
        var isFirstTime = true;
        this.isButton = true;
        while (true) {
          try {
            const response = await this.backendApi('ckycRedirect', reqData, headers, "get");
            this.loadingMsg = "Please complete kyc in new tab or cancel to stop to change the PAN details.";
            if (response.data.errors && response.data.errors.length > 0) {
              if (isFirstTime) {
                isFirstTime = false;
                window.open(redirectUrl, '_blank').focus();
              }
            } else if (response.data.data.manufacturer[0].product[0].applicationStatus.manufacturerAppStatus.toLowerCase() === 'success') {
              sessionStorage.setItem("kyc_response", JSON.stringify(response.data.data));
              this.loadingState = false;
              sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
              if (this.channel_type == "B2C") {
                this.$router.push('/confirm-payment-diy')
              }
              else {
                this.$router.push('/confirm-payment')
              }
              break;
            }
          } catch (error) {
            this.loadingState = false;
            this.errorMessage = "An error occurred while fetching CKYC details. Please try again.";
          }
          await new Promise(resolve => setTimeout(resolve, 45000));
        }
      } catch (error) {
        this.loadingState = false;
        this.errorMessage = "An error occurred while fetching CKYC details. Please try again.";
      }
    },
      activeTabAfterReload(filledDataTab)
      {
        let tabIndex=this.tabsArr.indexOf(filledDataTab)
        for(let i=0;i<=tabIndex;i++)
        {
          let tab=this.tabsArr[i];
          if ($("#proposalId_" + tab).hasClass("show active")) {
            $("#proposalId_" + tab).removeClass("show active");
          }
  
          if ($("#tablink_" + tab).hasClass("disabled")) {
            $("#tablink_" + tab).removeClass("disabled");
            $("#tablinka_" + tab).removeClass("disabled");
          }
          $("#tablink_" + tab).addClass('active');
          $("#tablinka_" + tab).addClass('active');
          $("#tablinka_" + tab).attr("aria-selected", "true");
        }
        $("#proposalId_" + filledDataTab).addClass('show active');
      },
      activeTab(tabToActive) {
        console.log("activeTab Called", tabToActive);
  
        // Scroll Top
        this.scrollToTop();
        let visibilityExp = "";
        if(tabToActive == 'insuredMembers') {
          visibilityExp = this.formInfo["fieldGroups"][tabToActive]['0']["visibility"];
        } else {
          visibilityExp = this.formInfo["fieldGroups"][tabToActive]["visibility"];
        }
     
        let ckk = this.checkVisibility(visibilityExp);
        if (ckk == true) {
          //console.log('this.tabsArr', this.tabsArr)
          this.currentTab = tabToActive;
          sessionStorage.setItem("currentTab", JSON.stringify(this.currentTab));
  
          for (var i = 0; i < this.tabsArr.length; i++) {
            var tab = this.tabsArr[i];
            if ($("#step" + tab + "-tab").hasClass("active")) {
              console.log("inside tab active");
              $("#step" + tab + "-tab").removeClass("active");
              $("#step" + tab + "-tab").attr("aria-selected", "false");
              $("#step" + tab + '-tab').addClass("disabled");
              $("#step" + tab).removeClass("show active");
            }
          }
          if ($("#step" + tabToActive + "-tab").hasClass("disabled")) {
            $("#step" + tabToActive + "-tab").removeClass("disabled");
          }
          $("#step" + tabToActive + "-tab").addClass("active");
          $("#step" + tabToActive).addClass("show active");
          $("#step" + tabToActive + "-tab").attr("aria-selected", "true");
        } else {
          this.activeNextTab(tabToActive);
        }
      },
      goBack() {
        this.currentTab = JSON.parse(sessionStorage.getItem("currentTab"));
        console.log("current tab: ", this.currentTab);
        var tabIndex = this.tabsArr.indexOf(this.currentTab);
        this.activePrevTab(this.currentTab);
      },
      activePrevTab(tabToActive) {
        console.log("active prev tab called", this.tabsArr);
        var tabIndex = this.tabsArr.indexOf(tabToActive);
        if (tabIndex > 0) {
          console.log("inside prev tab true");
          if(tabToActive != 'traceInfo' && tabToActive != 'distributor') {
            let prevTab = this.tabsArr[tabIndex - 1];
            //console.log('uuu: ', this.formInfo['fieldGroups'][prevTab]['visibility']);
            let ckk = this.checkVisibility(
              this.formInfo["fieldGroups"][prevTab]["visibility"]
            );
            if (ckk == true) {
              this.activeTab(prevTab);
            } else {
              this.activePrevTab(prevTab);
            }
          }
        } else {
          this.$router.push("/addon-rider");
        }
      },
    isTabContentActive(val) {
      if (val == "proposerDetails") {
      return "show active";
      } else {
      // return "disabled";
      return "";
      }
    },
    getColSize(valType, ind1, ind2, ind3 = "", value = "") {
      //console.log('get col size info, Val: ', valType, 'Ind1: ', ind1, 'Ind2', ind2, 'Ind3: ', ind3)
      if(value.name === 'rtoCode' && this.$store.state.quoteCategory !== 'New'){
        return "d-none";
      }
      if (ind1 == "healthQuestions") {
        return "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 member-option";
      } else if (ind1 == "nomineeInfo") {
        if (ind2 == "address" || ind3 == "appointeeAddress") {
          return "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-3";
        } else {
          return "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3 column";
        }
      } else if (valType == "boolean") {
        return "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-3";
      } else {
        return "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3";
      }
    },
    getAutoCompleteData() {
      return getIsAutoComplete();
    },
    scrollToTop() {
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      },
      checkVisibility2(value, sectionIndex) {
        //console.log("check Visibility called: ", value);
        // default expression evalutiona added along with visibility
  
        
  
        if (value) {
          if(sectionIndex == 'healthQuestions') {
            let tmpValue = this.getVisitibilityExpIndexZero(value);
            value = tmpValue;
          } 
  
          let obj = this.getFinalObject(value);
          try {
            //console.log('iioioioioioiio: ', eval(obj));
            return eval(obj);
          } catch (err) {
            //console.log("error visibility exp2: ", value);
          }
        } else {
          return true;
        }
      },
    saveProposal(sectionIndex) {  
        this.loadingState = true;
        this.loadingMsg="Saving Proposal..."
  
        // if(this.selectedPlan?.trackInfo?.manufacturerQuoteID) {
        //   this.formInfo.fieldGroups.traceInfo.fields["manufacturerQuoteID"].input = this.selectedPlan?.trackInfo?.manufacturerQuoteID;
        // }
        let kycData = "";
        try {
          const storedData = sessionStorage.getItem("kyc_response");
          kycData = storedData ? JSON.parse(storedData) : "";
        } catch (e) {
          console.error("Failed to parse kyc_response from sessionStorage:", e);
          kycData = "";
        }
        if(this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName!=undefined && !this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName.input){
          if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input) {
            this.proposalJson.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input
          }
          if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input) {
            this.proposalJson.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName.input = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName.input
          }
          if (this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input) {
            this.proposalJson.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input = this.formInfo.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input
          }
        }else{
          if(kycData && kycData.personalInformation){
            this.proposalJson.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input = kycData.personalInformation.firstName
            this.proposalJson.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName.input = kycData.personalInformation.middleName
            this.proposalJson.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input = kycData.personalInformation.lastName
          }
        }
        let propoalData = {
          "journey_id": JSON.parse(sessionStorage.getItem("journey_id")),
          "tag_name" : sectionIndex,
          "proposal_json": this.proposalJson,
        };
        var headers = {
          Authorization: "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
          "Content-Type": "application/json",
        };
        //console.log('qData: ', qData);
        this.backendApi("saveProposal", propoalData, headers)
          .then((response) => {
            this.loadingState = false;
            this.activeNextTab(sectionIndex);
            if (response == 'error') {
              self.apiError = true;
            }
            else if (response && response.data) {
              // let currTab = JSON.parse(sessionStorage.getItem('filledDataTab'))
              // if('fieldGroups' in response.data.data.proposal_json.fieldGroups[currTab] && Object.keys(response.data.data.proposal_json.fieldGroups[currTab].fieldGroups).length != 0){
                // sessionStorage.setItem(currTab, JSON.stringify(response.data.data.proposal_json.fieldGroups[currTab].fieldGroups))
              // }else{
                // sessionStorage.setItem(currTab, JSON.stringify(response.data.data.proposal_json.fieldGroups[currTab].fields))
              // }
            }else if (response.data.errors.length > 0){
              if (response.data.errors[0].errorDisplayMessage != "") {
                for (let i = 0; i < response.data.errors.length; i++) {
                  let ck = 1;
                  this.displayApiErrosOnUI.push(ck + '. ' + stripHtml(response.data.errors[i]["errorDisplayMessage"]));
                  ck++;
                }
              }
            }
          })
          .catch((error) => {
            this.loadingState=false;
            console.log('error msg block dp', error);
            // let msg=['We are facing some issue from backend while saving proposal data ']
  
            //   this.$router.push({ path: '/alert', query: {backUrl:'proposal-page', msg: msg }});
          });
      },
      checkValidation(value, label = "") {
        //console.log('check Validation called: ', value);
        if (value) {
          let obj = this.getFinalObject(value);
          try {
            return eval(obj);
          } catch (err) {
            console.log("check validation error exp 2: ", value);
            return true;
          }
        } else {
          //return false;
        }
      },
      checkValidation2(value, label = "") {
        //console.log('check Validation 2 called: ', value);
        if (value) {
          let obj = this.getFinalObject(value);
          console.log('Validation 2 obj: ', obj);
          try {
            return eval(obj);
          } catch (err) {
            console.log("check validation2 error exp 2: ", obj);
            return true;
          }
        } else {
          //return false;
        }
      },
      checkPattern(value, pattern) {
        try {
          return eval(eval(pattern).test(value));
        } catch {
          console.log("Invalid regular expression: ", pattern);
          return true;
        }
      },
      saveProposalDetails(reqData) {
        this.loadingState = true;
      this.loadingMsg="Saving Proposal..."
        var headers = {
          "quoteId": this.uiQuoteId,
          Authorization: "Basic " + window.btoa(process.env.VUE_APP_DATA_PER_USERNPASS),
          "Content-Type": "application/json",
        };
        this.backendApi("saveProposalDetailsData", reqData, headers)
          .then((response) => {
            this.loadingState = false;
            //console.log('save quote response: ', response);
            if (response == 'error') {
              //self.apiError = true;
            } else if (response && response.data) {
              console.log('proposal details data saved');
            }
          })
          .catch((error) => {
            this.loadingState=false;
            console.log('error msg block proposal details data', error);
          });
      },
      verifyModalClose(){
        this.verifyPremiumFlag=false;
      },
      async continueNewPremium(){
        this.loadingState=true;
        this.verifyPremiumFlag=false;
        this.selectedPlan = this.updatedPlanData;
        sessionStorage.setItem("selected_plan_data", JSON.stringify(this.selectedPlan));

        const isUploadDocRequired = sessionStorage.getItem('isUploadDocRequired') ? JSON.parse(sessionStorage.getItem('isUploadDocRequired')) : false;
        const configData = this.$store.state.configData;
        const isOvd = configData["OVD_KYC"][this.selectedPlan.insuranceAndProducts.insuranceCompanyCode];
        if (shouldSkipGodigitKycOvd(this.selectedPlan)) {
          sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
        } else if (isUploadDocRequired && isOvd && isOvd==="PRE_PROPOSAL"){
          this.$router.push('/upload-ovds')
          return;
        }

        // await this.getCkycDetails();
        if (this.channel_type == "B2C") {
          this.$router.push('/confirm-payment-diy')
        }
        else {
          this.$router.push('/confirm-payment')
        }
      },
      // Custom date handling methods for separate DD/MM/YYYY fields
      handleDateDayChange(event, fieldPath) {
        const day = event.target.value;
        if (day < 1 || day > 31) return;
        
        // Get the current date value
        const currentDate = this.getNestedValue(this.formInfo, fieldPath);
        
        if (!currentDate) {
          // If no date exists, create a new one with only the day
          const today = new Date();
          const month = today.getMonth() + 1;
          const year = today.getFullYear();
          const newDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          this.setNestedValue(this.formInfo, fieldPath, newDate);
        } else {
          // Otherwise, update only the day part
          let dateParts = currentDate.split('-');
          if (dateParts.length === 3) {
            dateParts[2] = String(day).padStart(2, '0');
            this.setNestedValue(this.formInfo, fieldPath, dateParts.join('-'));
          } else {
            // Handle invalid date format by setting a proper date
            const today = new Date();
            const month = today.getMonth() + 1;
            const year = today.getFullYear();
            const newDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            this.setNestedValue(this.formInfo, fieldPath, newDate);
          }
        }
      },
      
      handleDateMonthChange(event, fieldPath) {
        const month = event.target.value;
        if (month < 1 || month > 12) return;
        
        // Get the current date value
        const currentDate = this.getNestedValue(this.formInfo, fieldPath);
        
        if (!currentDate) {
          // If no date exists, create a new one with only the month
          const today = new Date();
          // Default to 1st day of month if none set
          const day = 1;
          const year = today.getFullYear();
          const newDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          this.setNestedValue(this.formInfo, fieldPath, newDate);
        } else {
          // Otherwise, update only the month part
          let dateParts = currentDate.split('-');
          if (dateParts.length === 3) {
            dateParts[1] = String(month).padStart(2, '0');
            this.setNestedValue(this.formInfo, fieldPath, dateParts.join('-'));
          } else {
            // Handle invalid date format by setting a proper date
            const today = new Date();
            const day = this.getNestedValue(this.formInfo, fieldPath + '_day') || 1;
            const year = today.getFullYear();
            const newDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            this.setNestedValue(this.formInfo, fieldPath, newDate);
          }
        }
      },
      
      handleDateYearChange(event, fieldPath) {
        const year = event.target.value;
        if (year < 1900 || year > 2100) return;
        
        // Get the current date value
        const currentDate = this.getNestedValue(this.formInfo, fieldPath);
        
        if (!currentDate) {
          // If no date exists, create a new one with only the year
          const today = new Date();
          // Default to 1st day of current month if none set
          const day = 1;
          const month = today.getMonth() + 1;
          const newDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          this.setNestedValue(this.formInfo, fieldPath, newDate);
        } else {
          // Otherwise, update only the year part
          let dateParts = currentDate.split('-');
          if (dateParts.length === 3) {
            dateParts[0] = year;
            this.setNestedValue(this.formInfo, fieldPath, dateParts.join('-'));
          } else {
            // Handle invalid date format by setting a proper date
            const today = new Date();
            const day = 1;
            const month = today.getMonth() + 1;
            const newDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            this.setNestedValue(this.formInfo, fieldPath, newDate);
          }
        }
      },
      
      // Helper function to get a deeply nested value
      getNestedValue(obj, path) {
        const parts = path.split('.');
        let value = obj;
        
        for (const part of parts) {
          if (value === undefined || value === null) return undefined;
          value = value[part];
        }
        
        return value;
      },
      
      // Helper function to set a deeply nested value
      setNestedValue(obj, path, value) {
        const parts = path.split('.');
        let current = obj;
        
        for (let i = 0; i < parts.length - 1; i++) {
          const part = parts[i];
          if (current[part] === undefined) {
            current[part] = {};
          }
          current = current[part];
        }
        
        current[parts[parts.length - 1]] = value;
      },
      selectMaxDate(data, field) {
        const today = moment();
        if (data.name === 'nomineeInfo' && field.name === 'dateOfBirth') {
          return today.subtract(18, 'years').format('YYYY-MM-DD');
        } else {
          return '9999-12-31';
        
        }
      },
      selectMinDate(data, field){
        if (data.name === 'nomineeInfo' && field.name === 'dateOfBirth') {
          const today = new Date();
          const minDate = new Date(today.getFullYear() - 99, today.getMonth(), today.getDate());
          return minDate.toISOString().split('T')[0];
        }
      },
      setMinDateAssociation(field) {
        const odDate = new Date(this.userData.OdDate); // e.g., '2025-06-18'
        const today = new Date();

        if (field.name === 'autoAssoExpDate') {
          const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
          const odDateOnly = new Date(odDate.getFullYear(), odDate.getMonth(), odDate.getDate());
          const baseDate = odDateOnly > todayOnly ? odDateOnly : todayOnly;
          const nextDay = new Date(baseDate);
          nextDay.setDate(baseDate.getDate() + 2);
          return nextDay.toISOString().split('T')[0];
        }
      },
      dobMaxRange(parent, field){
        const today = moment();
        console.log("All is well", parent, field)
        if((parent.name=='personalDetails' || parent.name=='corporateDetails') && field.name == 'dateOfBirth'){
          return today.subtract(18, 'years').format('YYYY-MM-DD');
        }else if(parent.name=='corporateDetails' && field.name == 'dateOfEstablishment'){
          return today.subtract(1, 'day').format('YYYY-MM-DD');
        }
      },
      calculateAge(dob) {
        const birthDate = new Date(dob); // expects 'YYYY-MM-DD' or valid date string
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
          age--;
        }
        return age;
      },
      
      // Get day, month, year from a date string
      getDateParts(dateString) {
        if (!dateString) return { day: '', month: '', year: '' };
        
        const dateParts = dateString.split('-');
        if (dateParts.length !== 3) return { day: '', month: '', year: '' };
        
        // Make sure we're only returning valid numbers
        const year = dateParts[0] || '';
        const month = dateParts[1] ? parseInt(dateParts[1], 10) : '';
        const day = dateParts[2] ? parseInt(dateParts[2], 10) : '';
        
        return {
          year: year,
          month: month,
          day: day
        };
      },
      
      // Check if a field is a date of birth field that needs the special treatment
      isDateOfBirth(fieldName) {
        // Check all possible names for date of birth fields
        const dobFieldNames = ['dateOfBirth'];
        const name = fieldName ? fieldName.toLowerCase() : '';
        return dobFieldNames.some(dobName => name.includes(dobName));
      }
  },
  computed: {
    isShow() {
      return sessionStorage.getItem('fromDashboard') ? JSON.parse(sessionStorage.getItem('fromDashboard')) : false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/components/process-wizard.scss";
.backtoprevious{
  font-size: 12px;
  color: $main-bg !important;
}
.dark{
  .copy-icon{
    filter: invert(1) !important;
   }

   .floating-input{
    color: $base-dark-text !important;
   }
   .floating-form .floating-select{
    color: $base-dark-text !important;
   }
   .backtoprevious{
    color: $base-dark-text !important;
  }
  .selectrtosvg{
    filter: invert(1);
  }
}

/* Custom styles for registration number fields */
.registration-code-field {
  position: relative;
  
  input {
    background-color: transparent;
    font-weight: 600;
    border-radius: 4px 0 0 4px;
    &:focus {
      border-color: #80bdff;
      outline: 0;
      box-shadow: 0 0 0 0.25rem rgba(0, 123, 255, 0.25);
    }
  }
}

.vehicle-number-field {
  position: relative;
  flex: 1;
  width:100%;
  
  input {
    font-weight: 500;
    border-radius: 0 4px 4px 0;
    &:focus {
      border-color: #80bdff;
      outline: 0;
      box-shadow: 0 0 0 0.25rem rgba(0, 123, 255, 0.25);
    }
  }
}

/* Custom Date Input Component Styles */
.date-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .date-input-field {
    width: 70px;
    font-weight: 500;
    
    &:focus {
      border-color: #80bdff;
      outline: 0;
      box-shadow: 0 0 0 0.25rem rgba(0, 123, 255, 0.25);
    }
  }
  
  .date-separator {
    font-weight: bold;
    margin: 0 2px;
  }
  
  .year-input {
    width: 90px;
  }
}

.dark {
  .data-placeholder{
    color: white;
  }
}
</style>
